import React, { useState, useEffect, useRef, useMemo, useCallback,useContext } from 'react';
import { useSocket } from '../contexts/SocketContext';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, List, ListItem, ListItemText, ListItemIcon, Avatar, TextField, Button, IconButton, Grid,
  Chip, Menu, MenuItem, Tooltip, Accordion, AccordionSummary, AccordionDetails, Dialog, DialogTitle, DialogContent, DialogActions, Drawer, useMediaQuery, Popover,
  useTheme, CircularProgress, Badge, Fab, InputAdornment, Select, Link, FormControl, InputLabel, Checkbox, FormControlLabel, formControlClasses, ListSubheader , Collapse
} from '@mui/material';
import Divider from '@mui/material/Divider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CallIcon from '@mui/icons-material/Call';
import CallMissedIcon from '@mui/icons-material/CallMissed';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import PauseIcon from '@mui/icons-material/Pause';
import ForwardIcon from '@mui/icons-material/Forward';
import SendIcon from '@mui/icons-material/Send';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import PersonAddAlt1RoundedIcon from '@mui/icons-material/PersonAddAlt1Rounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import CreateContactDialog from '../components/CreateContactDialog';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import api, { createServicePayment, uploadDocument, sendDocumentViaWhatsApp, broadcastServiceRequest, acceptServiceRequest, rejectServiceRequest } from '../api';
import CustomAudioPlayer from '../customcomponents/CustomAudioPlayer';
import CustomLocationLoader from '../customcomponents/CustomLocationLoader';
import CustomSnackbar from '../customcomponents/CustomSnackBar';
import CustomVideoPlayer from '../customcomponents/CustomVideoPlayer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage,faVideo,faLocationDot,faUserTie,faHeadphones,faFileLines,faNoteSticky,faPhone, faAdd ,faFilePdf } from '@fortawesome/free-solid-svg-icons'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EventNoteIcon from '@mui/icons-material/EventNote';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import CustomDateAndTimePicker from '../customcomponents/CustomDateAndTimePicker';
import dayjs from 'dayjs';
import { toast } from 'react-hot-toast';
import AlbumRoundedIcon from '@mui/icons-material/AlbumRounded';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import CustomReminderAlert from '../customcomponents/CustomReminderAlert';
import  SearchInput  from '../customcomponents/CustomSearchInput';

import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { API_BASE_URL } from '../constant';
import axios from 'axios';
import { SettingsContext } from '../App';


// Add at the top, after imports
const STATUS_LABELS = {
  1: 'Open',
  2: 'Hold',
  3: 'Closed',
};

const STATUS_COLORS = {
  1: '#28a745', // Open - Green
  2: '#ffc107', // Hold - Yellow/Orange
  3: '#dc3545', // Closed - Red
};

// color blocks chat aswin

// --- AGE BLOCKS (5x, 3 minutes each) ---
const BLOCK_COLORS = {
  green:  '#16a34a', // minute 1 of a block
  yellow: '#f59e0b', // minute 2 of a block
  red:    '#ef4444', // minute 3 of a block
  off:    '#e5e7eb', // disabled/idle
};


    function computeBlockColorsFromTimestamp(timestamp, isRead) {
      if (!timestamp || isRead) return Array(5).fill('off');

      const createdAt = new Date(timestamp).getTime();
      if (isNaN(createdAt)) return Array(5).fill('off');

      const diffMins = Math.floor((Date.now() - createdAt) / 60000);

      const blocks = Array(5).fill('off');

      // Each block covers 3 minutes
      const blockIndex = Math.floor(diffMins / 3);

      const phase = diffMins % 3;

      // 1st rule: paint all previous blocks FULL RED
      for (let i = 0; i < blockIndex && i < blocks.length; i++) {
        blocks[i] = 'red';
      }

      // 2nd rule: paint the current block with cycling color
      if (blockIndex < blocks.length) {
        if (phase === 0) blocks[blockIndex] = 'green';
        else if (phase === 1) blocks[blockIndex] = 'yellow';
        else blocks[blockIndex] = 'red';
      }

      return blocks;
    }

    function AgeBlocks({timestamp , isRead}) {
      const [,setTick] = React.useState(0);
        React.useEffect(()=>{
          if (!timestamp) return;
          setTick(t=>t+1);
          const id = setInterval(()=>{
            setTick(t=>t+1);
          },60_000);

          return()=>clearInterval(id);
        },[timestamp,isRead]);

        const colors = computeBlockColorsFromTimestamp(timestamp,isRead);

        return(
          <Box sx={{display:'inline-flex',gap:'3px',alignItems:'center'}}>
            {colors.map((key,idx)=>(
              <Box key={idx} sx={{width:10,height:6,ml:idx===0?0:0.01,bgcolor:BLOCK_COLORS[key],opacity:key==='off'?0.4:1}}></Box>
            ))}
          </Box>
        );
    }

    // Small label showing elapsed time since timestamp in minutes (up to 59)
    // and in hours (with one decimal) thereafter: e.g. "1min", "45min", "1.5hr", "2hr"
    function AgeLabel({ timestamp }) {
      const [, setTick] = React.useState(0);
      React.useEffect(() => {
        if (!timestamp) return undefined;
        const id = setInterval(() => setTick(t => t + 1), 15_000); // refresh every 15s for near-minute accuracy
        return () => clearInterval(id);
      }, [timestamp]);

      const theme = useTheme();
      const isSmallScreen = useMediaQuery('(max-width:800px)');
      if (!timestamp) return null;
      const t = new Date(timestamp).getTime();
      if (Number.isNaN(t)) return null;
      const diffMs = Date.now() - t;
      const mins = Math.floor(diffMs / 60000);
      const hours = mins / 60;
      const days = Math.floor(hours / 24);
      const weeks = Math.floor(days / 7);
      const years = Math.floor(days / 365);
      if (mins <= 0) return <Typography variant="caption" sx={{ fontSize: isSmallScreen?'0.5rem':'0.65rem', color: '#ef4444', display: 'block' }}>just now</Typography>;
      if (mins < 60) {
        return <Typography variant="caption" sx={{ fontSize: isSmallScreen?'0.5rem':'0.65rem', color: '#ef4444', display: 'block' }}>{mins}min{mins !== 1 ? 's' : ''}</Typography>;
      }
      if (hours < 24) {
        const rounded = Math.round(hours * 10) / 10;
        return (
          <Typography variant="caption"  sx={{ fontSize: isSmallScreen?'0.5rem':'0.65rem', color: '#ef4444', display: 'block' }}>
            {rounded}hour{rounded !== 1 ? 's' : ''}
          </Typography>
        );
      }
      if (days < 7) {
        return (
          <Typography variant="caption"  sx={{ fontSize: isSmallScreen?'0.5rem':'0.65rem', color: '#ef4444', display: 'block' }}>
            {days} day{days !== 1 ? 's' : ''}
          </Typography>
        );
      }
      if (weeks < 52) {
        return (
          <Typography variant="caption"  sx={{ fontSize: isSmallScreen?'0.5rem':'0.65rem', color: '#ef4444', display: 'block' }}>
            {weeks} week{weeks !== 1 ? 's' : ''}
          </Typography>
        );
      }
      return (
        <Typography variant="caption" sx={{ fontSize: isSmallScreen?'0.5rem':'0.65rem', color: '#ef4444', display: 'block' }} >
          {years} year{years !== 1 ? 's' : ''}
        </Typography>
      );
    }

    // newwwwwwwwwwwwwwww
    /**
     * Age from the last customer message UNTIL the next true "forward to user".
     * Disable only after an external/public forward. Internal/agent notes do NOT disable.
     * Returns: { anchorTs: string|number|null, replied: boolean }
    */
    function computeReplyAgingFromTicket(rawTicket) { 
      const msgs = Array.isArray(rawTicket?.lastUserMessage)? rawTicket.lastUserMessage : [];
      // console.log(msgs);
      const ts = (m) => m?.TA_Created_At || m?.createdAt || m?.updatedAt || null;
      
      // Strict customer detector
      const isCustomerMsg = (m) => {
        if (m?.TA_is_publish === false) return false;         // ignore non-published
        const type = (m?.TA_Thread_Type || '').toLowerCase();
        const role = (m?.senderRole || '').toLowerCase();
        const message = (m?.TA_Thread_Message || '').toLowerCase();
        return (
          type === 'user' || type === 'customer' || type === 'inbound' ||
          role === 'customer' || role === 'user' || message === 'Call'
        );
      };

      const lastThreadMsg = Array.isArray(rawTicket?.threadLastMessage)
        ? rawTicket.threadLastMessage.at(-1)
        : rawTicket?.threadLastMessage;

      if (lastThreadMsg?.TA_Is_ExpertMessage === true) {
        const expertTs = ts(lastThreadMsg);
        if (expertTs) {
          return {
            anchorTs: expertTs,
            replied: false,
            source: "expert",
          };
        }
      }

      const isCallMessage = (m) => (m?.TA_Thread_Message || '').toLowerCase() === 'call';

      // STRICT forward-to-user detector (external/public only)
      const isForwardToUser = (m) => {
        // Must be published AND explicitly external
        const published = m?.TA_is_publish !== false;
        if (!published) return false;
        
        // Any of these fields often indicate external delivery channel
        const channel = (m?.TA_Delivery_Channel ||  m?.deliveryChannel || '').toLowerCase();
        const target  = (m?.TA_Forwarded_To || m?.TA_Target || m?.target || '').toLowerCase();
        const subtype = (m?.TA_Thread_Subtype || m?.TA_Message_Subtype || '').toLowerCase();
        const action  = (m?.TA_Action || m?.TA_Message_Type || '').toLowerCase();
        const toUser  = (m?.toUser || m?.toCustomer || m?.isToEndUser);
        
        // Prefer explicit booleans/flags when present
        const flags = [
          m?.TA_is_forward, m?.TA_Is_Forward, m?.isForwarded, m?.forwarded,
          m?.isExternal, m?.TA_is_external
        ].filter((v) => v !== undefined);

        // Heuristics: require external channel/target OR explicit forward flag
        const clearlyExternal =
        channel === 'external' || channel === 'customer' || channel === 'enduser' ||
          target === 'user' || target === 'customer' || target === 'enduser' ||
          !!toUser || flags.includes(true);
          
        // Also allow explicit “forward” subtype/action as a hint, but only if external too
        const mentionsForward = subtype.includes('forward') || action.includes('forward');
        
        // Final rule: must be external; and either flagged forward OR mentions forward
        return clearlyExternal && (flags.includes(true) || mentionsForward);
      };
      
      // Ensure chronological (oldest→newest)
      const sorted = [...msgs].sort((a, b) => new Date(ts(a) || 0) - new Date(ts(b) ||  0));

      let pendingCustomerAt = null;     // last customer msg waiting to be forwarded
      let lastPairedCustomerAt = null;  // most recent customer that DID get forwarded
      let lastPairedForwardAt  = null;
      
      for (const m of sorted) {
        const t = ts(m);
        if (!t) continue;

        // if (isCustomerMsg(m)) {
        //   pendingCustomerAt = t;        // start/replace the window at this customer msg
        //   continue;
        // }
        // if (!m?.TA_is_publish) {
        //   pendingCustomerAt = t;        // start/replace the window at this customer msg
        //   continue;
        // }
        // if (m?.TA_Thread_Type.toLowerCase() === 'user' || m?.TA_Thread_Type.toLowerCase() === 'customer') {
        //   pendingCustomerAt = t;        // start/replace the window at this customer msg
        //   continue;
        // }

        if ( m?.TA_is_publish !== false && ['user', 'customer'].includes((m?.TA_Thread_Type || '').toLowerCase())) {
          pendingCustomerAt = t;
          continue;
        }

        if(m?.TA_Template_Type === 3 || m?.TA_Template_Type === 4){
          pendingCustomerAt = t;
          continue;
        }

        if (isCallMessage(m)) { 
          pendingCustomerAt = t;
          continue;
        }

        if (isForwardToUser(m)) {

          // If this is a system/template message, do NOT restart the timer
          if (m?.TA_Thread_Type && m.TA_Thread_Type.toLowerCase() === 'system') {
            continue; // skip pairing, timer does not restart
          }

          if ( pendingCustomerAt && isCallMessage(pendingCustomerAt) && m?.TA_Thread_Type?.toLowerCase() === 'comment') { pendingCustomerAt = null;
          return { anchorTs: null, replied: true };
          }

          // pair only if there is a prior customer message
          if (pendingCustomerAt && new Date(t) > new Date(pendingCustomerAt)) {
            lastPairedCustomerAt = pendingCustomerAt;
            lastPairedForwardAt = t;
            pendingCustomerAt = null;    // window closed until another customer msg appears
          }
          continue;
        }

        // ignore all other agent/internal/system notes
      }

      // If there’s an un-forwarded customer message, keep aging from it
      if (pendingCustomerAt) {
        return { anchorTs: pendingCustomerAt, replied: false };
      }

      // If the most recent customer message was forwarded (externally), disable
      if (lastPairedCustomerAt && lastPairedForwardAt) {
        return { anchorTs: lastPairedCustomerAt, replied: true };
      }

      // Nothing relevant to show
      return { anchorTs: null, replied: rawTicket?.systemReplayed };
    }

    // 1️⃣ Identify a call interaction
      const isCallInteraction = (item) => {
        return (
          item?.TA_Thread_Message === "Call" ||
          item?.type === "call"
        );
      };
      // console.log("isCallInteraction",isCallInteraction);

      // 2️⃣ Identify valid follow-up after a call
      const isValidFollowUpAfterCall = (item) => {
        return (
          (item?.comment && item.comment.trim().length > 0) ||
          item?.TA_Thread_Type === "system"
        );
      };

      // 3️⃣ Core rule: should disable Hold / Close?
      const shouldDisableHoldCloseByCall = (interactions = []) => {
        if (!interactions.length) return false;

        let lastCallIndex = -1;

        // Find last call
        for (let i = interactions.length - 1; i >= 0; i--) {
          if (isCallInteraction(interactions[i])) {
            lastCallIndex = i;
            break;
          }
        }

        // No call → do NOT block
        if (lastCallIndex === -1) return false;

        // Check if any valid follow-up exists AFTER the call
        for (let i = lastCallIndex + 1; i < interactions.length; i++) {
          if (isValidFollowUpAfterCall(interactions[i])) {
            return false; // enable buttons
          }
        }

        // Call exists but no follow-up
        return true; // disable buttons
      };



    function Interactions() {
      const isMdDown = useMediaQuery(theme => theme.breakpoints.down('md'));
      const { socket: socketContext, isConnected: isSocketConnected, on } = useSocket();
      const [selectedContact, setSelectedContact] = useState(null);
      const [showChatView, setShowChatView] = useState(false); // Controls chat view on mobile
      const [showContactDetails, setShowContactDetails] = useState(false);
      const [chatHistory, setChatHistory] = useState([]);
      const [anchorEl, setAnchorEl] = useState(null);
      const [anchorPaymentEl, setAnchorPaymentEl] = useState(null);
      const [commentDialogOpen, setCommentDialogOpen] = useState(false);
      const [commentValue, setCommentValue] = useState('');
      const [commentMissedCallIdx, setCommentMissedCallIdx] = useState(null);
      // const [expandedAccordion, setExpandedAccordion] = useState(false);
      const [collapsedComment, setCollapsedComment] = useState(null);
      const [inputMessage, setInputMessage] = useState('');
      const [msgMenuAnchorEl, setMsgMenuAnchorEl] = useState(null);
      const [msgMenuIdx, setMsgMenuIdx] = useState(null);
      const [assignDialogOpen, setAssignDialogOpen] = useState(false);
      const [assignUserValue, setAssignUserValue] = useState([]);
      const [assignMsgIdx, setAssignMsgIdx] = useState(null);
      const [drawerOpen, setDrawerOpen] = useState(false);  
      const {settings,userRole}=useContext(SettingsContext);
      
      const [reminderTicketStatus, setReminderTicketStatus] = useState(1);
      
      const [services, setServices] = useState([]);
      const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);

      const navigate = useNavigate();

      // for creating error in editing the contact in interaction section
      const [createPincodeError, setCreatePincodeError] = useState('');
      const [createErrors, setCreateErrors] = useState({ pincode: '' });



      //  For the expansion of the message when click on read more in the center chat area
      const [isExpanded, setIsExpanded] = useState(false);
      const loggedInUser=localStorage.getItem('userId');
      // // // console.log(loggedInUser);

      const toggleMessage = () => {
        setIsExpanded(!isExpanded);
      };

      const canAccess = (keyName) => {
        const item = settings?.find(s => s.keyName === keyName);
        return item?.roles?.some(r => r.roleName === userRole);
      };
      const hidePaymentButton=canAccess("payment_button");
      const hideBroadCastButton=canAccess("broadcast_button");
      const AddressLine = canAccess("intearaction_address_line");
      const canAddressLine = canAccess("address_line");
      const canHidePro = canAccess("hide_interactions_pro");
      const canHideTicket = canAccess("hide_interactions_tickets");

      // for check whether the last interaction is call and whether it is commented or not
      const lastInteraction = chatHistory[chatHistory.length - 1];

      const isLastInteractionCall = lastInteraction && (lastInteraction?.message === "Call" && lastInteraction?.comment === undefined);
      
      // Disable ticket status buttons only if:
      // 1. The setting is enabled (canHideTicket is true) AND
      // 2. The last interaction is a call with no comment (isLastInteractionCall is true)
      const disableTicketStatusButtons = canHideTicket && isLastInteractionCall;                 

      // console.log("chatHistory",chatHistory);
      // console.log("lastInteraction",lastInteraction);
      // console.log("isLastInteractionCall",isLastInteractionCall);

      // For the expansion of the message when click on read more in the user chat area
      const [isExpandedUser, setIsExpandedUser] = useState(false);
      
      const TicketStatusIndicationBtn = useCallback(()=>{ 
        if(!reminderTicketStatus) return null;
        if(reminderTicketStatus){ // hold ticket only
          return (
            <Tooltip title="Change Ticket Status">
              <IconButton
                disableRipple
                onClick={openStatusMenu}
                size="small"
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  background: STATUS_COLORS[reminderTicketStatus],
                }}
                aria-controls={statusMenuOpen ? 'ticket-status-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={statusMenuOpen ? 'true' : undefined}
              >
                <AlbumRoundedIcon  />
              </IconButton>
            </Tooltip>
          )
        }
      },[reminderTicketStatus]);


      // media display in the user chat area
      const hasMediaAttachment = (item) => {
        // attachments populated objects
        if (item?.attachments?.length > 0) return true;

        // metadata based (whatsapp)
        const t = item?.metadata?.data?.message?.message_content_type;
        return ["Image", "Video", "Audio", "Document", "PDF"].includes(t);
      };


      const renderAttachmentMessage = (item, isSystemMessage) => {
      const att = item?.attachments?.[0];

      const url =
        att?.TD_File_Path ||
        att?.TD_Document_URL ||
        item?.metadata?.data?.message?.media_url;

      const type =
        att?.TD_Document_Type ||
        item?.metadata?.data?.message?.message_content_type;

      if (!url || !type) return null;

      if (type === "Image") {
        return (
          <img
            src={url}
            alt="Image"
            style={{
              maxWidth: "100%",
              maxHeight: 400,
              borderRadius: 8,
              marginBottom: 8,
              display: "block",
            }}
          />
        );
      }

      if (type === "Video") {
        return (
          <video
            src={url}
            controls
            style={{ width: "100%", maxHeight: 320, borderRadius: 8 }}
          />
        );
      }

      if (type === "Audio") {
        return <audio src={url} controls style={{ width: "100%" }} />;
      }

      if (type === "Document" || type === "PDF") {
        return (
          <Box
            component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "inline-block",
              px: 2,
              py: 1,
              width: "100%",
              background: isSystemMessage ? "#6c5ce7" : "#3b82f6",
              color: "#fff",
              fontWeight: 600,
              borderRadius: 2,
              textAlign: "center",
              textDecoration: "none",
            }}
          >
            Open Document
          </Box>
        );
      }

      return null;
    };




      
      // Search states
      const [searchQuery, setSearchQuery] = useState('');
      const [isSearchExpanded, setIsSearchExpanded] = useState(false);
      const searchInputRef = useRef(null);

      // For Search POP over
      const handleOpenSearch = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleCloseSearch = () => {
        setAnchorEl(null);
        setSearchQuery("");
      };

      useEffect(() => {
        if (anchorEl) {
          setTimeout(() => {
            searchInputRef.current?.focus();
          }, 10);
        }
        else if (isSearchExpanded) {
          // Small delay ensures width transition completes
          setTimeout(() => {
            searchInputRef.current?.focus();
          }, 150);
        }
      }, [anchorEl,isSearchExpanded]);


      //  backend search states
      const [searchResults, setSearchResults] = useState([]);
      const [searchLoading, setSearchLoading] = useState(false);
      const [searchError, setSearchError] = useState(null);

      useEffect(() => {
      // If search is cleared, go back to normal paginated tickets
      if (!searchQuery || searchQuery.trim() === '') {
        setSearchResults([]);
        setSearchError(null);
        return;
      }

      let isActive = true;
      const controller = new AbortController();

      const runSearch = async () => {
        try {
          setSearchLoading(true);
          setSearchError(null);

          // Assumes your base path is /api/tickets
          const res = await api.get('/tickets/search', {
            params: { query: searchQuery },      // hits GET /api/tickets/search?query=...
            signal: controller.signal,
          });

          if (!isActive) return;

          if (res.data?.success && Array.isArray(res.data.data)) {
            // searchTicket currently returns raw Mongoose docs with TA_Patient_Ref, etc. :contentReference[oaicite:4]{index=4}
            setSearchResults(res.data.data);
          } else {
            setSearchResults([]);
          }
        } catch (err) {
          if (!isActive || err.name === 'CanceledError') return;
          console.error('Ticket search failed:', err);
          setSearchError('Failed to search tickets');
          setSearchResults([]);
        } finally {
          if (isActive) setSearchLoading(false);
        }
      };

      // simple debounce so we don’t fire for every keystroke
      const debounceId = setTimeout(runSearch, 400);

      return () => {
        isActive = false;
        controller.abort();
        clearTimeout(debounceId);
      };
    }, [searchQuery]);


    // for the filter of all , unread and delayed response from the backend
    const [messageFilter, setMessageFilter] = useState('all'); // 'all' or 'unread'

    useEffect(() => {
      // For "all" → show socket tickets
      if (messageFilter === 'all') {
        setSearchResults([]);
        return;
      }

      let isActive = true;
      const controller = new AbortController();

      const runFilter = async () => {
        try {
          setSearchLoading(true);
          setSearchError(null);

          const res = await api.get('/tickets/filter', {
            params: { filter: messageFilter },
            signal: controller.signal,
          });

          if (!isActive) return;

          if (res.data?.success && Array.isArray(res.data.data)) {
            setSearchResults(res.data.data);
          } else {
            setSearchResults([]);
          }
        } catch (err) {
          if (!isActive || err.name === 'CanceledError') return;
          setSearchError('Failed to filter tickets');
          setSearchResults([]);
        } finally {
          if (isActive) setSearchLoading(false);
        }
      };

      runFilter();

      return () => {
        isActive = false;
        controller.abort();
      };
    }, [messageFilter]);


      
      // Tooltip states
      const [tooltipOpen, setTooltipOpen] = useState({ close: false, hold: false, forward: false });
      
      // Last seen visibility state
      const [showLastSeen, setShowLastSeen] = useState(false);
      
      // New states for scroll management
      const [showScrollToBottom, setShowScrollToBottom] = useState(false);
      const [unreadCount, setUnreadCount] = useState(0);
      const [isNearBottom, setIsNearBottom] = useState(true);
      
      // PRO list state
      const [proList, setProList] = useState([]);
      const [proListLoading, setProListLoading] = useState(false);
      
      // PRO view states
      const [showProView, setShowProView] = useState(false);
      const [proPatients, setProPatients] = useState({});
      const [expandedPro, setExpandedPro] = useState(null);
      const [proAnchorEl, setProAnchorEl] = useState(null);
      const [selectedProId, setSelectedProId] = useState(null); // Track selected PRO ID
      
      // Ticket fetching states
      const [tickets, setTickets] = useState([]);
      const [ticketsLoading, setTicketsLoading] = useState(false);
      const [ticketsError, setTicketsError] = useState(null);
      const theme = useTheme();
      const isSmallScreen = useMediaQuery('(max-width:800px)');
      
      // Pagination states
      const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 15,
        hasNextPage: false,
        hasPrevPage: false
      });
      const [loadingMore, setLoadingMore] = useState(false);
      const [loadingPrev, setLoadingPrev] = useState(false);

      // Ref for the tickets list container
      const ticketsListRef = useRef(null);

      //aswin
      const [unreadMap, setUnreadMap] = useState({});
      const lastSeenPerTicketRef = useRef({});
      //aswin


      const [ticketStatus, setTicketStatus] = useState(1); // 1=open, 2=hold, 3=closed

      // Add state to track last seen message ID
      const [lastSeenMessageId, setLastSeenMessageId] = useState(null);
      const [newMessageIds, setNewMessageIds] = useState([]);

      // At the top of your component:
      const isActionMenuOpen = Boolean(actionMenuAnchorEl);

      // Payment modal state
      const [paymentModalOpen, setPaymentModalOpen] = useState(false);
      const [selectedService, setSelectedService] = useState('');
      const [serviceAmount, setServiceAmount] = useState('');
      const [isCustomAmount, setIsCustomAmount] = useState(false);

      // This is done for document send through interaction page
      // Document upload state
      const [documentModalOpen, setDocumentModalOpen] = useState(false);
      const [documentFile, setDocumentFile] = useState(null);
      const [documentDescription, setDocumentDescription] = useState('');
      const [documentLoading, setDocumentLoading] = useState(false);
      const [sendDocViaWhatsApp, setSendDocViaWhatsApp] = useState(false);
      const [patientDocuments, setPatientDocuments] = useState([]);
      const [documentsLoading, setDocumentsLoading] = useState(false);

      const [filterAnchorEl, setFilterAnchorEl] = useState(null);
      const [customSnackbarOpen, setCustomSnackbarOpen] = useState({ open: false, data: '', severity: 'success' });
      const [openReminderModal, setOpenReminderModal] = useState({ data: '', open: false });

      // Reminders overlay state (shows incoming active reminders)
      const [activeReminder, setActiveReminder] = useState({ open: false, data: null });

      // Reminder tickets fetched from server (ids of tickets with pending reminders)
      const [reminderTicketRef, setReminderTicketRef] = useState([]);

      // Helper to check whether a ticket has an active/pending reminder
      const isReminderActivated = (ticketId) => {
        if (!ticketId) return false;
        try {
          return Array.isArray(reminderTicketRef) && reminderTicketRef.includes(ticketId);
        } catch (e) {
          return false;
        }
      };



      useEffect(() => {
        if (!socketContext || !isSocketConnected) return;
        // handler that saves the incoming reminder payload into state
        const handleActiveReminder = (data) => {
          try {
            setActiveReminder({ open: true, data });
          } catch (err) {
            console.error('Failed to handle active-reminder', err);
          }
        };

        socketContext.on('active-reminder', handleActiveReminder);

        return () => {
          // remove the specific handler
          try {
            socketContext.off('active-reminder', handleActiveReminder);
          } catch (err) {
            // fallback: remove all listeners for the event
            try { socketContext.off('active-reminder'); } catch (e) { }
          }
        };
      }, [socketContext, isSocketConnected]);

      // Auto-dismiss the active reminder after 6 seconds
      useEffect(() => {
        if (!activeReminder.open) return;
        // const id = setTimeout(() => setActiveReminder({ open: false, data: null }), 6000);
        // return () => clearTimeout(id);
      }, [activeReminder.open]);

      const [statusMenuEl, setStatusMenuEl] = React.useState(null);
      const statusMenuOpen = Boolean(statusMenuEl);
      const statusOptions = [1, 2, 3]; // assumes STATUS_LABELS / STATUS_COLORS use 1,2,3

      const openStatusMenu = (e) => setStatusMenuEl(e.currentTarget);
      const closeStatusMenu = () => setStatusMenuEl(null);

      const handleStatusPick = async (status) => {
        setTicketStatus(status);
        setShowProView(false);
        resetTicketsForNewStatus();
        await socketContext.emit('live-chat-ticket', {
          customerId: status,
          page: 1,
          limit: 10,
        });
        closeStatusMenu();
      };

    const handleSnackbarClose = (event, reason) => {

        setCustomSnackbarOpen({ ...customSnackbarOpen, open: false });

    };

    const handleActionMenuOpen = (event) => {
      setActionMenuAnchorEl(event.currentTarget);
    };

    const handleActionMenuClose = () => {
      setActionMenuAnchorEl(null);
    };


      // Drawer states
      const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
      };

      
      // Separate states for User Chat area
      const [showUserChatScrollToBottom, setShowUserChatScrollToBottom] = useState(false);
      const [userChatUnreadCount, setUserChatUnreadCount] = useState(0);
      const [isSystemMessageChatNearBottom, setIsUserChatNearBottom] = useState(true);
      
      // Separate chat history for User Chat area
      const [userChatHistory, setUserChatHistory] = useState([]);
      
      // Chat pagination states
      const [chatPagination, setChatPagination] = useState({
        currentPage: 1,
        totalPages: 0,
        totalCount: 0,
        limit: 8,
        hasNextPage: false,
        hasPrevPage: false,
        isLoadingMore: false
      });
      
      // Track forwarded messages - use localStorage for persistence
      const [forwardedMessages, setForwardedMessages] = useState(() => {
        const saved = localStorage.getItem('forwardedMessages');
        return saved ? new Set(JSON.parse(saved)) : new Set();
      });

      // Socket.IO connection management - using context instead
      // const [socket, setSocket] = useState(null);
      // const [socketConnected, setSocketConnected] = useState(false);
      
      // Chat loading and error states
      const [chatLoading, setChatLoading] = useState(false);
      const [chatError, setChatError] = useState(null);
      
      const open = Boolean(anchorEl);

      //toggle menu
      const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      //close menu
      const handleClose = () => {
        setAnchorEl(null);
        setAnchorPaymentEl(null);
      };

      // Handle back to chat list on mobile
      const handleBackToChatList = () => {
        setShowChatView(false);
        setShowContactDetails(false);
      };
      
      // Handle view user chat on mobile
      const handleViewUserChat = () => {
        if (isMdDown) {
          setShowContactDetails(true);
          setShowChatView(false);
        }
      };


      // Service template modal state
      const [serviceTemplateModalOpen, setServiceTemplateModalOpen] = useState(false);
      const [selectedServiceTemplates, setSelectedServiceTemplates] = useState([]);

      const [serviceSelectOpen, setServiceSelectOpen] = useState(false);


      // Open / close modal
      const handleServiceModalOpen = () => {
        setServiceTemplateModalOpen(true);
      };

      const handleServiceModalClose = () => {
        setServiceTemplateModalOpen(false);
        setSelectedServiceTemplates([]);
      };

      // Handle multi-select, max 3
      const handleServiceTemplateChange = (event) => {
        const value = event.target.value || [];

        if (value.length > 3) {
          toast.error('You can select a maximum of 3 services');
          return;
        } 
        setSelectedServiceTemplates(value);
        if (value.length === 3) {
        setServiceSelectOpen(false);
      }
        };
      //   else {
      //     // keep old selection & warn
      //     toast.error('You can select a maximum of 3 services');
      //   }
      // };

      
      // Call API to send the selected services as a template

      // const handleSendServiceTemplate = async () => {
      //   if (!selectedContact?.id) {
      //     toast.error('No ticket selected');
      //     return;
      //   }

      //   if (!selectedServiceTemplates.length) {
      //     toast.error('Please select at least one service');
      //     return;
      //   }

      //   try {
      //     // Adjust payload/endpoint to what your backend expects
      //     const res = await api.post(`/tickets/${selectedContact.id}/send-template`, {
      //       templateType: 'service',          // <— you can change this key if backend needs something else
      //       serviceRefs: selectedServiceTemplates,
      //     });

      //     if (res.data?.success) {
      //       toast.success(res.data.message || 'Service template sent');
      //       setServiceTemplateModalOpen(false);
      //       setSelectedServiceTemplates([]);
      //     } else {
      //       throw new Error(res.data?.message || 'Failed to send service template');
      //     }
      //   } catch (err) {
      //     console.error('Error sending service template:', err);
      //     toast.error(err.message || 'Failed to send service template');
      //   }
      // };


      const handleSendServiceTemplate = async () => {
        if (!selectedContact?.id) {
          alert('No ticket selected');
          return;
        }

        if (!selectedServiceTemplates.length) {
          alert('Please select at least one service');
          return;
        }

        setStatusLoading(true);   // reuse same loading flag

        try {
          const res = await api.post(`/tickets/${selectedContact.id}/send-template`, {
            templateType: 'service',          // <— you can change this key if backend needs something else
            serviceRefs: selectedServiceTemplates,   // array of service IDs
          });
          // // console.log(res.data)
          if (res.data?.success) {
            alert(res.data.message || 'Service template sent successfully');

            const t = res?.data?.data;
            // console.log(t);          
            if (res?.data?.isReConnectMessage===false) {

              //  const selectedNames = services
              //   .filter(s => selectedServiceTemplates.includes(s._id))
              //   .map(s => s.TA_Service_Name);

              // // Base message from backend or fallback
              // let uiMessage = t?.TA_Thread_Message || 'Service selection requested';

              // // Append selected services if we have any
              // if (selectedNames.length) {
              //   uiMessage += `\nSelected services: ${selectedNames.join(', ')}`;
              // }
              
              setChatHistory(prev => [
                ...prev,
                {
                  id: t?._id?.$oid || t?._id,
                  message: t?.TA_Thread_Message || 'Service selection requested',
                  // message: uiMessage,
                  sender: t?.TA_Thread_Type ? 'system' : 'customer',
                  name: t?.TA_Thread_Type ? 'system' : 'customer',
                  timestamp: t?.TA_Created_At,
                  messageType: 'Text',
                  channelType: 'Thread',
                  messageStatus: 'Delivered',
                  threadId: t?.TA_Thread_Message_ID,
                  ticketRef: t?.TA_Thread_Ticket_Ref?.$oid || t?.TA_Thread_Ticket_Ref,
                  createdBy: t?.TA_Created_By?.$oid || t?.TA_Created_By,
                  isInternal: t?.TA_Is_Internal,
                  isPublish: t?.TA_is_publish,
                  metadata: t?.TA_Metadata,
                  attachments: t?.TA_Attachments,
                },
              ]);
            }else{
              setChatHistory(prev => [
                ...prev,
                {
                  id: t?._id?.$oid || t?._id,
                  message: t?.TA_Thread_Message || res?.data?.reconnectTemplateMessage,
                  // message: uiMessage,
                  sender:  'system' ,
                  name:  'system' ,
                  timestamp: t?.TA_Created_At,
                  messageType: 'Text',
                  channelType: 'Thread',
                  messageStatus: 'Delivered',
                  threadId: t?.TA_Thread_Message_ID,
                  ticketRef: t?.TA_Thread_Ticket_Ref?.$oid || t?.TA_Thread_Ticket_Ref,
                  createdBy: t?.TA_Created_By?.$oid || t?.TA_Created_By,
                  isInternal: t?.TA_Is_Internal,
                  isPublish: t?.TA_is_publish,
                  metadata: t?.TA_Metadata,
                  attachments: t?.TA_Attachments,
                  isReconnectMessage:true
                },
              ]);
            }
            await socketContext.emit('live-chat-ticket', {
              customerId: 1,
              page: 1,
              limit: 15
            });
            
            setServiceTemplateModalOpen(false);
            setSelectedServiceTemplates([]);
          } else {
            throw new Error(res.data?.message || 'Failed to send service template');
          }
        } catch (error) {
          console.error('Error sending service template:', error);
          alert(
            (error?.response?.data && error.response.data.message) ||
            error.message ||
            'An error occurred',
          );
        } finally {
          setStatusLoading(false);
        }
      };






      // Check if we should show the chat list or chat view on mobile
      const showChatList = !isMdDown || (!showChatView && !showContactDetails) || !selectedContact;
      
      
      // Optimized fetch chat messages with useCallback
      // const fetchChatMessages = useCallback(async (customerId) => {
      //   if (!customerId) return;
        
      //   setChatLoading(true);
      //   setChatError(null);
        
      //   try {
      //     // Fetch interactions for this customer from TIMM collection
      //     // const res = await api.get(`/interactions/${customerId}`);
      //     const res = filteredActiveChats.filter((chat) => chat.TA_Patient_Ref === customerId);
          
      //     if (res?.data?.success && res?.data?.data) {
      //       const interactions = Array.isArray(res?.data?.data) ? res?.data?.data : [res?.data?.data];
            
      //       const mappedMessages = interactions.map(interaction => {
      //         const isCustomerMessage = interaction.TIMM_ChatType === 'CustomerMessage';
              
      //         return {
      //           id: interaction._id?.$oid || interaction._id,
      //           message: interaction.TIMM_MessageContent,
      //           sender: isCustomerMessage ? 'customer' : 'system',
      //           name: isCustomerMessage ? (interaction.TIMM_CustomerName || 'Customer') : 'System',
      //           timestamp: interaction.TIMM_ReceivedAtUtc?.$date || interaction.TIMM_CreatedAt?.$date,
      //           messageType: interaction.TIMM_MessageType,
      //           channelType: interaction.TIMM_ChannelType,
      //           messageStatus: interaction.TIMM_MessageStatus,
      //           rowPayload: interaction.TIMM_RowPayload
      //         };
      //       }).sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
            
      //       setChatHistory(mappedMessages);
            
      //       if (mappedMessages.length > 0) {
      //         setLastSeenMessageId(mappedMessages[mappedMessages.length - 1]?.id);
      //       }
      //     } else {
      //       setChatHistory([]);
      //     }
      //   } catch (err) {
      //     console.error('Error fetching chat messages:', err);
      //     setChatError('Failed to load chat messages');
      //     setChatHistory([]);
      //   } finally {
      //     setChatLoading(false);
      //   }
      // }, []);

      const fetchChatMessages = async (res, isLoadMore = false) => {
        console.log('jasheer',{res});
        try {
          // Handle direct array response from Public_User_Threads
          const interactions = Array.isArray(res?.response) ? res?.response : [res?.response];
          const patientData = res?.patientData;
          const paginationData = res?.pagination;

          // const ticketIdForComments =
          // interactions && interactions.length > 0
          //   ? (interactions[0]?.TA_Thread_Ticket_Ref?.$oid || interactions[0]?.TA_Thread_Ticket_Ref)
          //   : null;


          //   let comments = [];
          //   if (ticketIdForComments) {
          //     try {
          //       comments = await fetchComments(ticketIdForComments);
          //     } catch (err) {
          //       console.error('Error fetching comments for ticket', ticketIdForComments, err);
          //     }
          //   }

          
          // Update pagination state
          if (paginationData) {
            setChatPagination({
              currentPage: paginationData.currentPage,
              totalPages: paginationData.totalPages,
              totalCount: paginationData.totalCount,
              limit: paginationData.limit,
              hasNextPage: paginationData.hasNextPage,
              hasPrevPage: paginationData.hasPrevPage,
              isLoadingMore: false
            });
          }
          
          if (interactions && interactions.length > 0) {
            const mappedMessages = interactions.map(interaction => {
              // Map Public_User_Threads format to chat message format
              const isSystemMessage = interaction?.TA_Thread_Type === 'system';
              // // console.log(interactions);
              
              return {
                id: interaction?._id?.$oid || interaction?._id,
                message: interaction?.TA_Thread_Message || 'None',
                sender: isSystemMessage ? 'system' : 'customer',
                reminder: interaction?.TA_Thread_Type  || '',
                name: patientData?.TA_Patient_Name || patientData?.TA_Patient_Mobile_Number || 'Customer',
                timestamp: interaction?.TA_Created_At,
                messageType: 'Text', // Default to Text for thread messages
                channelType: 'Thread',
                messageStatus: 'Delivered',
                threadId: interaction?.TA_Thread_Message_ID,
                ticketRef: interaction?.TA_Thread_Ticket_Ref?.$oid || interaction?.TA_Thread_Ticket_Ref,
                createdBy: interaction?.TA_Created_By?.$oid || interaction?.TA_Created_By,
                isInternal: interaction?.TA_Is_Internal,
                isPublish: interaction?.TA_is_publish,
                metadata: interaction?.TA_Metadata,
                attachments: interaction?.TA_Attachments,
                callStatus: interaction?.TA_Thread_Call_Status,
                assignedUsers: interaction?.TA_Assigned_To,
                templateType: interaction?.TA_Template_Type || null,
                comment:interaction?.TA_Comments,
                commentService: interaction?.TA_CallService || null,
                service:interaction?.TA_CallService
              };
            }).sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

            if (isLoadMore) {
              // Store current scroll position and height before adding old messages
              const chatArea = chatAreaRef.current;
              const userChatArea = userChatAreaRef.current;

              let currentScrollTop = 0;
              let currentScrollHeight = 0;

              if (chatArea) {
                currentScrollTop = chatArea.scrollTop;
                currentScrollHeight = chatArea.scrollHeight;
              }

              // Prepend old messages to existing chat history
              setChatHistory(prev => [...mappedMessages, ...prev]);
              setUserChatHistory(prev => [...mappedMessages, ...prev]);

              // Restore scroll position after state update
              setTimeout(() => {
                if (chatArea) {
                  const newScrollHeight = chatArea.scrollHeight;
                  const heightDifference = newScrollHeight - currentScrollHeight;
                  chatArea.scrollTop = currentScrollTop + heightDifference;
                }
                if (userChatArea) {
                  const newScrollHeight = userChatArea.scrollHeight;
                  const heightDifference = newScrollHeight - currentScrollHeight;
                  userChatArea.scrollTop = currentScrollTop + heightDifference;
                }
              }, 0);
            } else {
              // Replace chat history (initial load or refresh)
              setChatHistory(mappedMessages);
              setUserChatHistory(mappedMessages);
            }
            
            if (mappedMessages.length > 0) {
              setLastSeenMessageId(mappedMessages[mappedMessages.length - 1]?.id);
            }
          } else {
            if (!isLoadMore) {
              setChatHistory([]);
              setUserChatHistory([]);
            }
          }
        } catch (error) {
          console.error('Error fetching chat messages:', error);
          setChatError('Failed to load chat messages');
          setChatHistory([]);
        }
      };


      // Utility function to preserve call timestamp
      const preserveCallTimestamp = useCallback((item) => {
        return item.timestamp || item.originalTimestamp || new Date().toISOString();
      }, []);

      // Utility function to get original call time
      const getOriginalCallTime = useCallback((item) => {
        return item.timestamp || item.originalTimestamp || item.callTime;
      }, []);

      const loadMoreChatMessages = async () => {
        if (!selectedContact?.id || chatPagination.isLoadingMore || !chatPagination.hasNextPage) {
          return;
        }

        setChatPagination(prev => ({ ...prev, isLoadingMore: true }));

        try {
          const nextPage = chatPagination.currentPage + 1;
          await socketContext.emit('live-chat-interactions', {
            customerId: selectedContact.id,
            page: nextPage,
            limit: chatPagination.limit,
            isInitialLoad: false
          });
        } catch (error) {
          console.error('Error loading more messages:', error);
          setChatPagination(prev => ({ ...prev, isLoadingMore: false }));
        }
      };

      const handleLiveChatPickerResponse = (response) => {
        // // // console.log('jashjsahashj',response)
        if (response.success) {
          if (response.pagination) {
            const { currentPage } = response.pagination;
            const currentPagination = pagination;
            
            // If it's the first page or we're loading a different status, replace the tickets
            if (currentPage === 1) {
              setTickets(response.data);
            } else if (currentPage > currentPagination.currentPage) {
              // For next pages, append to existing tickets
              setTickets(prevTickets => {
                // Check if we already have tickets from this page to avoid duplicates
                const existingIds = new Set(prevTickets.map(ticket => ticket._id));
                const newTickets = response.data.filter(ticket => !existingIds.has(ticket._id));
                return [...prevTickets, ...newTickets];
              });
            } else if (currentPage < currentPagination.currentPage) {
              // For previous pages, prepend to existing tickets
              setTickets(prevTickets => {
                // Check if we already have tickets from this page to avoid duplicates
                const existingIds = new Set(prevTickets.map(ticket => ticket._id));
                const newTickets = response.data.filter(ticket => !existingIds.has(ticket._id));
                return [...newTickets, ...prevTickets];
              });
            }
            
            setPagination(response.pagination);
          } else {
            // Fallback for responses without pagination
            setTickets(response.data);
          }
        }
      };

      // Function to reset tickets when status changes
      const resetTicketsForNewStatus = () => {
        setTickets([]);
        setPagination({
          currentPage: 1,
          totalPages: 1,
          totalCount: 0,
          limit: 10,
          hasNextPage: false,
          hasPrevPage: false
        });
      };

      // Function to load next page of tickets
      const loadNextPage = async () => {
        if (loadingMore || !pagination.hasNextPage || !socketContext) return;
        
        setLoadingMore(true);
        try {
          await socketContext.emit('live-chat-ticket', {
            customerId: ticketStatus,
            page: pagination.currentPage + 1,
            limit: pagination.limit
          });
        } catch (error) {
          console.error('Error loading next page:', error);
        } finally {
          setLoadingMore(false);
        }
      };

      // Function to load previous page of tickets
      const loadPreviousPage = async () => {
        if (loadingPrev || !pagination.hasPrevPage || !socketContext) return;
        
        setLoadingPrev(true);
        try {
          await socketContext.emit('live-chat-ticket', {
            customerId: ticketStatus,
            page: pagination.currentPage - 1,
            limit: pagination.limit
          });
        } catch (error) {
          console.error('Error loading previous page:', error);
        } finally {
          setLoadingPrev(false);
        }
      };

      // Handle scroll events for infinite loading
      const handleTicketsScroll = useCallback((event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        const scrollThreshold = 100; // Load more when 100px from bottom
        // // // console.log({ scrollTop, scrollHeight, clientHeight })
        
        // Load next page when scrolling down near bottom
        if (scrollHeight - scrollTop - clientHeight < scrollThreshold && pagination.hasNextPage && !loadingMore) {
          // // // console.log('Loading next page...');
          loadNextPage();
        }
        
        // Load previous page when scrolling up near top
        if (scrollTop < scrollThreshold && pagination.hasPrevPage && !loadingPrev) {
          // // // console.log('Loading previous page...');
          loadPreviousPage();
        }
      }, [pagination.hasNextPage, pagination.hasPrevPage, loadingMore, loadingPrev, loadNextPage, loadPreviousPage]);

      useEffect(() => {
        if (socketContext && isSocketConnected ) {
          // Reset tickets for initial load
          resetTicketsForNewStatus();
          // Initial load with pagination
          socketContext.emit('live-chat-ticket', {
            customerId: 1,
            page: 1,
            limit: 15
          });
        }

        if (!socketContext || !isSocketConnected) return;


        socketContext.on('live-chat-ticket-response', handleLiveChatPickerResponse);

        socketContext.on('servicePaymentSuccess', (data)=>{
          setChatHistory(prev=>[...prev,
            {
              id: '' || reminderData?.paymentId,
              message: data?.paymentMessage || 'None',
              sender: 'system',
              name:  'Customer',
              timestamp: data?.paidAt,
              messageType: 'Text', // Default to Text for thread messages
              channelType: 'Thread',
              messageStatus: 'Delivered',
              metadata: data,
            }
          ]);
        });

        socketContext.on('ticket_updated_calling',(data)=>{
          socketContext.emit('live-chat-ticket', {
            customerId: 1,
            page: 1,
            limit: 15
          });
        })
        
      
        // Cleanup function to remove listeners
        return () => {
          socketContext.off('live-chat-ticket-response', handleLiveChatPickerResponse);
          socketContext.off('ticket_updated');
          socketContext.off('servicePaymentSuccess');
        };
      }, [socketContext, isSocketConnected]);
      
      useEffect(() => {
        if (!socketContext || !isSocketConnected) return;

        const handleLiveChatInteractionsResponse = (response) => {
          // // // console.log({response})
          const arr = Array.isArray(response?.response) ? response.response : [];
          const ticketId = arr[0]?.TA_Thread_Ticket_Ref;
          const isInitialLoad = response?.pagination?.isInitialLoad !== false;

          // If this payload belongs to the open chat, refresh the center pane
          if (selectedContact && ticketId === selectedContact.id) {
            fetchChatMessages(response, !isInitialLoad);
            // Clear unread for the open ticket
            setUnreadMap((prev) => {
              if (!prev || !prev[ticketId]) return prev;
              const next = { ...prev };
              next[ticketId] = 0;
              return next;
            });
            return;
          }

          // Otherwise, if there's a new **customer** message, bump unread for that ticket
          const hasNewCustomerMsg = arr.some(

            (m) =>
              (m?.TA_Thread_Type === 'user' || m?.TA_Thread_Type === 'customer') &&
              m?.TA_is_publish
          );

          if (ticketId && hasNewCustomerMsg) {
            setUnreadMap((prev) => ({ ...prev, [ticketId]: (prev?.[ticketId] || 0) + 1 }));

            // 2) update the ticket so AgeBlocks / AgeLabel recompute immediately
              setTickets((prevTickets) => {
                if (!Array.isArray(prevTickets)) return prevTickets;

                return prevTickets.map((t) => {
                  const id = t?._id?.$oid || t?._id;
                  if (id !== ticketId) return t;

                  // merge new interactions into lastUserMessage (this is what computeReplyAgingFromTicket reads)
                  const existing = Array.isArray(t.lastUserMessage) ? t.lastUserMessage : [];
                  const merged = [...existing];

                  for (const msg of arr) {
                    const msgId = msg?._id || msg?.TA_Thread_Message_ID;
                    if (!msgId) {
                      merged.push(msg);
                      continue;
                    }
                    const already = merged.some(
                      (m) => (m?._id || m?.TA_Thread_Message_ID) === msgId
                    );
                    if (!already) merged.push(msg);
                  }

                  return {
                    ...t,
                    lastUserMessage: merged,
                    // keep updated time fresh – also used elsewhere for sorting
                    TA_Updated_At:
                      arr[0]?.TA_Created_At ||
                      arr[0]?.createdAt ||
                      t.TA_Updated_At,
                  };
                });
              });
            
          }
        };

        try {
          socketContext.on('live-chat-interactions-response', handleLiveChatInteractionsResponse);
        
          // Handle room join/leave confirmations
          socketContext.on('joined-customer-room', (data) => {
            // // // console.log('Joined customer room:', data);
          });
          
          socketContext.on('left-customer-room', (data) => {
            // // // console.log('Left customer room:', data);
          });

          return () => {
            socketContext.off('live-chat-interactions-response', handleLiveChatInteractionsResponse);
            socketContext.off('joined-customer-room');
            socketContext.off('left-customer-room');      
          };
        } catch (error) {
          // // console.log(error)
        }
        
        
      }, [selectedContact]);

      // Update chat history when selectedContact changes
      useEffect(() => {
        if (chatAreaRef.current) {
          chatAreaRef.current.scrollTop = chatAreaRef.current.scrollHeight;
        }
        setChatHistory([]);
        setUnreadCount(0);
        setShowScrollToBottom(false);
        setUserChatUnreadCount(0);
        setShowUserChatScrollToBottom(false);
        setLastSeenMessageId(null);
        setNewMessageIds([]);
        
        // Only switch to chat view on mobile if we're not already in contact details view
        if (isMdDown && selectedContact && !showContactDetails) {
          setShowChatView(true);
        }
      }, [selectedContact, isMdDown, showContactDetails]); // Added showContactDetails to dependencies

      // Ensure User Chat area scrolls to bottom when new messages are added
      useEffect(() => {
        if (userChatAreaRef.current && isSystemMessageChatNearBottom) {
          userChatAreaRef.current.scrollTop = userChatAreaRef.current.scrollHeight;
        }
      }, [userChatHistory, isSystemMessageChatNearBottom]);

      // Debug scroll dimensions
      useEffect(() => {
        if (userChatAreaRef.current) {
          const { scrollHeight, clientHeight } = userChatAreaRef.current;
        }
      }, [userChatHistory]);

      // Auto-scroll to bottom when chatHistory changes (only if user is near bottom)
      useEffect(() => {
        if (chatAreaRef.current && isNearBottom) {
          chatAreaRef.current.scrollTop = chatAreaRef.current.scrollHeight;
        } else if (chatAreaRef.current && !isNearBottom) {
          // If user is not near bottom, increment unread count for new messages
          setUnreadCount(prev => prev + 1);
        }
      }, [chatHistory, isNearBottom]);

      // Handle scroll events to determine if user is near bottom and load more messages when scrolling to top
      const isProgrammaticScrollRef = useRef(false);

      const handleScroll = () => {
        if (isProgrammaticScrollRef.current) return;

        if (chatAreaRef.current) {
          const { scrollTop, scrollHeight, clientHeight } = chatAreaRef.current;
          const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50;
          const shouldShowButton = scrollHeight > clientHeight && !isAtBottom;

          setIsNearBottom(isAtBottom);
          setShowScrollToBottom(shouldShowButton);

          if (isAtBottom) {
            setUnreadCount(0);
          }

          // Load more messages when scrolling to the top
          if (scrollTop < 100 && chatPagination.hasNextPage && !chatPagination.isLoadingMore) {
            loadMoreChatMessages().then(() => {
              // Set flag to ignore the upcoming scroll event
              isProgrammaticScrollRef.current = true;

              // Reset the flag after scroll position is restored
              setTimeout(() => {
                isProgrammaticScrollRef.current = false;
              }, 100);
            });
          }
        }
      };

      // Handle scroll events for User Chat area
      const handleUserChatScroll = () => {
        if (userChatAreaRef.current) {
          const { scrollTop, scrollHeight, clientHeight } = userChatAreaRef.current;
          const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50; // 50px threshold
          const shouldShowButton = scrollHeight > clientHeight && !isAtBottom;
          
          setIsUserChatNearBottom(isAtBottom);
          setShowUserChatScrollToBottom(shouldShowButton);
          
          if (isAtBottom) {
            setUserChatUnreadCount(0);
          }
          
        }
      };

      // Scroll to bottom function
      const scrollToBottom = () => {
        if (chatAreaRef.current) {
          chatAreaRef.current.scrollTo({
            top: chatAreaRef.current.scrollHeight,
            behavior: 'smooth'
          });
          setUnreadCount(0);
          setShowScrollToBottom(false);
        }
      };

      // Scroll to bottom function for User Chat area
      const scrollUserChatToBottom = () => {
        if (userChatAreaRef.current) {
          userChatAreaRef.current.scrollTo({
            top: userChatAreaRef.current.scrollHeight,
            behavior: 'smooth'
          });
          setUserChatUnreadCount(0);
          setShowUserChatScrollToBottom(false);
        }
      };

      // Handle right-click on missed call
      const handleMissedCallContextMenu = (event, idx) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
        setCommentMissedCallIdx(idx);
      };

      const handleMenuOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
      const handleMenuClose = () => {
        setAnchorEl(null);
      };

      const handleAddComment = (idx) => {
        setCommentDialogOpen(true);
        setAnchorEl(null);
        setCommentValue(chatHistory[idx]?.comment || '');
      };

      const handleCommentSave = () => {
        const updated = chatHistory.map((item, idx) =>
          idx === commentMissedCallIdx ? { ...item, comment: commentValue } : item
        );
        setChatHistory(updated);
        setCommentDialogOpen(false);
        setCommentValue('');
      };

      // Add sending state
      const [sending, setSending] = useState(false);

      // Optimized handleSend for TIMM collection
      const handleSend = useCallback(async () => {
        if (!inputMessage.trim() || !selectedContact?.id) return;
        setSending(true);
        try {
          const res = await api.post(`/tickets/${selectedContact.id}/threads/message`, {
            message: inputMessage,
            messageType: 'Text',
            chatType: 'SystemMessage'
          });
          // // // console.log("res",res)
          if (res.data?.success) {
            const newMessage = {
              // id: Date.now(),
              id: res.data?.data?._id,
              message: inputMessage,
              sender: 'system',
              name: 'System',
              timestamp: new Date().toISOString(),
              messageType: 'Text',
              channelType: selectedContact.raw?.customer?.channelType || 'Whatsapp'
            };
            setChatHistory(prev => [...prev, newMessage]);
          }
          setInputMessage('');
          socketContext.emit('live-chat-ticket', {
            customerId: ticketStatus,
            page: 1,
            limit: 15
          });
        } catch (err) {
          alert('Failed to send message');
        } finally {
          setSending(false);
          // await socketContext.emit('live-chat-ticket', 1);
        }
      }, [inputMessage, selectedContact]);

      const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          handleSend();
        }
      }, [handleSend]);

      // Handle right-click on message bubble
      const handleMsgContextMenu = (event, idx) => {
        event.preventDefault();
        setMsgMenuAnchorEl(event.currentTarget);
        setMsgMenuIdx(idx);
      };

      const handleMsgMenuClose = () => {
        setMsgMenuAnchorEl(null);
        setMsgMenuIdx(null);
      };

      const handleAssignUser = (idx) => {
        setAssignDialogOpen(true);
        setMsgMenuAnchorEl(null);
        setAssignUserValue([]);
        setAssignMsgIdx(idx);
      };

      const [assignLoading, setAssignLoading] = useState(false);

      // const handleAssignUserSave = async () => {
      //   if (assignMsgIdx !== null && assignUserValue.length > 0) {
      //     setAssignLoading(true);
      //     const assignedUsers = userList.filter(u => assignUserValue.includes(u.name));
      //     // // // console.log('users',assignedUsers);
      //     const userIds = assignedUsers.map(u => u.id);
      //     const ticketId = selectedContact?.id;
      //     const threadId = chatHistory[assignMsgIdx]?.id;
      //     try {
      //       await api.post(`/tickets/${ticketId}/threads/${threadId}/assign`, {
      //         userIds,
      //       });
      //       await socketContext.emit('live-chat-interactions', {
      //         customerId: selectedContact?.id,
      //         page: 1,
      //         limit: 8,
      //         isInitialLoad: true
      //       });
      //       setAssignDialogOpen(false);
      //       setAssignUserValue([]);
      //       setAssignMsgIdx(null);
      //     } catch (err) {
      //       alert('Failed to assign users');
      //     } finally {
      //       setAssignLoading(false);
      //     }
      //   } else {
      //     setAssignDialogOpen(false);
      //     setAssignUserValue([]);
      //     setAssignMsgIdx(null);
      //   }
      // };

      // Forward message functionality
      
      const handleAssignUserSave = async () => {
      if (assignMsgIdx !== null && assignUserValue.length > 0) {
        setAssignLoading(true);

        // assignUserValue is already an array of user IDs
        const userIds = assignUserValue;
        const assignedUsers = userList.filter(u => userIds.includes(u.id)); // optional, if you need the full objects

        const ticketId = selectedContact?.id;
        const threadId = chatHistory[assignMsgIdx]?.id;

        try {
          await api.post(`/tickets/${ticketId}/threads/${threadId}/assign`, {
            userIds,
          });

          setChatHistory(prev =>
            prev.map((msg, idx) =>
              idx === assignMsgIdx
                ? {
                    ...msg,
                    assignedUsers: assignedUsers, // or userIds depending on your structure
                  }
                : msg
            )
          );

          await socketContext.emit('live-chat-ticket', {
            customerId: ticketStatus,
            page: 1,
            limit: 10
          })
          await socketContext.emit('live-chat-interactions', {
            customerId: selectedContact?.id,
            page: 1,
            limit: 8,
            isInitialLoad: true
          });
          setAssignDialogOpen(false);
          setAssignUserValue([]);
          setAssignMsgIdx(null);
        } catch (err) {
          alert('Failed to assign users');
        } finally {
          setAssignLoading(false);
        }
      } else {
        setAssignDialogOpen(false);
        setAssignUserValue([]);
        setAssignMsgIdx(null);
      }
      };


      // Broadcast to Google Map with selected service + message + patient
      const handleBroadcastToMap = async () => {
        if (!selectedContact?.id) {
          alert('No ticket / patient selected');
          return;
        }

        if (!selectedService) {
          alert('Please select a service before broadcasting');
          return;
        }

        if (assignMsgIdx === null || !chatHistory[assignMsgIdx]) {
          alert('No message found to broadcast');
          return;
        }

        const messageObj = chatHistory[assignMsgIdx];

        // Try to get a meaningful message text
        const messageText =
          messageObj?.message ||
          messageObj?.TA_Thread_Message ||
          'Service selection requested';

        // Try to resolve a patient/customer id that matches your locations data
        const patientId =
          selectedContact?.raw?.TA_Patient_Ref?._id ||
          selectedContact?.raw?.TA_Patient_Ref ||
          selectedContact?.id; // fallback

        const payload = {
          fromAssignBroadcast: true,
          ticketId: selectedContact.id,
          patientId,
          serviceId: selectedService,
          message: messageText,
        };

        try {
          // changed for broadcast message by aswin
          // Send broadcast to service users
          // return console.log()
          await api.post('/broadcast/broadcasts', {
            serviceRef: selectedService,
            broadcastMessage: messageText,
            ticketId:selectedContact.id
          }, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          });

          toast.success('Broadcast message sent to all service users');

          // Also send to map notifications (if needed)
          await api.post('/notifications/broadcast', {
            userIds: [], // empty = broadcast to all; optionally pass specific userIds
            ticketId: payload.ticketId,
            serviceId: payload.serviceId,
            message: `Service requested: ${messageText}`,
            data: { fromAssignBroadcast: true }
          });
        } catch (err) {
          console.error('Failed to request broadcast:', err);
          toast.error('Failed to send broadcast message');
          // continue to maps navigation even if broadcast fails
        }

        // Navigate to /maps with state
        navigate('/maps', { state: payload });

        // Close the dialog
        setAssignDialogOpen(false);
      };


    const handleCloseAssignDialog = () => {
      setAssignDialogOpen(false);
      setAssignUserValue([]);
      setAssignSearchQuery('');
      setSelectedService('');
    };


      
      const [forwardDialogOpen, setForwardDialogOpen] = useState(false);
      const [forwardToValue, setForwardToValue] = useState('');
      const [forwardMessageValue, setForwardMessageValue] = useState('');
      const [pendingForwardedMessage, setPendingForwardedMessage] = useState(null);

      
      const getFileExt = (url = "") => {
        const clean = url.split("?")[0];
        return (clean.split(".").pop() || "").toLowerCase();
      };
      
      const isUrl = (s = "") => /^https?:\/\//i.test(s);
      
      const renderForwardPreview = () => {
        const m = pendingForwardedMessage || {};
        const att = Array.isArray(m.attachments) && m.attachments.length ? m.attachments[0] : null;
        
        // ---------- Resolve media URL ----------
        let fileUrl =
        att?.TD_File_Path ||
        att?.file_url ||
        att?.fileUrl ||
        m?.TA_Thread_Image_URL ||
        (typeof forwardMessageValue === "string" && /^https?:\/\//i.test(forwardMessageValue)
        ? forwardMessageValue
        : null);
        
        if (!fileUrl) return null;
        
        // ---------- Detect file type ----------
        const cleanUrl = fileUrl.split("?")[0];
        const ext = cleanUrl.split(".").pop()?.toLowerCase();
        
        let type = null;
        if (["jpg","jpeg","png","gif","webp"].includes(ext)) type = "Image";
        else if (ext === "pdf") type = "PDF";
        else if (["doc","docx","xls","xlsx","ppt","pptx"].includes(ext)) type = "Document";
        else if (["mp4","mov","mkv","webm"].includes(ext)) type = "Video";
        else if (["mp3","wav","ogg","m4a"].includes(ext)) type = "Audio";
        
        if (!type) return null;
        
        // ---------- Render preview ----------
        if (type === "Image") {
          return (
            <img
            src={fileUrl}
            alt="Preview"
            style={{ width: "100%", maxHeight: 280, objectFit: "contain", borderRadius: 8 }}
            />
          );
        }
        
        if (type === "PDF") {
          return (
            <iframe
            src={fileUrl}
            title="PDF Preview"
            style={{ width: "100%", height: 300, border: "none", borderRadius: 8 }}
            />
          );
        }
        
        if (type === "Document") {
          return (
            <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
            title="Document Preview"
            style={{ width: "100%", height: 300, border: "none", borderRadius: 8 }}
            />
          );
        }
        
        if (type === "Video") {
          return (
            <video
            src={fileUrl}
            controls
            style={{ width: "100%", maxHeight: 280, borderRadius: 8 }}
            />
          );
        }
        
        if (type === "Audio") {
          return (
            <audio
            src={fileUrl}
            controls
            style={{ width: "100%" }}
            />
          );
        }
        
        return null;
      };
      
      const forwardPreviewNode = renderForwardPreview();
      const hasForwardMedia = Boolean(forwardPreviewNode);


      const handleForwardMessage = (idx) => {
        // // // console.log("idx",idx)
        console.log("chatHistory",chatHistory[idx])
        const ticketId = selectedContact?.id;
        const threadId = chatHistory[idx]?.id;
        const originalMessageId = chatHistory[idx]?.id;
        // Make sure ticketId is valid
        if (!ticketId) {
          alert('No ticket selected!');
          return;
        }
        // // // console.log('Forwarding message:', { ticketId, threadId, originalMessageId, message: chatHistory[idx]?.message });
        setForwardDialogOpen(true);
        setForwardMessageValue(chatHistory[idx]?.message || '');
        setForwardToValue('');
        // Store the message data for forwarding
        setPendingForwardedMessage({ ...chatHistory[idx], ticketId, threadId, originalMessageId });
      };

      const handleForwardMessageSave = async (idx) => {
        const ticketId = selectedContact?.id;
        const threadId = pendingForwardedMessage?.id; // Use id which is the actual thread ID (_id from backend)
        const originalMessageId = pendingForwardedMessage?.originalMessageId;

        console.log("pendingForwardedMessage ",pendingForwardedMessage)
        

        if (!ticketId) {
          alert('No ticket selected!');
          return;
        }

        try {
          // Send the forwarded message directly
          const publishApi = await api.post(`/tickets/${ticketId}/threads/${threadId}/publish`, {
            message: forwardMessageValue,
            threadType: 'comment',
            statusFrom: 1,
            statusTo: 1,
            isInternal: false,
            attachments: []
          });
          console.log({publishApi})

          // Add the sent message to chat history
          const sentMessage = {
            // id: Date.now(),
            // sender: 'patient',
            id: threadId,
            type: 'message',
            sender: 'system',
            name: selectedContact?.raw?.patient?.name || 'Patient',
            message: forwardMessageValue,
            timestamp: pendingForwardedMessage?.timestamp || new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            isPending: false,
            ticketId: selectedContact?.id,
            threadId: threadId,
            originalMessageId: originalMessageId,
            isPublish:true
          };
          const updatedUserChat = [...userChatHistory, sentMessage];
          setUserChatHistory(updatedUserChat);
          setPendingForwardedMessage({ ...chatHistory[idx], ticketId : publishApi?.TA_Thread_Ticket_Ref, id : publishApi?._Id, originalMessageId })
          
          // Mark the original message as forwarded
          if (originalMessageId) {
            // // console.log('Marking message as forwarded:', originalMessageId);
            setForwardedMessages(prev => {
              const newSet = new Set([...prev, originalMessageId]);
              // // console.log('Updated forwarded messages:', Array.from(newSet));
              // Save to localStorage
              localStorage.setItem('forwardedMessages', JSON.stringify(Array.from(newSet)));
              return newSet;
            });
          }

          await socketContext.emit('live-chat-ticket', {
            customerId: ticketStatus,
            page: 1,
            limit: 10
          })
          await socketContext.emit('join-customer-room', selectedContact?.id);
          await socketContext.emit('live-chat-interactions', {
            customerId: selectedContact?.id,
            page: 1,
            limit: 8,
            isInitialLoad: true
          });
          
          // // console.log('Forwarded message sent successfully:', forwardMessageValue, 'Original message ID:', originalMessageId);
          setForwardDialogOpen(false);
          setForwardToValue('');
          setForwardMessageValue('');
          setPendingForwardedMessage(null);
        } catch (err) {
          console.error('Error forwarding message:', err);
          alert('Failed to forward message');
        }
      };


      // Optimized filtered chats with useMemo
      // const filteredActiveChats = useMemo(() => {
      //   // // // console.log("tickets",tickets)
      //   if (!tickets) {
      //     return [];
      //   }
      //   return tickets
      //     .filter(ticket => {
      //       // Extract patient information from populated TA_Patient_Ref
      //       const patient = ticket?.TA_Patient_Ref;
      //       const name = patient?.TA_Patient_Name || patient?.TA_Patient_Mobile_Number || '';
      //       const email = patient?.TA_Patient_Email_Address || '';
      //       const phone = patient?.TA_Patient_Mobile_Number || '';
      //       const ticketDescription = ticket?.TA_Ticket_Description || '';
      //       const query = searchQuery?.toLowerCase() || '';
      //       const TA_Ticket_Status = ticket?.TA_Ticket_Status || 1;

      //       // Apply read status filter (0 = unread, 1 = read)
      //       if (messageFilter === 'unread' && ticket.TA_Is_TicketSeen !== 0) {
      //         return false;
      //       }


      //       if (!ticket?.TA_Patient_Ref) {
      //         return false;
      //       }

      //       // Apply search query filter
      //       const matchesSearch = name.toLowerCase().includes(query) ||
      //         email.toLowerCase().includes(query) ||
      //         phone.toString().toLowerCase().includes(query) ||
      //         ticketDescription.toLowerCase().includes(query);

      //       if (!matchesSearch) return false;

      //       // Apply awaiting reply filter
      //       if (messageFilter === 'awaiting-reply') {
      //         // Get the last message from threadLastMessage
      //         const lastMessage = ticket?.threadLastMessage?.[0];

      //         if (!lastMessage) {
      //           // If no messages at all, it needs attention
      //           return true;
      //         }

      //         const lastMessageType = lastMessage?.TA_Thread_Type;
      //         const lastMessageTime = lastMessage?.TA_Created_At || ticket?.TA_Updated_At || ticket?.TA_Created_At;

      //         // Check if last message is from user (needs reply)
      //         const isLastMessageFromUser = lastMessageType === 'user';

      //         // Calculate delay in hours
      //         const delayHours = lastMessageTime ?
      //           (new Date().getTime() - new Date(lastMessageTime).getTime()) / (1000 * 60 * 60) : 0;

      //         // Consider delayed if over 1 hour (you can adjust this threshold)
      //         const isDelayed = delayHours > 0.25;

      //         // Show tickets where:
      //         // 1. Last message is from user (needs reply) AND
      //         // 2. Either ticket is unread OR it's delayed (read but not replied)
      //         const needsReply = isLastMessageFromUser;

      //         if (!needsReply) {
      //           return false;
      //         }

      //         // Store delay hours for sorting
      //         ticket.delayHours = delayHours;
      //       }
      //       return true;
      //     })
      //     .sort((a, b) => {
      //       if (messageFilter === 'awaiting-reply') {
      //         // Sort by delay time in descending order (longest delay first)
      //         const delayA = a.delayHours || 0;
      //         const delayB = b.delayHours || 0;


      //         // For tickets with same delay, sort by last message time (most recent first)
      //         if (Math.abs(delayA - delayB) < 0.25) { // Consider same delay if within 5 minutes
      //           const timeA = new Date(a.TA_Updated_At || a.TA_Created_At).getTime();
      //           const timeB = new Date(b.TA_Updated_At || b.TA_Created_At).getTime();
      //           return timeA - timeB; // Most recent first
      //         }

      //         return delayB - delayA; // Longest delay first
      //       }

      //       if (messageFilter === 'unread') {
      //         // For unread filter, sort unread tickets by updated time (most recent first)
      //         const timeA = new Date(a.TA_Updated_At || a.TA_Created_At).getTime();
      //         const timeB = new Date(b.TA_Updated_At || b.TA_Created_At).getTime();
      //         return timeB - timeA; // Most recent first
      //       }

      //       // Default sort by updated time, then created time (most recent first)
      //       // const timeA = new Date(a.TA_Updated_At || a.TA_Created_At).getTime();
      //       // const timeB = new Date(b.TA_Updated_At || b.TA_Created_At).getTime();

      //       // return timeB - timeA; // Most recent first
      //     })
      //     .map(ticket => {
      //       // Enhance ticket with formatted last message
      //       const lastMessage = ticket?.threadLastMessage?.[0]?.TA_Thread_Message;
      //       let displayMessage = 'No messages yet';
            

      //       if (lastMessage) {
      //         const messageContentType = ticket?.threadLastMessage[0]?.TA_Metadata?.data?.message?.message_content_type;
      //         const messageText = lastMessage;
      //         // // console.log(ticket);
      //         if(lastMessage=='Call'){
      //           displayMessage= (<> <FontAwesomeIcon icon={faPhone} /> Call </>);
      //         }
      //         else if (messageContentType === 'InteractiveButtonReply') {
      //           try {
      //             const messageStr = ticket?.threadLastMessage[0]?.TA_Metadata?.data?.message?.message;              
      //             const parsed = JSON.parse(messageStr || '{}');          
      //             const title = parsed?.button_reply?.title || parsed?.list_reply?.title || 'Unknown Action';
      //             displayMessage = title; 
      //           } catch (error) {
      //             console.error('Failed to parse message:', error);
      //             displayMessage = 'Unknown Action';
      //           }
      //         }
      //         else{
      //           switch (messageContentType) {
      //             case 'Text':
      //               displayMessage = messageText || 'Text message';
      //               break;
      //             case 'Image':
      //               displayMessage = (<> <FontAwesomeIcon icon={faImage} /> Image </>);
      //               break;
      //             case 'Video':
      //               displayMessage = (<><FontAwesomeIcon icon={faVideo} /> Video</>);
      //               break;
      //             case 'Audio':
      //               displayMessage = (<> <FontAwesomeIcon icon={faHeadphones} style={{ color: "#74C0FC", }} /> Audio</>);
      //               break;
      //             case 'Document':
      //               displayMessage = (<> <FontAwesomeIcon icon={faFileLines} style={{ color: "#74C0FC", }} /> Document</>);
      //               break;
      //             case 'Location':
      //               displayMessage = (<><FontAwesomeIcon icon={faLocationDot} style={{ color: "#f02828", }} /> Location</>);
      //               break;
      //             case 'Contact':
      //               displayMessage = (<><FontAwesomeIcon icon={faUserTie} style={{ color: "#568ff0", }} /> Contact</>);
      //               break;
      //             case 'Sticker':
      //               displayMessage = (<> <FontAwesomeIcon icon={faNoteSticky} style={{ color: "#74C0FC", }} /></>);
      //               break;
      //             case 'Call' :
      //               displayMessage = (<> <FontAwesomeIcon icon={faPhone} style={{ color: "#74C0FC", }} /> Call</>);
      //               break;
      //             case 'InteractiveButtonReply' :
      //               displayMessage = (<> <FontAwesomeIcon icon={faPhone} style={{ color: "#74C0FC", }} /> Reply</>);
      //               break;
      //             default:
      //               displayMessage = messageText || 'Message';
      //               break;
      //           }
      //         }

      //         // Truncate long text messages
      //         if (messageContentType === 'Text' && displayMessage.length > 50) {
      //           displayMessage = displayMessage.substring(0, 50) + '...';
      //         }
      //       }

      //       return {
      //         ...ticket,
      //         displayLastMessage: displayMessage
      //       };
      //     });
      // }, [tickets, searchQuery, messageFilter]);

      const getFileExtFromUrl = (url = "") => {
        try {
          const cleanUrl = url.split("?")[0];
          return cleanUrl.split(".").pop().toLowerCase();
        } catch {
          return "";
        }
      };

      const detectSystemFileType = (lastMessage) => {
        const url =
          lastMessage?.TA_Thread_Image_URL ||
          lastMessage?.TA_Thread_Message ||
          "";

        if (!url.startsWith("http")) return null;

        const ext = getFileExtFromUrl(url);

        if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "Image";
        if (ext === "pdf") return "PDF";
        if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext))
          return "Document";
        if (["mp4", "mov", "mkv", "webm"].includes(ext)) return "Video";
        if (["mp3", "wav", "ogg", "m4a"].includes(ext)) return "Audio";

        return "File";
      };


      
    // Optimized filtered chats with useMemo
      
    const filteredActiveChats = useMemo(() => {
      // When there is text in search box, use backend results (all tickets).
      const baseTickets = searchQuery?.trim().length>0
        ? searchResults           // full search across DB
        :messageFilter === 'all'
        ? tickets                // paginated live-chat-ticket data
        :searchResults;

      if (!baseTickets) {
        return [];
      }

      return baseTickets
        .filter(ticket => {
          const patient = ticket?.TA_Patient_Ref;
          const name = patient?.TA_Patient_Name || patient?.TA_Patient_Mobile_Number || '';
          const email = patient?.TA_Patient_Email_Address || '';
          const phone = patient?.TA_Patient_Mobile_Number || '';
          const ticketDescription = ticket?.TA_Ticket_Description || '';
          const query = (searchQuery || '').toLowerCase();
          const TA_Ticket_Status = ticket?.TA_Ticket_Status || 1;

          // unread filter
          if (messageFilter === 'unread') {
            const seen = ticket.TA_Is_TicketSeen;
            const isUnread =
              seen === 0 ||
              seen === "0" ||
              seen === false ||
              seen === null ||
              seen === undefined;

            if (!isUnread) return false;
          } 

          if (!ticket?.TA_Patient_Ref) {
            return false;
          }


          // search filter (now against ALL matching tickets from DB)
          const matchesSearch =
            name.toLowerCase().includes(query) ||
            email.toLowerCase().includes(query) ||
            phone.toString().toLowerCase().includes(query) ||
            ticketDescription.toLowerCase().includes(query);

          if (!matchesSearch) return false;
          // existing "awaiting-reply" logic kept as-is
                if (messageFilter === 'awaiting-reply') {
                  const lastMessage = ticket?.threadLastMessage?.[0];

            if (!lastMessage) {
                    return true;
                  }
          const lastMessageType = lastMessage?.TA_Thread_Type;
                  const lastMessageTime =
                    lastMessage?.TA_Created_At ||
                    ticket?.TA_Updated_At ||
                    ticket?.TA_Created_At;
          const isLastMessageFromUser = lastMessageType === 'user';
                  const delayHours = lastMessageTime
                    ? (new Date().getTime() - new Date(lastMessageTime).getTime()) /
                      (1000 * 60 * 60)
                    : 0;
          const isDelayed = delayHours > 0.25;
                  const needsReply = isLastMessageFromUser;
          if (!needsReply) {
                    return false;
                  }
          ticket.delayHours = delayHours;
                }
          return true;
              })
              .sort((a, b) => {
                  if (messageFilter === 'awaiting-reply') {
                    // Sort by delay time in descending order (longest delay first)
                    const delayA = a.delayHours || 0;
                    const delayB = b.delayHours || 0;


                    // For tickets with same delay, sort by last message time (most recent first)
                    if (Math.abs(delayA - delayB) < 0.25) { // Consider same delay if within 5 minutes
                      const timeA = new Date(a.TA_Updated_At || a.TA_Created_At).getTime();
                      const timeB = new Date(b.TA_Updated_At || b.TA_Created_At).getTime();
                      return timeA - timeB; // Most recent first
                    }
            return delayB - delayA; // Longest delay first
                  }
          if (messageFilter === 'unread') {
                    // For unread filter, sort unread tickets by updated time (most recent first)
                    const timeA = new Date(a.TA_Updated_At || a.TA_Created_At).getTime();
                    const timeB = new Date(b.TA_Updated_At || b.TA_Created_At).getTime();
                    return timeB - timeA; // Most recent first
                  }
          // Default sort by updated time, then created time (most recent first)
                  // const timeA = new Date(a.TA_Updated_At || a.TA_Created_At).getTime();
                  // const timeB = new Date(b.TA_Updated_At || b.TA_Created_At).getTime();
          // return timeB - timeA; // Most recent first
                })
                .map(ticket => {
                  // Enhance ticket with formatted last message
                  const lastMessage = ticket?.threadLastMessage?.[0]?.TA_Thread_Message;
                  let displayMessage = 'No messages yet';


                  if (lastMessage) {
                    // const messageContentType = ticket?.threadLastMessage[0]?.TA_Metadata?.data?.message?.message_content_type;
                    const lastMsgObj = ticket?.threadLastMessage?.[0];

                    let messageContentType =
                      lastMsgObj?.TA_Metadata?.data?.message?.message_content_type;

                    //  NEW: detect system-uploaded files
                    if (!messageContentType && lastMsgObj?.TA_Thread_Type === "system") {
                      messageContentType = detectSystemFileType(lastMsgObj);
                    }
                    const messageText = lastMessage;
                    // console.log('ticket', ticket);
                    if(lastMessage=='Call'){
                      displayMessage= (<> <FontAwesomeIcon icon={faPhone} /> Call </>);
                    }
                    else if (messageContentType === 'InteractiveButtonReply') {
                      try {
                        const messageStr = ticket?.threadLastMessage[0]?.TA_Metadata?.data?.message?.message;              
                        const parsed = JSON.parse(messageStr || '{}');          
                        const title = parsed?.button_reply?.title || parsed?.list_reply?.title || 'Unknown Action';
                        displayMessage = title; 
                      } catch (error) {
                        console.error('Failed to parse message:', error);
                        displayMessage = 'Unknown Action';
                      }
                    }
                    else{
                      switch (messageContentType) {
                        case 'Text':
                          displayMessage = messageText || 'Text message';
                          break;
                        case 'Image':
                          displayMessage = (<> <FontAwesomeIcon icon={faImage} /> Image </>);
                          break;
                        case 'Video':
                          displayMessage = (<><FontAwesomeIcon icon={faVideo} /> Video</>);
                          break;
                        case 'Audio':
                          displayMessage = (<> <FontAwesomeIcon icon={faHeadphones} style={{ color: "#74C0FC", }} /> Audio</>);
                          break;
                        case 'Document':
                          displayMessage = (<> <FontAwesomeIcon icon={faFileLines} style={{ color: "#74C0FC", }} /> Document</>);
                          break;
                        case 'Location':
                          displayMessage = (<><FontAwesomeIcon icon={faLocationDot} style={{ color: "#f02828", }} /> Location</>);
                          break;
                        case 'Contact':
                          displayMessage = (<><FontAwesomeIcon icon={faUserTie} style={{ color: "#568ff0", }} /> Contact</>);
                          break;
                        case 'Sticker':
                          displayMessage = (<> <FontAwesomeIcon icon={faNoteSticky} style={{ color: "#74C0FC", }} /></>);
                          break;
                        case 'Call' :
                          displayMessage = (<> <FontAwesomeIcon icon={faPhone} style={{ color: "#74C0FC", }} /> Call</>);
                          break;
                        case 'InteractiveButtonReply' :
                          displayMessage = (<> <FontAwesomeIcon icon={faPhone} style={{ color: "#74C0FC", }} /> Reply</>);
                          break;
                        default:
                          displayMessage = messageText || 'Message';
                          break;
                      }
                    }

                    // Truncate long text messages
                    if (messageContentType === 'Text' && displayMessage.length > 50) {
                      displayMessage = displayMessage.substring(0, 50) + '...';
                    }
                  }

                return {
                  ...ticket,
                  displayLastMessage: displayMessage,
                };
              });
    }, [tickets, searchResults, searchQuery, messageFilter]);


      // aswin start
      useEffect(() => {
      if (!Array.isArray(filteredActiveChats)) return;
      setUnreadMap((prev) => {
        const next = { ...prev };
        filteredActiveChats.forEach((t) => {
          // If backend says not seen, ensure at least 1 to draw attention
          if (t?.TA_Is_TicketSeen === 0 && !next[t._id]) {
            next[t._id] = next[t._id] || 1;
          }
        });
        return next;
      });
    }, [filteredActiveChats]);

      // aswin end


      const [profileModalOpen, setProfileModalOpen] = useState(false);
      const [addContactModalOpen, setAddContactModalOpen] = useState(false);
      const [addContactInitialValues, setAddContactInitialValues] = useState({});

      const handleAddToContact = () => {
        setAddContactInitialValues({
          name: selectedContact?.name || '',
          phone: '', // Add phone if available
          email: '', // Add email if available
        });
        setAddContactModalOpen(true);
      };

      const handleSaveContact = (contact) => {
        setAddContactModalOpen(false);
        alert('Contact saved: ' + JSON.stringify(contact));
      };

      const fileInputRef = useRef();
      const handleImportClick = () => {
        fileInputRef.current && fileInputRef.current.click();
      };
      
      const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        // Check if we should upload as document (only one file) or just add to chat
        if (files.length === 1 && selectedContact?.id) {
          const file = files[0];
          // Show document upload modal
          setDocumentFile(file);
          setDocumentModalOpen(true);
          e.target.value = '';
          return;
        }

        // Original behavior: add files to chat as preview
        const newMessages = files.map(file => {
          const isImage = file.type.startsWith('image/');
          const url = URL.createObjectURL(file);
          return {
            id: Date.now() + Math.random(),
            type: 'file',
            sender: 'user',
            name: 'You',
            file,
            fileUrl: url,
            fileName: file.name,
            fileType: file.type,
            isImage,
            timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
          };
        });
        setChatHistory(prev => [...prev, ...newMessages]);
        e.target.value = '';
      };

      // Handle document upload with optional WhatsApp sending
      const handleUploadDocument = async () => {
        if (!documentFile || !selectedContact?.id) {
          toast.error('Please select a file and a contact');
          return;
        }

        setDocumentLoading(true);
        try {
          const result = await uploadDocument(
            documentFile,
            selectedContact.raw?.TA_Patient_Ref?._id || selectedContact.raw?.TA_Patient_Ref,
            selectedContact.id,
            null,
            documentDescription,
            sendDocViaWhatsApp
          );

          if (result.success) {
            toast.success(
              sendDocViaWhatsApp 
                ? 'Document uploaded and sent via WhatsApp!' 
                : 'Document uploaded successfully!'
            );

            console.log('Document upload result:', result);
            
            // Add document to chat history
            setChatHistory(prev => [...prev, {
              id: result?.threadId,
              type: 'document',
              sender: 'system',
              name: 'Document',
              message: result?.publicUrl || '',
              fileName: documentFile.name,
              fileType: documentFile.type,
              timestamp: new Date().toISOString(),
              documentId: result.data._id,
              whatsappSent: result.whatsappSent,
              attachments:[result?.attachmentDetails]
            }]);

            // Close modal and reset
            setDocumentModalOpen(false);
            setDocumentFile(null);
            setDocumentDescription('');
            setSendDocViaWhatsApp(false);

            // Refresh documents list if WhatsApp was sent
            if (sendDocViaWhatsApp && result.whatsappSent) {
              toast.info('Document sent to WhatsApp!');
            }
          } else {
            toast.error(result.message || 'Failed to upload document');
          }
        } catch (error) {
          console.error('Error uploading document:', error);
          toast.error(error.message || 'Failed to upload document');
        } finally {
          setDocumentLoading(false);
        }
      };

      const [userList, setUserList] = useState([]);

      useEffect(() => {
        const fetchUsers = async () => {
          try {
            const res = await api.get('/users');
            if (res.data && res.data.success && Array.isArray(res.data.data)) {
              setUserList(res.data.data.map(user => ({
                id: user.id || user._id,
                name: user.name || user.TA_User_Name || user.email,
                avatar: (user.name || user.TA_User_Name || user.email || 'U')[0].toUpperCase(),
                roleId: user.roleId,
              })));
            }
          } catch (err) {
            setUserList([]);
          }
        };
        fetchUsers();
      }, []);

      // for roles
      const [roles, setRoles] = useState([]);

      useEffect(() => {
      const fetchRoles = async () => {
        try {
          const res = await api.get('/roles');
          if (res.data && res.data.success && Array.isArray(res.data.data)) {
            setRoles(res.data.data); // roles with TA_Role_Service_Ref
          } else {
            setRoles([]);
          }
        } catch (err) {
          console.error('Failed to fetch roles', err);
          setRoles([]);
        }
      };

      fetchRoles();
    }, []);




      // Add ticketStatus state for selected ticket
      const [selectedTicketStatus, setSelectedTicketStatus] = useState(null);

      // Update selectedTicketStatus when selectedContact changes
      useEffect(() => {
        if (selectedContact?.raw?.request?.status) {
          setSelectedTicketStatus(selectedContact.raw.request.status);
        } else {
          setSelectedTicketStatus(null);
        }
      }, [selectedContact]);

      // Confirmation dialog state
      const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
      const [pendingStatus, setPendingStatus] = useState(null);
      const [pendingActionLabel, setPendingActionLabel] = useState('');
      const [statusLoading, setStatusLoading] = useState(false);
      const [pendingTemplateAction, setPendingTemplateAction] = useState(null);

      // Handler for template actions
      const handleTemplateAction = (type) => {
        if (!selectedContact?.id) {
          alert('No ticket selected');
          return;
        }
        setPendingTemplateAction({ type });
        setPendingActionLabel(type === 'main-menu' ? 'send Main Menu template' : 'send Feedback template');
        setConfirmDialogOpen(true);
      };

      // Handler for status update (close, hold, open) - now opens dialog
      const handleStatusUpdate = (status) => {
        let actionLabel = status === 3 ? 'close' : status === 2 ? 'hold' : 'open';
        setPendingStatus(status);
        setPendingTemplateAction(null);
        setPendingActionLabel(actionLabel);
        setConfirmDialogOpen(true);
        setTicketStatus(2)
      };

      // Function to update ticket status
      const updateTicketStatus = async (ticketId, status) => {
        try {
          const response = await api.put(`/tickets/${ticketId}/status`, { status });
          if (response.data?.success) {
            // Update the local state if needed
            resetTicketsForNewStatus(); // Reset tickets when status changes
            await socketContext.emit('live-chat-ticket', {
              customerId: status,
              page: 1,
              limit: 10
            })
            await socketContext.emit('join-customer-room', selectedContact?.id);
            await socketContext.emit('live-chat-interactions', {
              customerId: selectedContact?.id,
              page: 1,
              limit: 8,
              isInitialLoad: true
            });
            setSelectedContact({
              ...selectedContact,
              ticketStatus: status
            });

            setTicketStatus(status);

            return true;
          }
          throw new Error(response.data?.message || 'Failed to update ticket status');
        } catch (error) {
          console.error('Error updating ticket status:', error);
          throw error;
        }
      };

      // Handler for confirming status update
      const handleConfirmStatusUpdate = async () => {
        if (pendingStatus === null && !pendingTemplateAction) return;
        
        setStatusLoading(true);
        // return // // console.log("pendingStatus",pendingStatus,"pendingTemplateAction",pendingTemplateAction) ;
        try {
          if (pendingTemplateAction) {
            const { type } = pendingTemplateAction;
            if (type === 'main-menu') {
              const res = await api.post(`/tickets/${selectedContact.id}/send-template`, {
                templateType: 'main-menu'
              });
              // // // console.log("res",res.data.data)
              if (res.data?.success) {
                alert(res.data.message || 'Main menu template sent successfully');
                setChatHistory(prev => [
                  ...prev,
                  // { id: Date.now(), message: paymentMessage, sender: 'system', name: 'System', timestamp: new Date().toISOString() }
                  {
                    id: res?.data?.data?._id?.$oid || res?.data?.data?._id,
                    message: res?.data?.data?.TA_Thread_Message || 'Service selection requested',
                    sender: res?.data?.data?.TA_Thread_Type ? 'system' : 'customer',
                    name: res?.data?.data?.TA_Thread_Type ? 'system' : 'customer',
                    timestamp: res?.data?.data?.TA_Created_At,
                    messageType: 'Text', // Default to Text for thread messages
                    channelType: 'Thread',
                    messageStatus: 'Delivered',
                    threadId: res?.data?.data?.TA_Thread_Message_ID,
                    ticketRef: res?.data?.data?.TA_Thread_Ticket_Ref?.$oid || res?.data?.data?.TA_Thread_Ticket_Ref,
                    createdBy: res?.data?.data?.TA_Created_By?.$oid || res?.data?.data?.TA_Created_By,
                    isInternal: res?.data?.data?.TA_Is_Internal,
                    isPublish: res?.data?.data?.TA_is_publish,
                    metadata: res?.data?.data?.TA_Metadata,
                    attachments: res?.data?.data?.TA_Attachments
                  }
                ]);
              } else {
                throw new Error(res.data?.message || 'Failed to send template');
              }
            } else if (type === 'feedback') {
              const res = await api.post(`/tickets/${selectedContact.id}/feedback`);
              if (res.data?.success) {
                alert(res.data.message || 'Feedback template sent successfully');
              } else {
                throw new Error(res.data?.message || 'Failed to send feedback');
              }
            }
            setPendingTemplateAction(null);
          } else {
            await updateTicketStatus(selectedContact.id, pendingStatus);
            // Update the selected contact's status
            if (selectedContact) {
              setSelectedContact(prev => ({
                ...prev,
                status: pendingStatus
              }));
            }
          }
          setConfirmDialogOpen(false);
          setPendingStatus(null);
          setPendingActionLabel('');
        } catch (error) {
          console.error('Error:', error);
          alert(error.message || 'An error occurred');
        } finally {
          setStatusLoading(false);
        }
      };

      // Add state for address book contacts and edit dialog
      const [addressBookContacts, setAddressBookContacts] = useState([]);
      const [editContactDialogOpen, setEditContactDialogOpen] = useState(false);
      const [editingContact, setEditingContact] = useState(null);
      const [confirmDialog, setConfirmDialog] = useState({
        open: false,
        title: '',
        content: '',
        onConfirm: null,
        onCancel: null
      });
      const [editContactData, setEditContactData] = useState({ name: '', phone: '', email: '', pro: '', id: '' });
      const [addressData, setAddressData] = useState([]);
      const [editContactLoading, setEditContactLoading] = useState(false);
      const [editContactError, setEditContactError] = useState(null);

      // Fetch address book contacts on mount
      useEffect(() => {
        const fetchContacts = async () => {
          try {
            const res = await api.get('/patients');
            // // // console.log("res",res.data)
            if (res.data && res.data.success && Array.isArray(res.data.data)) {
              setAddressBookContacts(res.data.data.map((item) => ({
                id: item._id,
                name: item.TA_Patient_Name || '-',
                phone: item.TA_Patient_Mobile_Number || '-',
                email: item.TA_Patient_Email_Address || '-',
                pro: item.TA_PRO_Ref || '',
                pincode: item.TA_Patient_PinCode || '',
                landMark: item.TA_Patient_LandMark || '', 
              })));
            } else {
              setAddressBookContacts([]);
            }
          } catch (err) {
            setAddressBookContacts([]);
          }
        };
        fetchContacts();
      }, []);

      useEffect(() => {
          if (!localStorage.getItem('token')) return;
          
          const fetchReminders = async () => {
            try {
              const response = await api.get('/reminder/getReminderData', {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              });
              if(response?.status == 200){
              let data = []
              response?.data?.reminderData?.map((item)=>{
                  if(!item?.TRM_IsActivated && item?.TRM_Ticket_Ref == selectedContact?.id){
                    data.push(item?.TRM_Ticket_Ref)
                  }
                })
                setReminderTicketRef(data);
              }
            } catch (error) {
              console.error('Error fetching reminders:', error);
            }
          };
          
          fetchReminders();
        }, [selectedContact]);

      // Handler for avatar click
      const handleAvatarClick = () => {
        // Try to match by phone or email
        const contact = addressBookContacts.find(c =>
          (selectedContact?.raw?.TA_Patient_Ref?.TA_Patient_Mobile_Number && c.phone === selectedContact.raw?.TA_Patient_Ref.TA_Patient_Mobile_Number) ||
          (selectedContact?.raw?.TA_Patient_Ref?.TA_Patient_Email_Address && c.email === selectedContact.raw?.TA_Patient_Ref.TA_Patient_Email_Address)
        ) || selectedContact;
        if (contact) {
          setEditContactData({ ...contact });
          setEditContactDialogOpen(true);
        } else {
          // fallback to create new contact as before
          setAddContactInitialValues({
            name: selectedContact?.name || '',
            phone: selectedContact?.raw?.TA_Patient_Ref?.TA_Patient_Mobile_Number || '',
            emsil: selectedContact?.raw?.TA_Patient_Ref?.TA_Patient_Email_Address || '',
          });
          setAddContactModalOpen(true);
        }
      };

      // Handler for updating contact
      const handleUpdateContact = async () => {
        if (!editContactData.id) return;
        setEditContactLoading(true);
        setEditContactError(null);
        try {
          const payload = {
            TA_Patient_Name: editContactData.name,
            TA_Patient_Mobile_Number: editContactData.phone,
            TA_Patient_Email_Address: editContactData.email,
            TA_PRO_Ref: editContactData.pro,
            TA_Patient_AddresLine_Array:addressData,
            TA_Patient_LandMark : editContactData.landMark
          };
          // // console.log(payload)
          // // // console.log('Updating contact with payload:', payload);
          // // // console.log('API endpoint:', `/patients/${editContactData.id}`);
          const res = await api.put(`/patients/${editContactData.id}`, payload);
          if (res.data && res.data.success) {
            setEditContactDialogOpen(false);
            //window.location.reload();   // Refresh page to reflect changes
            // Optionally, refresh address book contacts
            const updatedContacts = addressBookContacts.map(c =>
              c.id === editContactData.id ? { ...c, ...editContactData } : c
            );
            setAddressBookContacts(updatedContacts);
            // Update selectedContact so Contact Details tab reflects changes
            if (selectedContact) {
              const selectedPro = proList.find(pro => pro._id === editContactData.pro);
              setSelectedContact({
                ...selectedContact,
                name: editContactData.name,
                raw: {
                  ...selectedContact.raw,
                  patient: {
                    ...selectedContact.raw.patient,
                    mobile: editContactData.phone,
                    email: editContactData.email,
                    pro: editContactData.pro,
                    proName: selectedPro?.name || '',
                  }
                }
              });
              await socketContext.emit('live-chat-ticket', {
                customerId: 1,
                page: 1,
                limit: 15
              });
            }
          } else {
            // // console.log('Update failed - response:', res.data);
            setEditContactError('Failed to update contact');
          }
        } catch (err) {
          console.error('Update contact error:', err);
          console.error('Error response:', err.response?.data);
          setEditContactError('Failed to update contact');
        } finally {
          setEditContactLoading(false);
        }
      };

      // Fetch PRO list
      useEffect(() => {
        const fetchProList = async () => {
          setProListLoading(true);
          try {
            const res = await api.get('/pro-masters');
            if (res.data && res.data.success && Array.isArray(res.data.data)) {
              setProList(res.data.data);
            } else {
              setProList([]);
            }
          } catch (err) {
            console.error('Failed to fetch PRO list:', err);
            setProList([]);
          } finally {
            setProListLoading(false);
          }
        };

        fetchProList();
      }, []);

      // Fetch patients for a specific PRO
      const fetchPatientsForPro = async (proId) => {
        // Always update the expandedPro state first to ensure we're working with the correct PRO
        setExpandedPro(proId);

        // If we already have the patients for this PRO, just update the tickets
        if (proPatients[proId]) {
          setTickets(proPatients[proId]);
          setTicketsError(null);
          return;
        }

        try {
          const res = await api.get('/tickets', {
            params: {
              status: 1,
              page: 1,
              limit: 20,
              pro: proId
            }
          });

          let mappedPatients = [];

          if (res.data?.data) {
            mappedPatients = await Promise.all(res.data.data.map(async ticket => {
              let lastMessage = 'No messages yet';

              try {
                // Fetch the last message for this ticket
                const messagesRes = await api.get(`/tickets/${ticket._id}/messages`);
                if (messagesRes.data?.success && messagesRes.data.data?.messages && messagesRes.data.data.messages.length > 0) {
                  const messages = messagesRes.data.data.messages;
                  // Sort messages by timestamp to get the most recent one
                  const sortedMessages = [...messages].sort((a, b) => {
                    const timeA = new Date(a.updatedAt || a.createdAt || 0);
                    const timeB = new Date(b.updatedAt || b.createdAt || 0);
                    return timeB - timeA; // Most recent first
                  });
                  const lastMsg = sortedMessages[0]; // Get the most recent message
                  lastMessage = lastMsg.message || lastMsg.TA_Thread_Message || 'No message content';

                  // Truncate long messages for display in chat list
                  if (lastMessage.length > 50) {
                    lastMessage = lastMessage.substring(0, 50) + '...';
                  }
                }
              } catch (err) {
                console.error('Error fetching last message for ticket:', ticket._id, err);
                // Fallback to mobile number if message fetch fails
                lastMessage = ticket.patient?.mobile || ticket.patient?.phone || 'No mobile number';
              }

              return {
                id: ticket._id,
                name: ticket.patient?.name || ticket.patient?.mobile || ticket.patient?.phone || 'Unknown',
                lastMessage: lastMessage,
                time: ticket.request?.updatedAt ? new Date(ticket.request.updatedAt).toLocaleDateString('en-GB') : '',
                avatar: (ticket.patient?.name || 'T')[0].toUpperCase(),
                raw: ticket,
              };
            }));
          }

          // Always update the proPatients state with the fetched patients (even if empty)
          setProPatients(prev => ({
            ...prev,
            [proId]: mappedPatients
          }));

          // Always update the tickets list when a PRO is selected, even if empty
          setTickets(mappedPatients);
          setTicketsError(null);

          // Reset selected contact when switching PROs
          setSelectedContact(null);

        } catch (err) {
          console.error('Failed to fetch patients for PRO:', err);
          // Set empty array for this PRO in case of error
          setProPatients(prev => ({
            ...prev,
            [proId]: []
          }));
          // Set empty tickets and show error
          setTickets([]);
          setTicketsError('Failed to load patients');
        }
      };

      // Handle PRO accordion expansion
      useEffect(() => {
        if (expandedPro) {
          fetchPatientsForPro(expandedPro);
        }
      }, [expandedPro]);

      const handleEscape = (e) => {
        if (e.key === 'Escape') {
          setSelectedContact(null);
          setUserChatHistory([]);
          setChatPagination({
          currentPage: 1,
          totalPages: 0,
          totalCount: 0,
          limit: 8,
          hasNextPage: false,
          hasPrevPage: false,
          isLoadingMore: false
        });
        }
      };

      // Escape key press use effect
      useEffect(() => {
        window.addEventListener('keydown', handleEscape);
        return () => window.removeEventListener('keydown', handleEscape);
      }, []);

      // Fetch interactions when selectedContact changes
      // useEffect(() => {
      //   if (!selectedContact?.id) {
      //     setUserChatHistory([]);
      //     fetchChatMessages(null);
      //     return;
      //   }

      //   // Fetch chat messages for the selected customer
      //   fetchChatMessages(selectedContact.id);
      // }, [selectedContact, fetchChatMessages]);

      const chatAreaRef = useRef(null);
      const userChatAreaRef = useRef(null);

      // Add a function to refetch user chat messages
      const [refreshingUserChat, setRefreshingUserChat] = useState(false); // <-- add loading state
      const refreshUserChat = async () => {
        if (!selectedContact?.id) {
          setUserChatHistory([]);
          return;
        }
        setRefreshingUserChat(true);
        try {
          // Call the new API to create a patient thread from Interakt
          const res = await api.post(`/tickets/${selectedContact.id}/patient-thread`);
          // Only show alert if there is a real error (not just no data)
          if (res.data && res.data.success === false && res.data.message && res.data.message.toLowerCase().indexOf('not found') === -1) {
            alert(res.data.message);
          }
          // If no data or not found, do nothing (no alert)
        } catch (err) {
          // No alert needed for errors
        } finally {
          setRefreshingUserChat(false);
          // Always refresh the user chat after attempting
          const currentUserId = localStorage.getItem('userId');
          api.get(`/tickets/${selectedContact.id}/published-messages`, { params: { page: 1, limit: 50 } })
            .then(res => {
              if (res.data && res.data.success && Array.isArray(res.data.data)) {
                // Ensure chronological order (oldest to newest)
                const messagesChrono = [...res.data.data].reverse();
                const mapped = messagesChrono.map(msg => {
                  const isCurrentUser = (msg.TA_Created_By?._id === currentUserId) || (msg.TA_Created_By === currentUserId);

                  // Better sender name handling for forwarded messages
                  let senderName = 'System';
                  if (isCurrentUser) {
                    senderName = 'You';
                  } else if (msg.TA_Thread_Type === 'system' || msg.TA_Is_Internal) {
                    senderName = 'System';
                  } else {
                    // For patient messages (including forwarded), always show patient name
                    senderName = selectedContact?.name || 'Patient';
                  }

                  return {
                    id: msg._id,
                    message: msg.TA_Thread_Message,
                    sender: isCurrentUser ? 'user' : senderName,
                    name: isCurrentUser ? 'You' : senderName,
                    timestamp: msg.TA_Created_At ? new Date(msg.TA_Created_At).toISOString() : '',
                    isInternal: msg.TA_Is_Internal,
                    attachments: msg.TA_Attachments,
                    callStatus: msg.TA_Call_Status,
                    metaData: msg?.TA_Metadata || {}
                  };
                });
                setUserChatHistory(mapped);
              } else {
                setUserChatHistory([]);
              }
            })
            .catch(() => setUserChatHistory([]));
        }
      };

      // Mark all as seen when user scrolls to bottom or on manual action
      const markAllAsSeen = () => {
        if (chatHistory.length > 0) {
          setLastSeenMessageId(chatHistory[chatHistory.length - 1].id);
          setNewMessageIds([]);
        }
      };


      // To captitalize the PRO Name
      const capitalizeFirstLetter = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
      };

      // Call comment functionality states
      const [callCommentDialogOpen, setCallCommentDialogOpen] = useState(false);
      const [callCommentValue, setCallCommentValue] = useState('');
      const [callCommentIdx, setCallCommentIdx] = useState(null);
      const [callCommentLoading, setCallCommentLoading] = useState(false);
      const [callCommentThreadId, setCallCommentThreadId] = useState(null);

      const [callCommentService,setCallCommentService] = useState('');

      // Optimized fetch comments with useCallback
      const fetchComments = useCallback(async (customerId) => {
        try {
          const res = await api.get(`/interactions/${customerId}/comments`);
          if (res.data?.success && Array.isArray(res.data.data)) {
            return res.data.data;
          }
          return [];
        } catch (err) {
          console.error('Error fetching comments:', err);
          // try {
          //   const storedComments = localStorage.getItem(`comments_${customerId}`);
          //   return storedComments ? JSON.parse(storedComments) : [];
          // } catch (localErr) {
          //   console.error('Error reading comments from localStorage:', localErr);
          // }
          return [];
        }
      }, []);

      // Optimized merge comments with messages using useCallback
      const mergeCommentsWithMessages = useCallback((messages, comments) => {
        return messages.map(msg => {
          const comment = comments.find(c => c.threadId === msg.id);
          return {
            ...msg,
            comment: comment?.message || msg.comment || null,
            commentThreadId: comment?._id || msg.commentThreadId || null,
            commentTimestamp: comment?.createdAt || msg.commentTimestamp || null,
            commentService: comment?.serviceRef || comment?.service || msg.commentService || null,
          };
        });
      }, []);

      // Removed unused utility functions for call timestamps

      // Call comment handlers for preselecting and opening dialog
      const handleCallCommentClick = (idx) => {
        const callItem = chatHistory[idx];
        setCallCommentIdx(idx);
        setCallCommentValue(callItem?.comment || '');
        setCallCommentThreadId(callItem?.commentThreadId || callItem?.id || null);
        setCallCommentService(callItem?.commentService || '');
        setCallCommentDialogOpen(true);
      };


    // The logic for the saving the call comments along with the services
      const handleCallCommentSave = async () => {
        if (!selectedContact?.id || callCommentIdx === null) return;
        if (!callCommentValue.trim()) {
          alert('Please enter a comment before saving.');
          return;
        }

        setCallCommentLoading(true);
        try {
          const callMessageId = chatHistory[callCommentIdx]?.id;

          const payload = {
            message: callCommentValue,
            threadId: callCommentThreadId || callMessageId,
            isInternal: true,
            attachments: [],
            service:callCommentService || undefined
          };

          const res = await api.post(`/tickets/${selectedContact.id}/ta-comment`, payload, {
            headers: { 'Content-Type': 'application/json' }
          });
          
          if (res.data && res.data.success) {
            const updated = chatHistory.map((item, idx) => {
              if (idx === callCommentIdx) {
                if (item.callStatus != null) {
                  const updatedItem = { ...item };
                  updatedItem.comment = callCommentValue;
                  updatedItem.commentThreadId = res.data.data?._id || callCommentThreadId;
                  updatedItem.commentTimestamp = new Date().toISOString();
                  updatedItem.originalCallTime = item.originalCallTime;
                  updatedItem.callTime = item.callTime;
                  updatedItem.commentService = callCommentService || null;
                  return updatedItem;
                } else {
                  return preserveCallTimestamp({
                    ...item,
                    comment: callCommentValue,
                    commentThreadId: res.data.data?._id || callCommentThreadId,
                    commentTimestamp: new Date().toISOString(),
                    commentService: callCommentService || null,
                  });
                }
              }
              return item;
            });

            setChatHistory(updated);
            setCallCommentDialogOpen(false);
            setCallCommentValue('');
            setCallCommentIdx(null);
            setCallCommentThreadId(null);
            setCallCommentService('');
          } else {
            throw new Error(res.data?.message || 'Failed to save comment');
          }
        } catch (err) {
          console.error('Error saving call comment:', err);
          let errorMessage = 'Failed to save comment';
          if (err.response?.data?.message) {
            errorMessage += ': ' + err.response.data.message;
          } else if (err.message) {
            errorMessage += ': ' + err.message;
          }
          alert(errorMessage);
        } finally {
          setCallCommentLoading(false);
        }
      };

      // logic for the cancelling the call comments
      const handleCallCommentCancel = () => {
        setCallCommentDialogOpen(false);
        setCallCommentLoading(false);
        setCallCommentValue('');
        setCallCommentIdx(null);
        setCallCommentThreadId(null);
        setCallCommentService('');
      };

      const handleCallCommentKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          handleCallCommentSave();
        }
      };

      const getService=async()=>{
        try{
          const res=await api.get('/services');
          // // // console.log(res.data.data);
          
            if (res.data?.data) {
            setServices(res.data.data); // save array to state
          }
        }
        catch(err){
          console.error('Error fetching services:', err);
        }
      }


      useEffect(()=>{
        getService()
      },[])

      useEffect(() => {
      const loadServices = async () => {
        try {
          const res = await api.get('/services');
          if (res.data && Array.isArray(res.data.data)) {
            setServices(res.data.data);
          }
        } catch (err) {
          console.error('Error fetching services', err);
        }
      };
      loadServices();
    }, []);

      useEffect(() => {
        if (!socketContext || !isSocketConnected) return;

        const handleSetReminder = async (data) => {
          setCustomSnackbarOpen({
            open: true,
            data: { name: 'Reminder', message: 'successfully set', type: 'message', duration: 3000 },
            severity: 'success'
          });
          const interaction = data.reminder;
          await socketContext.emit('live-chat-ticket',1);
          if (interaction) {
            const mappedMessages = [{
              id: interaction?._id?.$oid || interaction?._id,
              message: interaction?.TA_Thread_Message || 'None',
              sender: 'Reminder',
              reminder: interaction?.TA_Thread_Type || '',
              name: 'Reminder',
              timestamp: interaction?.TA_Created_At,
              messageType: 'Text',
              channelType: 'Thread',
              messageStatus: 'Delivered',
              threadId: interaction?.TA_Thread_Message_ID,
              ticketRef: interaction?.TA_Thread_Ticket_Ref?.$oid || interaction?.TA_Thread_Ticket_Ref,
              createdBy: interaction?.TA_Created_By?.$oid || interaction?.TA_Created_By,
              isInternal: interaction?.TA_Is_Internal,
              isPublish: interaction?.TA_is_publish,
              metadata: interaction?.TA_Metadata,
              attachments: interaction?.TA_Attachments,
              callStatus: interaction?.TA_Thread_Call_Status,
              assignedUsers: interaction?.TA_Assigned_To
            }];
            if (mappedMessages.length > 0) {
              setChatHistory(prev => [...mappedMessages, ...prev]);
            }
          }
        };

        const handleActiveReminder = async (data) => {
          alert(data.TA_Thread_Message);
          const interaction = data;
          await socketContext.emit('live-chat-ticket',1);
          if (interaction) {
            const mappedMessages = [{
              id: interaction?._id?.$oid || interaction?._id,
              message: interaction?.TA_Thread_Message || 'None',
              sender: 'Reminder',
              reminder: interaction?.TA_Thread_Type || '',
              name: 'Reminder',
              timestamp: interaction?.TA_Created_At,
              messageType: 'Text',
              channelType: 'Thread',
              messageStatus: 'Delivered',
              threadId: interaction?.TA_Thread_Message_ID,
              ticketRef: interaction?.TA_Thread_Ticket_Ref?.$oid || interaction?.TA_Thread_Ticket_Ref,
              createdBy: interaction?.TA_Created_By?.$oid || interaction?.TA_Created_By,
              isInternal: interaction?.TA_Is_Internal,
              isPublish: interaction?.TA_is_publish,
              metadata: interaction?.TA_Metadata,
              attachments: interaction?.TA_Attachments,
              callStatus: interaction?.TA_Thread_Call_Status,
              assignedUsers: interaction?.TA_Assigned_To
            }];
            if (mappedMessages.length > 0) {
              setChatHistory(prev => [...mappedMessages, ...prev]);
            }
            // // console.log('asjeer',data);
            setActiveReminder({ open: true, data :data?.TA_Thread_Message });
          }
        };

        // changes for the broadcast message by aswin  

        const handleBroadcastMessage = (data) => {
          // Handle incoming broadcast messages
          toast.info(`${data.message}`, { duration: 5000 });
          console.log('Broadcast message received:', data);
        };

        socketContext.on('set-reminder', handleSetReminder);
        socketContext.on('active-reminder', handleActiveReminder);
        socketContext.on('broadcast-message', handleBroadcastMessage);

        return () => {
          socketContext.off('active-reminder', handleActiveReminder);
          socketContext.off('set-reminder', handleSetReminder);
          socketContext.off('broadcast-message', handleBroadcastMessage);
        };
      }, [socketContext, isSocketConnected]);

      // set payment click logic
      const handlePaymentClick = () => {
        setPaymentModalOpen(true);
        setSelectedService('');
        setServiceAmount('');
        setIsCustomAmount(false);
      }
      // Handle service selection change
      const handleServiceChange = (event) => {
        const serviceId = event.target.value;
        setSelectedService(serviceId);

        setCallCommentService(serviceId); 

        // Find the selected service and set its amount
        const service = services.find(s => s._id === serviceId);
        if (service && service.TA_Service_Amount && service.TA_Service_Amount > 0) {
          setServiceAmount(service.TA_Service_Amount);
          setIsCustomAmount(false);
        } else {
          setServiceAmount('');
          setIsCustomAmount(true);
        }
      };

      // Handle amount input change
      const handleAmountChange = (event) => {
        setServiceAmount(event.target.value);
        // If user manually changes the amount, treat it as a custom amount
        if (selectedService) {
          const service = services.find(s => s._id === selectedService);
          if (service && service.TA_Service_Amount && service.TA_Service_Amount > 0) {
            setIsCustomAmount(service.TA_Service_Amount !== parseFloat(event.target.value));
          } else {
            setIsCustomAmount(true);
          }
        }
      };

      // Handle service payment from modal
      const handleServicePaymentFromModal = async () => {
        if (!selectedService) {
          alert('Please select a service');
          return;
        }

        if (!serviceAmount || parseFloat(serviceAmount) <= 0) {
          alert('Please enter a valid service amount');
          return;
        }

        // Close the modal first
        setPaymentModalOpen(false);

        // Then call the payment function
        await handleServicePayment(selectedService, serviceAmount);
      };

      // Update the handleServicePayment function to accept amount parameter
      const handleServicePayment = async (serviceId, amount) => {
        if (!selectedContact?.id) {
          alert('No ticket selected');
          return;
        }

        try {
          const userName = selectedContact?.name || selectedContact?.userName || '';
          const result = await createServicePayment({
            ticketId: selectedContact.id,
            serviceRef: serviceId,
            userName,
            amount: parseFloat(amount), // Pass the amount to the API
            phNumber: selectedContact?.phone
          });
          const data = result.data;
          const patientData = selectedContact;
          // // // console.log('Payment link result:', patientData);
          if (result && result.success) {
            const paymentMessage = result.message || `Payment link for ₹${amount}`;
            setChatHistory(prev => [
              ...prev,
              // { id: Date.now(), message: paymentMessage, sender: 'system', name: 'System', timestamp: new Date().toISOString() }
              {
                id: data?._id?.$oid || data?._id,
                message: data?.TA_Thread_Message || 'None',
                sender: data?.TA_Thread_Type ? 'system' : 'customer',
                name: patientData?.name || patientData?.phone || 'Customer',
                timestamp: data?.TA_Created_At,
                messageType: 'Text', // Default to Text for thread messages
                channelType: 'Thread',
                messageStatus: 'Delivered',
                threadId: data?.TA_Thread_Message_ID,
                ticketRef: data?.TA_Thread_Ticket_Ref?.$oid || data?.TA_Thread_Ticket_Ref,
                createdBy: data?.TA_Created_By?.$oid || data?.TA_Created_By,
                isInternal: data?.TA_Is_Internal,
                isPublish: data?.TA_is_publish,
                metadata: data?.TA_Metadata,
                attachments: data?.TA_Attachments
              }
            ]);
            alert('Payment link generated successfully.');
          } else {
            alert('Payment link could not be generated.');
          }
        } catch (error) {
          console.error('Error creating payment link:', error);
          alert('Failed to create payment link.');
        }
      };


      const handleOfflinePayment = async () => {
        if (!selectedContact?.id) {
          alert('No ticket selected');
          return;
        }
        // // // console.log(serviceAmount)

        const userName = selectedContact?.name || selectedContact?.userName || '';
        const result = await createServicePayment({
          ticketId: selectedContact.id,
          serviceRef: selectedService,
          userName,
          amount: parseFloat(serviceAmount), // Pass the amount to the API
          isOffLine: true,
          phNumber: selectedContact?.phone
        });

        if (result.success) {
          setPaymentModalOpen(false);
          alert('collected')
          const mappedData = {
            id: selectedContact?._id,
            message: result?.data?.TA_Thread_Message || 'None',
            sender: 'system',
            name: 'Customer',
            timestamp: result?.data?.TA_Created_At,
            messageType: 'Text', // Default to Text for thread messages
            channelType: 'Thread',
            messageStatus: 'Delivered',
            threadId: result?.data?.TA_Thread_Message_ID,
            ticketRef: result?.data?.TA_Thread_Ticket_Ref?.$oid || result?.data?.TA_Thread_Ticket_Ref,
            createdBy: result?.data?.TA_Created_By?.$oid || result?.data?.TA_Created_By,
            isInternal: result?.data?.TA_Is_Internal,
            isPublish: result?.data?.TA_is_publish,
            metadata: result?.data?.TA_Metadata,
            attachments: result?.data?.TA_Attachments,
            callStatus: result?.data?.TA_Thread_Call_Status
          };
          setChatHistory([...chatHistory, mappedData])
          setUserChatHistory([...userChatHistory, mappedData])
          await socketContext.emit('live-chat-ticket', 1);
        }
        // // // console.log({result})
      }

      const handleIsTicketSeen = async (ticketId) => {
        // if(selectedContact?.id == ticketId){
        await api.put(`/tickets/${ticketId}/status`, { isRead: 1 })
        // }    
      }

      // Dialog box for the reminder
      const [reminderDialogOpen, setReminderDialogOpen] = useState(false);
      const [reminderDate, setReminderDate] = useState(dayjs().format('YYYY-MM-DD'));
      const [reminderTime, setReminderTime] = useState(dayjs().format('HH:mm'));
      const [reminderComment, setReminderComment] = useState('');

      // Reminders state stored in localStorage under key 'reminders'
      const [reminderData, setReminderData] = useState([]);
      // Local search state specifically for the Assign Users dropdown inside the reminder dialog
      const [assignSearchQuery, setAssignSearchQuery] = React.useState('');


      const handleSetReminder = () => {
        // initialize fields when opening (set default to now)
        setReminderDate(dayjs().format('YYYY-MM-DD'));
        setReminderTime(dayjs().format('HH:mm'));
        setCallCommentValue('');
        setAssignUserValue([]);
        setAssignSearchQuery('');
        // keep previously selectedService if present or leave as is
        setReminderDialogOpen(true);
      }

      // Save the reminder to localStorage
      const handleSaveReminder = async (status) => {
        try {
          // Construct local datetime from the date and time strings
          const dtLocal = dayjs(`${reminderDate}T${reminderTime}`);
          if (!dtLocal || !dtLocal.isValid()) {
            alert('Please select a valid date and time for the reminder.');
            return;
          }
          if (dtLocal.isBefore(dayjs())) {
            return setCustomSnackbarOpen({ open: true, data: { name: 'Reminder', message: 'The selected time is in the past', type: 'message', duration: 3000 }, severity: 'warning' });
          }
          if (!selectedContact?.id) {
            return setCustomSnackbarOpen({ open: true, data: { name: 'Reminder', message: 'Please select a ticket to set ', type: 'message', duration: 3000 }, severity: 'warning' });
          }
          if (!selectedService) {
            return setCustomSnackbarOpen({ open: true, data: { name: 'Reminder', message: 'Please select a service to set ', type: 'message', duration: 3000 }, severity: 'warning' });
          }
          if (assignUserValue.length == 0) {
            return setCustomSnackbarOpen({ open: true, data: { name: 'Reminder', message: 'Please select at least one user to set ', type: 'message', duration: 3000 }, severity: 'warning' });
          }
          // if(!reminderComment){
          //   return setCustomSnackbarOpen({ open: true, data: { name: 'Reminder', message: 'Please enter a message',type:'message',duration:3000 }, severity: 'warning' });
          // }

          const createdAtDate = dayjs().format('YYYY-MM-DD');
          const createdAtTime = dayjs().format('HH:mm');
          const assignedUsers = userList.filter(u => assignUserValue.includes(u.id));

          const newReminder = {
            id: `${Date.now()}_${Math.floor(Math.random() * 10000)}`,
            ticketId: selectedContact?.id || null,
            ticketName: selectedContact?.name || null,
            serviceRef: selectedService || null,
            assignedUsers: assignedUsers || [],
            message: reminderComment || '',
            // Save UTC ISO built from the local date/time
            reminderDate: reminderDate,
            reminderTime: reminderTime,
            dateTimeISO: dtLocal.toISOString(),
            // createdAtDate: createdAtDate,
            // createdAtTime: createdAtTime
          };

          const res = await api.post('/reminder/add', newReminder, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          });

          // // console.log('res?.data',res?.data)

          if (res?.data?.success) {
            const reminderData = res?.data?.reminderThread;
            // setCustomSnackbarOpen({ open: true, data: { name: 'Reminder', message: res?.message,type:'message',duration:3000 }, severity: 'success' });
            toast.success(res?.data?.message);
            socketContext.emit('live-chat-ticket', {
              customerId: 2,
              page: 1,
              limit: 15
            });
            handleStatusUpdate(2); // Update ticket status to 'Reminder Set'
            setChatHistory(prev=>[...prev,
              {
                id: reminderData?._id?.$oid || reminderData?._id,
                message: reminderData?.TA_Thread_Message || 'None',
                sender: 'Reminder',
                reminder: reminderData?.TA_Thread_Type  || '',
                name:  'Customer',
                timestamp: reminderData?.TA_Created_At,
                messageType: 'Text', // Default to Text for thread messages
                channelType: 'Thread',
                messageStatus: 'Delivered',
                threadId: reminderData?.TA_Thread_Message_ID,
                ticketRef: reminderData?.TA_Thread_Ticket_Ref?.$oid || reminderData?.TA_Thread_Ticket_Ref,
                createdBy: reminderData?.TA_Created_By?.$oid || reminderData?.TA_Created_By,
                isInternal: reminderData?.TA_Is_Internal,
                isPublish: reminderData?.TA_is_publish,
                metadata: reminderData?.TA_Metadata,
              }
            ]);
          }
          // Give user feedback
          // close and clear fields
          setReminderDialogOpen(false);
          setReminderDate(dayjs().format('YYYY-MM-DD'));
          setReminderTime(dayjs().format('HH:mm'));
          setReminderComment('');
          setAssignUserValue([]);
          setAssignSearchQuery('');
          setSelectedService('');
          setServiceAmount('');
          setIsCustomAmount(false);
          setReminderTicketStatus(2); // Update ticket status to 'Reminder Set'
        } catch (err) {
          console.error('Error saving reminder', err);
          alert('Failed to save reminder');
        }
      };

      // Close reminder dialog and clear all reminder inputs
      const handleCloseReminder = () => {
        setReminderDialogOpen(false);
        setReminderDate(dayjs().format('YYYY-MM-DD'));
        setReminderTime(dayjs().format('HH:mm'));
        setReminderComment('');
        setAssignUserValue([]);
        setAssignSearchQuery('');
        setSelectedService('');
        setServiceAmount('');
        setIsCustomAmount(false);
      };



      const userHasSelectedService = useCallback((u) => {
        // if no service selected, show everyone
        if (!selectedService) return true;

        if (!u.roleId || !roles.length) return false;

        const role = roles.find(r => String(r._id) === String(u.roleId));
        if (!role) return false;

        const serviceRefs = Array.isArray(role.TA_Role_Service_Ref)
          ? role.TA_Role_Service_Ref
          : (role.TA_Role_Service_Ref ? [role.TA_Role_Service_Ref] : []);

        return serviceRefs.some(sid => String(sid) === String(selectedService));
      }, [roles, selectedService]);




      const filteredUsers = React.useMemo(() => {
        const q = assignSearchQuery.trim().toLowerCase();
        const byText = (u) =>
          !q ||
          [u.name, u.phone, u.email]
            .map(v => String(v || '').toLowerCase())
            .some(t => t.includes(q));

        const byNotSelected = (u) =>
          !assignUserValue.some(id => String(id) === String(u.id));

        const byService = (u) => userHasSelectedService(u);

          return userList.filter(u => byText(u) && byNotSelected(u) && byService(u));
        }, [assignSearchQuery, userList, assignUserValue, userHasSelectedService]);



      return (
        <Box sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          background: 'background.default',
          minHeight: '80vh',
          m:isSmallScreen?0:'auto',
          p:isSmallScreen?0:'auto',
        }}>


          {/* Reminder Alert (overlay) */}
          {activeReminder.open && (
            <Box
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                pt: 4,
                zIndex: 9999,
                pointerEvents: 'none',
                background: 'transparent'
              }}
            >
              <Box sx={{ pointerEvents: 'auto', mt: 10 }}>
                <CustomReminderAlert
                  title={activeReminder.data?.ticketName || 'Reminder'}
                  subtitle={
                    activeReminder.data?.message ||
                    activeReminder.data?.reminder ||
                    'You have a reminder'
                  }
                  count={1}
                  onClose={() => setActiveReminder({ open: false, data: null })}
                />
              </Box>
            </Box>

          )}

          {/* Main Content Area */}
          <Box sx={{
            flex: 1,
            display: 'flex',
            // minHeight: 0,
            m:0,
            overflow: 'hidden',
            background: 'transparent',
          }}>
            <Grid container spacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{
              flex: 1,
              // minHeight: 0,
              // overflow: { xs: 'visible', sm: 'hidden', md: 'hidden', lg: 'visible' },
              height: isSmallScreen?'90vh':'100%',
              // border:'1px solid yellow'
            }}>
                {/* Left Panel: Active Chats */}
                <Grid item xs={12} lg={3} md={6} sx={{
                  display: showChatList ? 'flex' : { xs: 'none', lg: 'flex' },
                  flexDirection: 'column',
                  minHeight: 0,
                  height: isSmallScreen?'94vh':'100%',
                  order: { xs: 1, lg: 1 },
                  // border:'1px solid red'
                }}>
                  <Paper sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    p: 0,
                    height: '100%',
                    maxHeight: '100%',
                    background: 'background.default',
                    borderRadius: 3,
                    // boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  }}>
                    <Box sx={{
                      p: isSmallScreen?1.2:2.2,
                      background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                      borderRadius: '10px 10px 0px 0px',
                      display: 'flex',
                      flexDirection: 'column',
                      flexShrink: 0,
                      boxShadow: '0 4px 25px rgba(224, 242, 254, 0.4)'
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                        <Box sx={{flex: isSmallScreen ? 0 : 1 }}>
                          <Typography variant="h6" sx={{
                            display: isSmallScreen ? 'none' : 'flex',
                            fontWeight: isSearchExpanded ? 400 : 700,
                            color: 'white',
                            fontSize: isSearchExpanded ? '0.9rem' : '1.1rem',
                            transition: 'all 0.2s ease', // smooth animation
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}>
                            Active Chats
                          </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', flex: 1, }} >
                          {/* Spacer for large screens */}
                          {!isSmallScreen && <Box sx={{ flex: 1 }} />}

                          {/* Icons Container */}
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: isSmallScreen ? 1 : 0, justifyContent: isSmallScreen ? 'center' : 'flex-start', }} >
                            {/* PRO Master Selector */}
                            <Tooltip title="Select PRO Master">
                              <IconButton
                                sx={{ color: 'white' ,p:0,display:canHidePro || isSearchExpanded?'none':'flex'}}
                                onClick={(e) => setProAnchorEl(e.currentTarget)}
                              >
                                <AccountCircleRoundedIcon sx={{ fontSize: 38 }} />
                              </IconButton>
                            </Tooltip>
                            <Menu
                              anchorEl={proAnchorEl}
                              open={Boolean(proAnchorEl)}
                              onClose={() => setProAnchorEl(null)}
                              PaperProps={{
                                elevation: 3,
                                sx: {
                                  mt: 1.5,
                                  minWidth: 200,
                                  borderRadius: 2,
                                  overflow: 'hidden',
                                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                },
                              }}
                              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            >
                              <Box
                                sx={{
                                  px: 2,
                                  py: 1,
                                  borderBottom: '1px solid rgba(0,0,0,0.05)',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                }}
                              >
                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                  PRO Masters
                                </Typography>
                                <Link href="" underline="none" sx={{ fontSize: '0.75rem' }}>
                                  Clear Filter
                                </Link>
                              </Box>

                              {proListLoading ? (
                                <Box sx={{ p: 2, textAlign: 'center' }}>
                                  <Typography variant="body2" color="text.secondary">
                                    Loading...
                                  </Typography>
                                </Box>
                              ) : proList.length > 0 ? (
                                proList.map((pro) => (
                                  <MenuItem
                                    key={pro._id}
                                    onClick={() => {
                                      setProAnchorEl(null);
                                      setShowProView(true);
                                      setSelectedProId(pro._id);
                                      setExpandedPro((prev) => (prev === pro._id ? null : pro._id));
                                      fetchPatientsForPro(pro._id);
                                    }}
                                    sx={{
                                      px: 2,
                                      py: 1.5,
                                      '&:hover': {
                                        backgroundColor: 'rgba(0, 136, 204, 0.08)',
                                      },
                                    }}
                                  >
                                    <Box
                                      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}
                                    >
                                      <Avatar
                                        sx={{
                                          width: 36,
                                          height: 36,
                                          bgcolor: 'primary.main',
                                          fontSize: '0.875rem',
                                          fontWeight: 500,
                                        }}
                                      >
                                        {pro.name?.[0]?.toUpperCase() || 'P'}
                                      </Avatar>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontWeight: 500,
                                          textTransform: 'capitalize',
                                        }}
                                      >
                                        {pro.name}
                                      </Typography>
                                    </Box>
                                  </MenuItem>
                                ))
                              ) : (
                                <Box sx={{ p: 2, textAlign: 'center' }}>
                                  <Typography variant="body2" color="text.secondary">
                                    No PROs available
                                  </Typography>
                                </Box>
                              )}

                              <Box sx={{ px: 2, py: 1, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                <Button
                                  fullWidth
                                  size="small"
                                  onClick={() => {
                                    setProAnchorEl(null);
                                    setShowProView(true);
                                    setSelectedProId(null);
                                  }}
                                  sx={{
                                    justifyContent: 'flex-start',
                                    color: 'primary.main',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                  }}
                                >
                                  View All PROs
                                </Button>
                              </Box>
                            </Menu>

                            {/* Ticket Status */}
                            <Tooltip title="Change Ticket Status">
                              <IconButton
                                disableRipple
                                onClick={openStatusMenu}
                                size="small"
                                sx={{
                                  borderColor: 'white',
                                  color: 'white',
                                  background: STATUS_COLORS[ticketStatus],
                                  m:0,
                                  display:isSearchExpanded?'none':'flex',
                                }}
                                aria-controls={statusMenuOpen ? 'ticket-status-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={statusMenuOpen ? 'true' : undefined}
                              >
                                <AlbumRoundedIcon />
                              </IconButton>
                            </Tooltip>
                            <Menu
                              id="ticket-status-menu"
                              anchorEl={statusMenuEl}
                              open={statusMenuOpen}
                              onClose={closeStatusMenu}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: isMdDown ? 'right' : 'center',
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: isMdDown ? 'right' : 'center',
                              }}
                            >
                              {statusOptions.map((status) => (
                                <MenuItem
                                  key={status}
                                  selected={ticketStatus === status}
                                  onClick={() => handleStatusPick(status)}
                                  sx={{ minWidth: 160 }}
                                >
                                  <ListItemIcon>
                                    <Box
                                      sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        bgcolor: STATUS_COLORS[status],
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={STATUS_LABELS[status]}
                                    primaryTypographyProps={{ fontWeight: 600 }}
                                  />
                                </MenuItem>
                              ))}
                            </Menu>

                            {/* Search Input */}
                              <TextField
                                size="small"
                                placeholder="Search chats..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                autoFocus
                                sx={{
                                  width: isSearchExpanded ? { xs: 150, sm: 180 } : 0,
                                  transition: "width 0.3s ease, opacity 0.3s ease",
                                  opacity: isSearchExpanded ? 1 : 0,
                                  overflow: "hidden",
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "20px",
                                    height: 38,
                                    fontSize: 14,
                                    background: "rgba(255, 255, 255, 0.95)",
                                    paddingRight: "8px",
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                    "& fieldset": {
                                      borderColor: "transparent",
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "rgba(255, 255, 255, 0.6)",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "#77c7ff",
                                      borderWidth: 1.5,
                                    },
                                  },
                                  "& input::placeholder": {
                                    color: "rgba(0, 0, 0, 0.5)",
                                  },
                                }}
                                InputProps={{
                                  inputRef: searchInputRef,
                                  startAdornment: (
                                    <InputAdornment position="start" sx={{ ml: 0.5 }}>
                                      <SearchIcon sx={{ fontSize: 20, color: "rgba(0, 0, 0, 0.5)" }} />
                                    </InputAdornment>
                                  ),
                                  endAdornment: isSearchExpanded && (
                                    <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                                      <CloseIcon
                                        onClick={() => {setIsSearchExpanded(false); setSearchQuery('');}}
                                        sx={{
                                          fontSize: 20,
                                          color: "rgba(0, 0, 0, 0.5)",
                                          "&:hover": {
                                            color: "rgba(0, 0, 0, 0.7)",
                                          },
                                        }}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              {!isSearchExpanded && (
                                <IconButton
                                  onClick={() => setIsSearchExpanded(true)}
                                  sx={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: '50%',
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    color: 'white',
                                    '&:hover': { background: 'rgba(255, 255, 255, 0.3)' },
                                  }}
                                >
                                  <SearchIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                              )}


                            {/* Chat Filter */}
                            <Badge
                              badgeContent={messageFilter === 'unread' ? '!' : null}
                              color="error"
                              overlap="circular"
                              sx={{display:isSearchExpanded?'none':'flex'}}
                            >
                              <Tooltip title="Chat Filter">
                                <IconButton
                                  onClick={(e) => setFilterAnchorEl(e.currentTarget)}
                                  sx={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: '50%',
                                    background:
                                      messageFilter === 'unread'
                                        ? 'rgba(255, 255, 255, 0.3)'
                                        : 'rgba(255, 255, 255, 0.2)',
                                    color: 'white',
                                    '&:hover': { background: 'rgba(255, 255, 255, 0.3)' },
                                  }}
                                >
                                  <FilterListIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                              </Tooltip>
                            </Badge>
                            <Menu
                              anchorEl={filterAnchorEl}
                              open={Boolean(filterAnchorEl)}
                              onClose={() => setFilterAnchorEl(null)}
                              PaperProps={{
                                sx: { mt: 1, minWidth: 120, borderRadius: 2, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' },
                              }}
                            >
                              <MenuItem 
                                onClick={() => { setMessageFilter('all'); setFilterAnchorEl(null); }} selected={messageFilter === 'all'}
                                sx={{color:'background.text'}}
                              >
                                All
                              </MenuItem>
                              <MenuItem 
                                onClick={() => { setMessageFilter('unread'); setFilterAnchorEl(null); }}
                                selected={messageFilter === 'unread'}
                                sx={{color:'background.text'}}
                              >
                                Unread
                              </MenuItem>
                              <MenuItem 
                                onClick={() => { setMessageFilter('awaiting-reply'); setFilterAnchorEl(null); }}
                                selected={messageFilter === 'awaiting-reply'}
                                sx={{color:'background.text'}}
                              >
                                Delayed Response
                              </MenuItem>
                              
                            </Menu>
                          </Box>
                        </Box>
                      </Box>
                    </Box>

                  <Box 
                    ref={ticketsListRef}
                    onScroll={handleTicketsScroll}
                    sx={{ 
                      flex: 1, 
                      minHeight: 0, 
                      height: '100%',
                      overflow: 'auto', 
                      p: 1,
                      backgroundColor:'background.paper',
                      scrollBehavior: 'smooth',
                      '&::-webkit-scrollbar': { 
                        width: '8px' 
                      },
                      '&::-webkit-scrollbar-track': { 
                        background: 'rgba(0, 0, 0, 0.05)',
                        borderRadius: '4px'
                      },
                      '&::-webkit-scrollbar-thumb': { 
                        background: 'rgba(20,83,45,0.3)',
                        borderRadius: '4px',
                        '&:hover': {
                          background: '#0088cc'
                        }
                      },
                      '&::-webkit-scrollbar-corner': {
                        background: 'transparent'
                      }
                    }}>
                    <List sx={{ minHeight: 0, p: 0 }}>
                      {/* Loading indicator for previous page */}
                      {loadingPrev && (
                        <ListItem sx={{ justifyContent: 'center', py: 2 }}>
                          <CircularProgress size={24} />
                          <Typography variant="body2" sx={{ ml: 2, color: 'text.secondary' }}>
                            Loading previous tickets...
                          </Typography>
                        </ListItem>
                      )}
                      
                      {showProView ? (
                        // PRO View Content
                        selectedProId ? (
                          // Show only the selected PRO's patients (no PRO details)
                          (() => {
                            const pro = proList.find(p => p._id === selectedProId);
                            return (
                              <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', mb: 2}}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600,color: 'background.text' }}>
                                      Patients Under {pro?.name ? capitalizeFirstLetter(pro?.name) : 'No Name'} PRO
                                    </Typography>
                                    <Link href="" underline="none" color="background.text">Clear Filter</Link>

                                  
                                </Box>
                                {proPatients[pro?._id] ? (
                                  proPatients[pro._id].length > 0 ? (
                                    proPatients[pro._id].map(contact => {
                                      // // // console.log({contact});
                                      const patient = contact?.raw?.patient;
                                      contact = {
                                        id: contact?.raw?._id,
                                        name: patient?.name || patient?.mobile || 'Unknown',
                                        phone: patient?.mobile || '',
                                        email: patient?.email || '',
                                        avatar: (patient?.name || 'U')[0].toUpperCase(),
                                        lastMessage: contact?.lastMessage || 'No description',
                                        time: contact?.time  || new Date(contact?.raw?.request?.createdAt).toLocaleDateString('en-GB'),
                                        isTicketRead: contact?.raw?.isTicketRead,
                                        ticketStatus: contact?.raw?.request?.status,
                                        raw: contact
                                      };

                                      return (
                                        <ListItem 
                                          key={contact.id} 
                                          button 
                                          sx={{
                                            borderRadius: '12px',
                                            mb: 0.5,
                                            p: 1.5,
                                            transition: 'all 0.2s ease',
                                            // background: selectedContact?.id === contact.id 
                                            //   ? 'rgba(20,83,45,0.1)'
                                            //   : 'transparent',
                                            background:
                                            selectedContact?.id === contact.id
                                              ? 'rgba(20,83,45,0.1)'
                                              : (unreadMap[contact.id] > 0
                                                  ? 'rgba(173, 216, 230, 0.25)' // light red tint for unread
                                                  : (contact.isTicketRead == 0 ? 'lightblue' : 'transparent')),
                                            '&:hover': {
                                              background: 'rgba(20,83,45,0.05)',
                                            },
                                          }}
                                          
                                          onClick={ async () => {
                                            // Leave previous customer room if any
                                            if (selectedContact?.id) {
                                              await socketContext?.emit('leave-customer-room', selectedContact.id);
                                            }
                                            
                                            setSelectedContact(contact);
                                            
                                            setUnreadMap((prev) => ({ ...prev, [contact.id]: 0 }));
                                            
                                            setEditContactData(contact);
                                            // // // console.log(contact);
                                            await handleIsTicketSeen(contact?.id);
                                            // Reset tickets when selecting a contact with different status
                                            if (contact?.ticketStatus !== ticketStatus) {
                                              resetTicketsForNewStatus();
                                              setTicketStatus(contact?.ticketStatus);
                                            }
                                            await socketContext.emit('live-chat-ticket', {
                                              customerId: contact?.ticketStatus,
                                              page: 1,
                                              limit: 10
                                            });
                                            
                                            // Join the new customer room and fetch interactions
                                            await socketContext.emit('join-customer-room', contact?.id);
                                            await socketContext.emit('live-chat-interactions', {
                                              customerId: contact?.id,
                                              page: 1,
                                              limit: 8,
                                              isInitialLoad: true
                                            });
                                            
                                            if (isMdDown) {
                                              setShowChatView(true);
                                              setShowContactDetails(false);
                                            }
                                          }}
                                        >
                                          

                                        

                                          <Badge
                                            overlap="circular"
                                            color="error"
                                            // badgeContent={unreadMap?.[contact.id] > 0 ? unreadMap[contact.id] : null}
                                            badgeContent={unreadMap?.[contact.id] > 0 ? "!" : null}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                          >
                                            <Avatar sx={{ 
                                              mr: 2,
                                              width: 40,
                                              height: 40,
                                              background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                                              fontSize: '1rem',
                                              fontWeight: 600,
                                            }}>
                                              {contact.avatar}
                                            </Avatar>
                                          </Badge>
                                          
                                          



                                          <ListItemText 
                                            primary={
                                              <Typography sx={{ 
                                                fontWeight: 600, 
                                                fontSize: '0.95rem',
                                                color: selectedContact?.id === contact.id ? '#28af5cff' : 'background.text',
                                                textTransform: 'capitalize',
                                              }}>
                                                {contact.name}
                                              </Typography>
                                            } 
                                            secondary={
                                              <Typography sx={{ 
                                                fontSize: '0.8rem',
                                                color: '#b8b8b8',
                                                lineHeight: 1.3,
                                              }}>
                                                {contact.lastMessage}
                                              </Typography>
                                            } 
                                          />
                                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                          <Typography variant="caption" sx={{ 
                                            color: 'background.text',
                                            fontSize: '0.65rem',
                                          }}>
                                            {contact.time}
                                          </Typography>
                                          {/* <Box sx={{ mt: 0.3, display : 'flex' }}>
                                            {(() => {
                                              const { anchorTs, replied } = computeReplyAgingFromTicket(contact?.raw);
                                              return (
                                                <>
                                                  <AgeBlocks timestamp={anchorTs} isRead={!!replied} /> 
                                                  <AgeLabel timestamp={anchorTs} />
                                                </>
                                              );
                                            })()}
                                          </Box> */}
                                          </Box>
                                        </ListItem>
                                      )
                                    })
                                  ) : (
                                    <Box sx={{ p: 3, textAlign: 'center' }}>
                                      <Typography variant="body2" sx={{ color: 'background.text', fontStyle: 'italic' }}>
                                        No patients assigned to this PRO
                                      </Typography>
                                    </Box>
                                  )
                                ) : (
                                  <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                      Loading patients...
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            );
                          })()
                        ) : proListLoading ? (
                          <Box sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="body2" sx={{ color: 'background.text', fontSize: '0.9rem' }}>
                              Loading PROs...
                            </Typography>
                          </Box>
                        ) : proList.length > 0 ? (
                          proList.map(pro => (
                            <Accordion
                            key={pro._id}
                            expanded={expandedPro === pro._id}
                            onChange={() => setExpandedPro(expandedPro === pro._id ? null : pro._id)}
                            sx={{
                              mb: 1,
                              borderRadius: '12px',
                              boxShadow: 'none',
                                border: '1px solid rgba(0,0,0,0.1)',
                                '&:before': { display: 'none' },
                                '&.Mui-expanded': {
                                  margin: '8px 0',
                                },
                              }}
                              >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{
                                  borderRadius: '12px',
                                  '&:hover': {
                                    backgroundColor: 'rgba(0,0,0,0.04)',
                                  },
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                  <Avatar sx={{ 
                                    width: 40,
                                    height: 40,
                                    background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                                    fontSize: '1rem',
                                    fontWeight: 600,
                                  }}>
                                    {pro.name?.[0]?.toUpperCase() || 'P'}
                                  </Avatar>
                                  <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: '0.95rem',textTransform:'capitalize',color: 'background.text' }}>
                                      {pro.name}
                                    </Typography>
                                    <Typography sx={{ fontSize: '0.8rem', color: 'background.text' }}>
                                      {pro.phoneNumber}
                                    </Typography>
                                  </Box>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails sx={{ pt: 0 }}>
                                <Box sx={{ pl: 6 }}>
                                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500,color: 'background.text' }}>
                                      Patients assigned to this PRO:
                                    </Typography>
                                    
                                  </Box>
                                  {proPatients[pro._id] ? (
                                    proPatients[pro._id].length > 0 ? (
                                      proPatients[pro._id].map(patient => (
                                        <ListItem 
                                          key={patient.id} 
                                          button 
                                          sx={{
                                            borderRadius: '12px',
                                            mb: 0.5,
                                            p: 1.5,
                                            transition: 'all 0.2s ease',
                                            background: selectedContact?.id === patient.id 
                                              ? 'rgba(20,83,45,0.1)'
                                              : 'transparent',
                                            '&:hover': {
                                              background: 'rgba(20,83,45,0.05)',
                                            },
                                          }}
                                          onClick={() => {
                                            
                                            if (patient) {
                                          
                                            setSelectedContact(patient);
                                              if (isMdDown) {
                                              setShowChatView(true);
                                              setShowContactDetails(false);
                                                }
                                                  }
                                                  }}
                                        >
                                          <Avatar sx={{ 
                                            mr: 2,
                                            width: 40,
                                            height: 40,
                                            background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                                            fontSize: '1rem',
                                            fontWeight: 600,
                                          }}>
                                            {patient.avatar}
                                          </Avatar>
                                          <ListItemText 
                                            primary={
                                              <Typography sx={{ 
                                                fontWeight: 600, 
                                                fontSize: '0.95rem',
                                                color: selectedContact?.id === patient.id ? '#28af5cff' : 'background.text',
                                                textTransform: 'capitalize',
                                              }}>
                                                {patient.name}
                                              </Typography>
                                            } 
                                            secondary={
                                              <Typography sx={{ 
                                                fontSize: '0.8rem',
                                                color: 'background.text',
                                                lineHeight: 1.3,
                                              }}>
                                                {patient.lastMessage}
                                              </Typography>
                                            } 
                                          />
                                          <Typography variant="caption" sx={{ 
                                            color: 'background.text',
                                            fontSize: '0.75rem',
                                          }}>
                                            {patient.time}
                                          </Typography>
                                        </ListItem>
                                      ))
                                    ) : (
                                      <Typography variant="body2" sx={{ color: 'background.text', fontStyle: 'italic' }}>
                                        No patients assigned to this PRO
                                      </Typography>
                                    )
                                  ) : (
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                      Loading patients...
                                    </Typography>
                                  )}
                                </Box>
                              </AccordionDetails>
                            </Accordion>
                          ))
                        ) : (
                          <Box sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="body2" sx={{ color: 'background.text', fontSize: '0.9rem' }}>
                              No PROs found
                            </Typography>
                          </Box>
                        )
                      ) : (
                        // Regular Tickets View
                        ticketsLoading ? (
                          <Box sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="body2" sx={{ color: 'background.text', fontSize: '0.9rem' }}>
                              Loading tickets...
                            </Typography>
                          </Box>
                        ) : ticketsError ? (
                          <Box sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="body2" sx={{ color: 'red', fontSize: '0.9rem' }}>
                              {ticketsError}
                            </Typography>
                          </Box>
                        ) : filteredActiveChats.length > 0 ? (
                            filteredActiveChats.map(contact => {
                              // console.log({contact})
                              const patient = contact?.TA_Patient_Ref;
                              // let lastMessage = contact?.threadLastMessage && contact?.threadLastMessage[0]?.TA_Thread_Message || '';
                              // if (lastMessage.length > 50 ) {
                              //   if(lastMessage == 'None' || lastMessage.startsWith('{\"address\"') || lastMessage.startsWith('{\"latitude\"') || lastMessage.startsWith('[{\"name\":') || lastMessage.startsWith('{\"name\"') ){                            
                              //     lastMessage = contact?.displayLastMessage || 'No description';
                              //   }else{
                              //     lastMessage = lastMessage.substring(0, 50) + '...';
                              //   }
                              // }
                              
                              contact = {
                                id: contact._id,
                                name: patient?.TA_Patient_Name || patient?.TA_Patient_Mobile_Number || 'Unknown',
                                phone: patient?.TA_Patient_Mobile_Number || '',
                                email: patient?.TA_Patient_Email_Address || '',
                                avatar: (patient?.TA_Patient_Name || 'U')[0].toUpperCase(),
                                lastMessage: contact?.displayLastMessage || 'No description',
                                time: new Date(contact.TA_Updated_At || contact.TA_Created_At).toLocaleDateString('en-GB'),
                                isTicketRead: contact.TA_Is_TicketSeen,
                                ticketStatus: contact.TA_Ticket_Status,
                                landMark: patient?.TA_Patient_LandMark,
                                addressArray: patient?.TA_Patient_AddresLine_Array,
                                raw: contact,
                              };
                              // console.log('contact', contact);
                              return(
                                <Box key={contact.id} sx={{ width: '100%', mb: 0.5, position: 'relative' }}>
                                  <Accordion
                                    disableGutters
                                    elevation={0}
                                    square
                                    sx={{
                                      background: 'transparent',
                                      boxShadow: 'none',
                                      margin: 0,
                                      width: '100%',
                                      '&:before': { display: 'none' },
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={null}
                                      sx={{
                                        padding: 0,
                                        minHeight: 'auto',
                                        '& .MuiAccordionSummary-content': {
                                          margin: 0,
                                          padding: 0,
                                        },
                                      }}
                                    >
                                      {/*  Chat section here */}
                                      <ListItem 
                                  key={contact.id} 
                                  button 
                                  selected={selectedContact?.id === contact.id} 
                                  onClick={ async (e) => {
                                    e.stopPropagation();
                                    // Leave previous customer room if any
                                    if (selectedContact?.id) {
                                      await socketContext?.emit('leave-customer-room', selectedContact.id);
                                    }
                                    
                                    setSelectedContact(contact);
                                    setAddressData(contact?.addressArray || [])
                                    //aswin
                                    setUnreadMap((prev) => ({ ...prev, [contact.id]: 0 }));
                                    //aswin
                                    await handleIsTicketSeen(contact?.id);
                                    // Reset tickets when selecting a contact with different status
                                    if (contact?.ticketStatus !== ticketStatus) {
                                      resetTicketsForNewStatus();
                                      setTicketStatus(contact?.ticketStatus);
                                    }
                                    await socketContext.emit('live-chat-ticket', {
                                      customerId: contact?.ticketStatus,
                                      page: pagination?.currentPage,
                                      limit: pagination?.limit
                                    });
                                    
                                    // Join the new customer room and fetch interactions
                                    await socketContext.emit('join-customer-room', contact?.id);
                                    await socketContext.emit('live-chat-interactions', {
                                      customerId: contact?.id,
                                      page: 1,
                                      limit: 8,
                                      isInitialLoad: true
                                    });

                                    if (isMdDown) {
                                      setShowChatView(true);
                                      setShowContactDetails(false);
                                    }
                                  }}
                                  sx={{
                                    borderRadius: '12px',
                                    mb: 0.5,
                                    mx: isSmallScreen ? 0 : 0.5,
                                    p:  isSmallScreen ? 1 : 1.5,
                                    transition: 'all 0.2s ease',
                                    // background: selectedContact?.id === contact.id 
                                    //   ? 'rgba(20,83,45,0.1)'
                                    //   : contact.isTicketRead == 0 ? 'lightblue' : 'transparent',
                                    background:
                                      selectedContact?.id === contact.id
                                        ? 'rgba(20,83,45,0.1)'
                                        : (unreadMap[contact.id] > 0
                                          ? 'rgba(173, 216, 230, 0.25)' // light red tint for unread
                                          : (contact.isTicketRead == 0 ? 'lightblue' : 'transparent')),
                                    '&:hover': {
                                      background: 'rgba(20,83,45,0.05)',
                                    },
                                    // '&.Mui-selected': {
                                    //   background: 'rgba(218, 250, 231, 0.15)',
                                    //   border: '1px solid rgba(20,83,45,0.2)',
                                    // },
                                    border: selectedContact?.id === contact.id ? '1px solid rgba(20,83,45,0.2)' : '',
                                  }}
                                >


                                  {/* <Avatar sx={{ 
                                    mr: 2,
                                    width: 40,
                                    height: 40,
                                    background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                                    fontSize: '1rem',
                                    fontWeight: 600,
                                  }}>
                                    {contact.avatar}
                                  </Avatar> */}

                                  <Badge
                                  overlap="circular"
                                  color="error"
                                  // badgeContent={unreadMap?.[contact.id] > 0 ? unreadMap[contact.id] : null}
                                  badgeContent={unreadMap?.[contact.id] > 0 ? "!" : null}
                                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                  sx={{ mr: 2 }}   // <-- margin between icon+badge and the name
                                >
                                  <Avatar
                                    sx={{
                                      width: 40,
                                      height: 40,
                                      background:
                                        'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                                      fontSize: '1rem',
                                      fontWeight: 600,
                                    }}
                                  >
                                    {contact.avatar}
                                  </Avatar>
                                </Badge>

                                  <ListItemText
                                    primary={
                                      <Typography sx={{
                                        fontWeight: 600,
                                        fontSize: isSmallScreen?'0.8rem':'0.95rem',
                                        color: selectedContact?.id === contact.id ? '#28af5cff' : 'background.text',
                                        textTransform: 'capitalize',
                                      }}>
                                        {contact?.name && contact.name.length > 15 ? contact.name.substring(0, 15) + '...' : contact?.name}
                                      </Typography>
                                    }
                                    secondary={
                                      <Typography sx={{
                                        fontSize: isSmallScreen?'0.7rem':'0.8rem',
                                        color: contact.highlightInRed ? '#f51616' : '#b8b8b8',
                                        lineHeight: 1.3,
                                      }}>
                                        {contact.lastMessage && contact.lastMessage.length > 20 ? contact.lastMessage.substring(0, 20) + '...' : contact?.lastMessage}
                                      </Typography>
                                    }
                                  />
                                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        color: 'background.text',
                                        fontWeight: 500,
                                        fontSize: isSmallScreen?'0.54rem':'0.65rem',
                                        background: 'background.default',
                                        px: 1,
                                        py: 0.3,
                                        borderRadius: '8px',
                                      }}
                                    >
                                      {/* {(() => {
                                        if (contact.lastPatientMessageTime) {
                                          const date = new Date(contact.lastPatientMessageTime);
                                          const day = String(date.getDate()).padStart(2, '0');
                                          const month = String(date.getMonth() + 1).padStart(2, '0');
                                          const year = String(date.getFullYear()).slice(-2);
                                          return `${day}/${month}/${year}`;
                                        } else {
                                          // console.log('aswin',contact.time);
                                          return contact.time;
                                        }
                                      })()} */}

                                     {(() => {
                                        const rawTs = contact?.raw?.threadLastMessage?.[0]?.TA_Created_At;
                                          // console.log(rawTs);  
                                          
                                        if (!rawTs) return "";

                                        const messageDate = new Date(rawTs); 
                                        if (isNaN(messageDate.getTime())) return "";
                                        
                                        const now = new Date();

                                        // ---- SAME DAY → show time ----
                                        const isSameDay =
                                          messageDate.getDate() === now.getDate() &&
                                          messageDate.getMonth() === now.getMonth() &&
                                          messageDate.getFullYear() === now.getFullYear();

                                        if (isSameDay) {
                                          return messageDate.toLocaleTimeString("en-IN", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          });
                                        }

                                        // ---- YESTERDAY (calendar-based, IST-safe) ----
                                        const yesterday = new Date(now);
                                        yesterday.setDate(now.getDate() - 1);

                                        const isYesterday =
                                          messageDate.getDate() === yesterday.getDate() &&
                                          messageDate.getMonth() === yesterday.getMonth() &&
                                          messageDate.getFullYear() === yesterday.getFullYear();

                                        if (isYesterday) {
                                          return "Yesterday";
                                        }

                                        // ---- OLDER → show date ----
                                        const day = String(messageDate.getDate()).padStart(2, "0");
                                        const month = String(messageDate.getMonth() + 1).padStart(2, "0");
                                        const year = String(messageDate.getFullYear()).slice(-2);

                                        return `${day}/${month}/${year}`;
                                      })()}

                                    </Typography>

                                    <Box sx={{ml:1}}>
                                      {(() => {
                                        const { anchorTs, replied } = computeReplyAgingFromTicket(contact?.raw);
                                        return (
                                          <>
                                            <AgeBlocks timestamp={anchorTs} disabled={!!replied} />
                                            <AgeLabel timestamp={anchorTs} />
                                          </>
                                        );
                                      })()}
                                    </Box>
                                  </Box>
                                </ListItem>

                                      <Badge
                                        overlap="circular"
                                        color="error"
                                        badgeContent={unreadMap?.[contact.id] > 0 ? '!' : null}
                                        sx={{
                                          position: 'absolute',
                                          left: 14,                   // moves badge inside the curved area
                                          top: '50%',
                                          transform: 'translateY(-50%)',
                                        }}
                                      >
                                        <Avatar
                                          sx={{
                                            width: 40,
                                            height: 40,
                                            background:
                                              'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                                            fontSize: '1rem',
                                            fontWeight: 600,
                                          }}
                                        >
                                          {contact.avatar}
                                        </Avatar>
                                      </Badge>
                                    </AccordionSummary>

                                    <AccordionDetails>
                                      Implement the quick summary report here.
                                    </AccordionDetails>
                                  </Accordion>
                                </Box>

                              )
                            })
                        ) : (
                          <Box sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.9rem' }}>
                              {searchQuery ? 'No chats found' : 'No tickets found'}
                            </Typography>
                          </Box>
                        )
                    )}
                    
                    {/* Loading indicator for next page */}
                    {loadingMore && (
                      <ListItem sx={{ justifyContent: 'center', py: 2 }}>
                        <CircularProgress size={24} />
                        <Typography variant="body2" sx={{ ml: 2, color: 'text.secondary' }}>
                          Loading more tickets...
                        </Typography>
                      </ListItem>
                    )}
                    
                    {/* Pagination info */}
                    {pagination.totalCount > 0 && (
                      <ListItem sx={{ justifyContent: 'center', py: 1 }}>
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                          Page {pagination.currentPage} of {pagination.totalPages} ({pagination.totalCount} tickets)
                        </Typography>
                      </ListItem>
                    )}
                    </List>
                  </Box>
                </Paper>
                </Grid>
              
                {/* Middle Panel: Chat Area */}
                <Grid item xs={12} lg={6} md={5} sx={{ 
                  display: { 
                    xs: (showChatView && !showContactDetails && selectedContact) ? 'flex' : 'none', 
                    lg: 'flex' 
                  }, 
                  flexDirection: 'column', 
                  minHeight: 0, 
                  height: isSmallScreen?(window.innerHeight-60):'100%',
                  order: { xs: 1, lg: 1 },
                  // position: 'relative',
                  ml: { xs: 0,md:0 },
                  // border:'1px solid red'
                }}>
                  <Paper sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    p: 0,
                    position: 'relative',
                    height: isSmallScreen?'90vh':'100%',
                    overflow: 'hidden',
                    borderRadius: 3,
                  }}>
                    {/* Header */}
                    <Box sx={{ 
                      p: isSmallScreen?1:2, 
                      border:'1px solid yellow',
                      borderBottom: 1, 
                      borderColor: 'divider', 
                      background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'space-between',
                      boxShadow: '0 4px 25px rgba(224, 242, 254, 0.4)',
                      position: 'relative',
                      zIndex: 10
                    }}>
                      {/* Back button for mobile */}
                      {isMdDown && (
                        <IconButton 
                          onClick={handleBackToChatList}
                          sx={{ 
                            color: 'white',
                            mr: 0,
                            ml: { xs: -1, sm: 0 },
                            display: { lg: 'none' }
                          }}
                        >
                          <ArrowBackIcon />
                        </IconButton>
                      )} 



                        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0, ml: { xs: isMdDown ? 0 : 2, sm: 1 } }} >
                          <Avatar sx={{
                            mr: 2,
                            bgcolor: 'rgba(255,255,255,0.2)',
                            color: 'white',
                            border: '2px solid rgba(255,255,255,0.3)',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                          }} onClick={handleAvatarClick}>
                            {selectedContact?.avatar}
                          </Avatar>
                          <Box
                            onMouseEnter={() => setShowLastSeen(true)}
                            onMouseLeave={() => setShowLastSeen(false)}
                            sx={{ cursor: 'pointer' }}
                          >
                            <Typography variant="h6" fontWeight={700} textTransform="capitalize" noWrap sx={{
                              color: 'white', textShadow: '0 1px 3px rgba(0,0,0,0.3)', overflow: 'hidden',
                              maxWidth: { xs: '130px', sm: '180px' },
                              textOverflow: 'ellipsis',
                            }}
                              onClick={handleAvatarClick}
                            >
                              {selectedContact?.name}
                            </Typography>

                          </Box>
                        </Box>




                        {/* Action Buttons */}

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: { xs: 'wrap', sm: 'nowrap' }, justifyContent: { xs: 'center', sm: 'flex-end' } }}>
                          {/* Show inline buttons on md+ */}

                          {/* currency icon  */}

                          {
                            selectedContact && (
                              <Tooltip title="Payment" arrow>
                                <Button
                                  variant="text"
                                  sx={{ fontWeight: 600, minWidth: 0, p: 1, display: { xs: 'none', sm: hidePaymentButton?'none':'inherit' } }}
                                  onClick={handlePaymentClick}
                                >
                                  <CurrencyRupeeIcon
                                    sx={{
                                      color: '#fff',
                                      border: '2px solid #fff',
                                      borderRadius: '50%',
                                      padding: '4px',
                                      fontSize: '2rem'
                                    }}
                                  />
                                </Button>
                              </Tooltip>
                            )
                          }

                          {/* chat view of center */}
                          {
                            selectedContact && (
                              <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>

                                {selectedContact?.ticketStatus !== 3 ? (
                                  <>
                                    {selectedContact?.ticketStatus === 2 ? (
                                      <Button disabled={disableTicketStatusButtons}  variant="contained" color="success" size="small" onClick={() => handleStatusUpdate(1)} sx={{ borderRadius: 10, textTransform: 'capitalize', fontWeight: 700 }}>
                                        Open
                                      </Button>
                                    ) : (
                                      <Button disabled={disableTicketStatusButtons}  variant="contained" color="warning" size="small" onClick={() => handleSetReminder()} sx={{ borderRadius: 10, textTransform: 'capitalize', fontWeight: 700 }}>
                                        Hold
                                      </Button>
                                    )}
                                    <Button disabled={disableTicketStatusButtons} variant="contained" color="error" size="small" onClick={() => handleStatusUpdate(3)} sx={{ borderRadius: 10, textTransform: 'capitalize', fontWeight: 700}}>
                                      Close
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    <Button disabled={disableTicketStatusButtons}  variant="contained" color="success" size="small" onClick={() => handleStatusUpdate(1)} sx={{ borderRadius: 10, textTransform: 'capitalize', fontWeight: 700 }}>
                                      Open
                                    </Button>
                                  </>
                                )}
                              </Box>
                            )
                          }


                          {/* Show 3-dot menu on xs/sm */}
                          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                              size="small"
                              onClick={handleActionMenuOpen}
                              sx={{ color: 'white' }}
                            >
                              <MoreVertIcon />
                            </IconButton>

                        <Menu
                          anchorEl={actionMenuAnchorEl}
                          open={isActionMenuOpen}
                          onClose={handleActionMenuClose}
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        >
                          {selectedContact?.ticketStatus !== 3 && (
                            <>
                              {selectedContact?.ticketStatus === 2 ? (
                                <MenuItem onClick={() => { handleStatusUpdate(1); handleActionMenuClose(); }}>
                                  Open
                                </MenuItem>
                              ) : (
                                <MenuItem onClick={() => { handleSetReminder(); handleActionMenuClose(); }}>
                                  Hold
                                </MenuItem>
                              )}
                              <MenuItem onClick={() => { handleStatusUpdate(3); handleActionMenuClose(); }}>
                                Close
                              </MenuItem>
                              <MenuItem onClick={() => { handleViewUserChat(); handleActionMenuClose(); }}>
                                View User Chat
                              </MenuItem>
                              <MenuItem onClick={handlePaymentClick}>
                                Payment
                              </MenuItem>
                            </>
                          )}
                        </Menu>
                      </Box>
                    </Box>
                </Box>
                
                {/* Scrollable chat area */}
                <Box
                  ref={chatAreaRef}
                  onScroll={handleScroll}
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    maxHeight: 'calc(100% - 65px)',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    p: 2,
                    pb: 3,
                    position: 'relative',
                    // background: 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
                    // Custom scrollbar styles
                    '&::-webkit-scrollbar': {
                      width: '6px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: 'rgba(0,0,0,0.2)',
                      borderRadius: '10px',
                      '&:hover': {
                        backgroundColor: 'rgba(0,0,0,0.3)',
                      }
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  {selectedContact?'':(
                    <Typography variant="h6" sx={{ fontWeight: 100, flex: 1, color: '#0088cc', display:'flex', alignItems:'center' ,justifyContent:'center' }}>Please select a chat.......</Typography>
                  )}
                  {chatLoading ? (
                    <Box sx={{ p: 3, textAlign: 'center' }}>
                      <Typography variant="body2" sx={{ color: 'background.text', fontSize: '0.9rem' }}>
                        Loading messages...
                      </Typography>
                    </Box>
                  ) : chatError ? (
                    <Box sx={{ p: 3, textAlign: 'center' }}>
                      <Typography variant="body2" sx={{ color: 'red', fontSize: '0.9rem' }}>
                        {chatError}
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      {/* Loading indicator for pagination */}
                      {chatPagination.isLoadingMore && (
                        <Box sx={{ p: 2, textAlign: 'center', borderBottom: '1px solid #e0e0e0' }}>
                          <CircularProgress size={20} />
                          <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
                            Loading more messages...
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Pagination info */}
                      {chatPagination.totalCount > 0 && (
                        <Box sx={{ p: 1, textAlign: 'center', borderBottom: '1px solid #e0e0e0' }}>
                          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            Showing {chatHistory.length} of {chatPagination.totalCount} messages
                            {chatPagination.hasNextPage && ' • Scroll up to load more'}
                          </Typography>
                        </Box>
                      )}
                      
                      {chatHistory.map((item, idx, arr) => {
                        // console.log('aswin',item);
                        
                        //  Get timestamp and format as readable date
                        const ts = item.timestamp ? new Date(item.timestamp) : null;

                        // format time for the days 
                        const formatDate = (date) => {
                        const now = new Date();
                        const diffDays = Math.floor((now.setHours(0, 0, 0, 0) - new Date(date.setHours(0, 0, 0, 0))) /(1000 * 60 * 60 * 24));
                        if (diffDays === 0) return 'TODAY';
                        if (diffDays === 1) return 'YESTERDAY';
                        return date.toLocaleDateString('en-GB', {day: 'numeric',month: 'long',year: 'numeric',}).toUpperCase();
                        };

                        const dateStr =ts && !isNaN(ts.getTime()) ? formatDate(new Date(ts)) : '';


                        //  Get previous item’s date (to know when the date changes)
                        const prev = idx > 0 ? arr[idx - 1] : null;

                        const prevDateStr =prev && prev.timestamp? formatDate(new Date(prev.timestamp)): '';

                        //  Show date separator only once per date
                        const showDateSeparator =idx === 0 ? !!dateStr : dateStr !== prevDateStr;

                        const isReconnectMessage = item.isReconnectMessage===true;

                        // To fetch the service and show in the comment section
                        const serviceIdForComment = item.commentService || item.service;

                        const serviceName = serviceIdForComment
                          ? services.find(s => String(s._id) === String(serviceIdForComment))?.TA_Service_Name
                          : null;

                          


                      //   if (item.type === 'missed_call') {
                      //     return (
                      //       <Box key={idx} sx={{ 
                      //         mb: 2, 
                      //         display: 'flex', 
                      //         justifyContent: 'center', 
                      //         alignItems: 'flex-start', 
                      //         gap: 1,
                      //         animation: 'fadeInUp 0.4s ease-out',
                      //         '@keyframes fadeInUp': {
                      //           '0%': {
                      //             opacity: 0,
                      //             transform: 'translateY(20px)'
                      //           },
                      //           '100%': {
                      //             opacity: 1,
                      //             transform: 'translateY(0)'
                      //           }
                      //         }
                      //       }}>
                      //     <Paper
                      //       sx={{ 
                      //         p: 1.5,   
                      //         background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)',
                      //         borderRadius: 4, 
                      //         minWidth: 180, 
                      //         maxWidth: 200, 
                      //         boxShadow: '0 8px 25px rgba(255, 107, 107, 0.3)',
                      //         border: '1px solid rgba(255,255,255,0.2)',
                      //         transition: 'all 0.3s ease',
                      //         '&:hover': {
                      //           transform: 'translateY(-3px)',
                      //           boxShadow: '0 12px 35px rgba(255, 107, 107, 0.4)',
                      //         }
                      //       }}
                      //       onContextMenu={e => handleMissedCallContextMenu(e, idx)}
                      //     >
                      //       <Typography sx={{ 
                      //         color: 'white', 
                      //         fontWeight: 700,
                      //         textShadow: '0 1px 3px rgba(0,0,0,0.3)',
                      //         fontSize: '0.9rem'
                      //       }}>
                      //         Missed Call
                      //       </Typography>
                      //       <Typography variant="caption" sx={{ 
                      //         color: 'rgba(255,255,255,0.9)',
                      //         fontWeight: 500,
                      //         fontSize: '0.75rem'
                      //       }}>
                      //         {item.timestamp}
                      //       </Typography>
                      //     </Paper>
                      //     {item.comment && (
                      //       <Box sx={{ position: 'relative', ml: 1,mt:1 }}>
                      //         {/* Comment icon button */}
                      //         <Tooltip title="View Comment" arrow>
                      //           <Box
                      //             onClick={() =>
                      //               setExpandedAccordion(expandedAccordion === idx ? false : idx)
                      //             }
                      //             sx={{
                      //               width: 34,
                      //               height: 34,
                      //               bgcolor:
                      //                 expandedAccordion === idx
                      //                   ? 'rgba(34,197,94,0.15)'
                      //                   : 'rgba(34,197,94,0.08)',
                      //               borderRadius: '50%',
                      //               display: 'flex',
                      //               alignItems: 'center',
                      //               justifyContent: 'center',
                      //               boxShadow:
                      //                 expandedAccordion === idx
                      //                   ? '0 0 0 3px rgba(34,197,94,0.2)'
                      //                   : '0 3px 6px rgba(0,0,0,0.1)',
                      //               cursor: 'pointer',
                      //               transition: 'all 0.25s ease',
                      //               '&:hover': {
                      //                 transform: 'scale(1.05)',
                      //                 boxShadow: '0 0 0 3px rgba(34,197,94,0.25)',
                      //               },
                      //             }}
                      //           >
                      //             <ChatBubbleOutlineRoundedIcon
                      //               sx={{
                      //                 fontSize: 18,
                      //                 color: expandedAccordion === idx ? '#15803d' : '#16a34a',
                      //                 transition: 'color 0.2s ease',
                      //               }}
                      //             />
                      //           </Box>
                      //         </Tooltip>

                      //         {/* Comment popover card */}
                      //         <Collapse in={expandedAccordion === idx}>
                      //           <Paper
                      //             elevation={3}
                      //             sx={{
                      //               mt: 1,
                      //               p: 1.5,
                      //               minWidth: 220,
                      //               maxWidth: 260,
                      //               borderRadius: 3,
                      //               bgcolor: '#ffffff',
                      //               boxShadow: '0 8px 24px rgba(15,23,42,0.12)',
                      //               border: '1px solid rgba(148,163,184,0.15)',
                      //               transition: 'all 0.25s ease',
                      //             }}
                      //           >
                      //             <Typography
                      //               sx={{
                      //                 fontWeight: 600,
                      //                 fontSize: 13,
                      //                 color: '#0f172a',
                      //                 mb: 0.5,
                      //               }}
                      //             >
                      //               Comment
                      //             </Typography>

                      //             <Typography
                      //               sx={{
                      //                 fontSize: 13,
                      //                 color: '#111827',
                      //                 lineHeight: 1.5,
                      //                 whiteSpace: 'pre-wrap',
                      //                 wordBreak: 'break-word',
                      //               }}
                      //             >
                      //               {item.comment}
                      //             </Typography>

                      //             {/* {item.commentTimestamp && (
                      //               <Typography
                      //                 variant="caption"
                      //                 sx={{
                      //                   display: 'flex',
                      //                   alignItems: 'center',
                      //                   gap: 0.5,
                      //                   mt: 1.25,
                      //                   fontSize: 11,
                      //                   color: '#9ca3af',
                      //                 }}
                      //               >
                      //                 <AccessTimeRoundedIcon sx={{ fontSize: 13 }} />
                      //                 {new Date(item.commentTimestamp).toLocaleString([], {
                      //                   day: '2-digit',
                      //                   month: 'short',
                      //                   hour: '2-digit',
                      //                   minute: '2-digit',
                      //                 })}
                      //               </Typography>
                      //             )} */}
                      //           </Paper>
                      //         </Collapse>
                      //       </Box>
                      //     )}

                      //   </Box>
                      // );
                      //   }
                    
                        // Check for call status
                        if (item.callStatus != null) {
                          // Determine positioning based on call status
                          const isIncomingCall = item.callStatus === 1; // Patient side - left
                          const isOutgoingCall = item.callStatus === 2; // Our side - right
                          const isMissedCall = item.callStatus === 3; // Missed - center
                          
                          return (
                            
                            <Box
                              key={idx}
                              sx={{
                                mt: 2,
                                display: 'flex',
                                flexDirection: 'column',        // 🔑 stack row + popup
                                width: '100%',
                                alignItems: {
                                  xs: 'center',
                                  sm: 'center',                  // phones & small tablets: center all
                                  md: isMissedCall
                                    ? 'center'
                                    : isOutgoingCall
                                    ? 'flex-end'
                                    : 'flex-start',             // md+ follow your logic
                                },
                                gap: 0.75,
                                animation: 'fadeIn 0.3s ease-out',
                                '@keyframes fadeIn': {
                                  '0%': { opacity: 0 },
                                  '100%': { opacity: 1 },
                                },
                              }}
                            >
                              {/* ROW: call pill + comment icon (always same line) */}
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: { xs: 0.75, sm: 1 },
                                  maxWidth: '100%',
                                }}
                              >
                                <Tooltip
                                  title={item.comment ? 'Click to edit comment' : 'Click to add comment'}
                                  arrow
                                >
                                  <Paper
                                    sx={{
                                      p: 1.25,
                                      background: isMissedCall
                                        ? 'linear-gradient(135deg, #f87171 0%, #ef4444 100%)'
                                        : isOutgoingCall
                                        ? 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)'
                                        : 'linear-gradient(135deg, #4ade80 0%, #22c55e 100%)',
                                      borderRadius: 999,
                                      minWidth: { xs: 'auto', sm: 180 },
                                      maxWidth: { xs: '80vw', sm: 'fit-content' },   // 🔑 better on phones
                                      boxShadow: isMissedCall
                                        ? '0 8px 25px rgba(239, 68, 68, 0.3)'
                                        : isOutgoingCall
                                        ? '0 8px 25px rgba(59, 130, 246, 0.3)'
                                        : '0 8px 25px rgba(34, 197, 94, 0.3)',
                                      border: '1px solid rgba(255,255,255,0.2)',
                                      transition: 'all 0.3s ease',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      '&:hover': {
                                        transform: 'translateY(-3px)',
                                        boxShadow: isMissedCall
                                          ? '0 12px 35px rgba(239, 68, 68, 0.4)'
                                          : isOutgoingCall
                                          ? '0 12px 35px rgba(59, 130, 246, 0.4)'
                                          : '0 12px 35px rgba(34, 197, 94, 0.4)',
                                      },
                                    }}
                                    onClick={() => handleCallCommentClick(idx)}
                                  >
                                    {isMissedCall ? (
                                      <CallMissedIcon fontSize="small" sx={{ mr: 0.75, color: 'white' }} />
                                    ) : isOutgoingCall ? (
                                      <CallMadeIcon fontSize="small" sx={{ mr: 0.75, color: 'white' }} />
                                    ) : (
                                      <CallReceivedIcon fontSize="small" sx={{ mr: 0.75, color: 'white' }} />
                                    )}

                                    <Typography
                                      sx={{
                                        color: 'white',
                                        fontWeight: 700,
                                        textShadow: '0 1px 3px rgba(0,0,0,0.3)',
                                        fontSize: { xs: '0.8rem', sm: '0.9rem' },
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {isMissedCall
                                        ? 'Missed Call'
                                        : isOutgoingCall
                                        ? 'Outgoing Call'
                                        : 'Incoming Call'}{' '}
                                      at{' '}
                                      {getOriginalCallTime(item)
                                        ? new Date(getOriginalCallTime(item)).toLocaleTimeString([], {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                          })
                                        : ''}
                                    </Typography>

                                    {item.comment && (
                                      <Box
                                        sx={{
                                          ml: 0.5,
                                          width: 6,
                                          height: 6,
                                          borderRadius: '50%',
                                          bgcolor: 'rgba(255,255,255,0.8)',
                                          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                        }}
                                      />
                                    )}
                                  </Paper>
                                </Tooltip>

                                {/* COMMENT ICON */}
                                {item.comment && (
                                  <Tooltip title="View Comment" arrow>
                                    <Box
                                      // onClick={() =>
                                      //   setExpandedAccordion(
                                      //     expandedAccordion === idx ? false : idx
                                      //   )
                                      // }
                                      onClick={() =>
                                        setCollapsedComment(
                                          collapsedComment === idx ? null : idx
                                        )
                                      }
                                      sx={{
                                        width: 32,
                                        height: 32,
                                        // bgcolor:
                                        //   expandedAccordion === idx
                                        //     ? 'rgba(34,197,94,0.15)'
                                        //     : 'rgba(34,197,94,0.08)',
                                        bgcolor:
                                          collapsedComment === idx
                                            ? 'rgba(34,197,94,0.15)'
                                            : 'rgba(34,197,94,0.08)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        // boxShadow:
                                        //   expandedAccordion === idx
                                        //     ? '0 0 0 3px rgba(34,197,94,0.2)'
                                        //     : '0 3px 6px rgba(0,0,0,0.1)',
                                        boxShadow:
                                          collapsedComment === idx
                                            ? '0 0 0 3px rgba(34,197,94,0.2)'
                                            : '0 3px 6px rgba(0,0,0,0.1)',
                                        cursor: 'pointer',
                                        transition: 'all 0.25s ease',
                                        '&:hover': {
                                          transform: 'scale(1.05)',
                                          boxShadow: '0 0 0 3px rgba(34,197,94,0.25)',
                                        },
                                      }}
                                    >
                                      <ChatBubbleOutlineRoundedIcon
                                        sx={{
                                          fontSize: 18,
                                          // color: expandedAccordion === idx ? '#15803d' : '#16a34a',
                                          color: collapsedComment === idx ? '#15803d' : '#16a34a',
                                          transition: 'color 0.2s ease',
                                        }}
                                      />
                                    </Box>
                                  </Tooltip>
                                )}
                              </Box>

                              {/* COMMENT CARD – centered under row, responsive width */}
                              {item.comment && (
                                // <Collapse in={expandedAccordion === idx}>
                                <Collapse in={collapsedComment !== idx}>
                                  <Box
                                    sx={{
                                      mt: 0.5,
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <Paper
                                      elevation={3}
                                      sx={{
                                        p: 1.25,
                                        // width: 'min(320px, 90vw)', 
                                        borderRadius: 3,
                                        bgcolor: '#ffffff',
                                        boxShadow: '0 8px 24px rgba(15,23,42,0.12)',
                                        border: '1px solid rgba(148,163,184,0.15)',
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontWeight: 600,
                                          fontSize: 13,
                                          color: '#0f172a',
                                          mb: 0.5,
                                        }}
                                      >
                                        Comment
                                      </Typography>

                                      <Typography
                                        sx={{
                                          fontSize: 13,
                                          color: '#111827',
                                          lineHeight: 1.5,
                                          whiteSpace: 'pre-wrap',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        {item.comment}
                                      </Typography>

                                      {serviceName && (
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            mt: 0.5,
                                            fontSize: 12,
                                            color: '#2563eb',
                                            fontWeight: 600,
                                          }}
                                        >
                                          Service: {serviceName}
                                        </Typography>
                                      )}
                                    </Paper>
                                  </Box>
                                </Collapse>
                              )}
                            </Box>

                            // <Box
                            //   key={idx}
                            //   sx={{
                            //     mt: 2,
                            //     display: 'flex',
                            //     flexDirection: 'column',
                            //     alignItems: {
                            //       xs: 'center',
                            //       sm: 'center',
                            //       md: isMissedCall
                            //         ? 'center'
                            //         : isOutgoingCall
                            //         ? 'flex-end'
                            //         : 'flex-start',
                            //     },
                            //     width: '100%',
                            //   }}
                            // >
                            //   {/* 🔹 Call pill + chat icon together */}
                            //   <Box
                            //     sx={{
                            //       display: 'flex',
                            //       alignItems: 'center',
                            //       justifyContent: 'center',
                            //       gap: 1,
                            //       flexWrap: 'nowrap',
                            //       position: 'relative',
                            //     }}
                            //   >
                            //     <Tooltip
                            //       title={item.comment ? 'Click to edit comment' : 'Click to add comment'}
                            //       arrow
                            //     >
                            //       <Paper
                            //         sx={{
                            //           p: { xs: 1.2, sm: 1.3 },
                            //           background: isMissedCall
                            //             ? 'linear-gradient(135deg, #f87171 0%, #ef4444 100%)'
                            //             : isOutgoingCall
                            //             ? 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)'
                            //             : 'linear-gradient(135deg, #4ade80 0%, #22c55e 100%)',
                            //           borderRadius: 999,
                            //           minWidth: { xs: 'auto', sm: 180 },
                            //           maxWidth: { xs: '80vw', sm: 'fit-content' },
                            //           boxShadow: isMissedCall
                            //             ? '0 8px 25px rgba(239, 68, 68, 0.3)'
                            //             : isOutgoingCall
                            //             ? '0 8px 25px rgba(59, 130, 246, 0.3)'
                            //             : '0 8px 25px rgba(34, 197, 94, 0.3)',
                            //           border: '1px solid rgba(255,255,255,0.25)',
                            //           cursor: 'pointer',
                            //           display: 'flex',
                            //           alignItems: 'center',
                            //           justifyContent: 'space-between',
                            //           transition: 'all 0.3s ease',
                            //           '&:hover': {
                            //             transform: 'translateY(-3px)',
                            //           },
                            //         }}
                            //         onClick={() => handleCallCommentClick(idx)}
                            //       >
                            //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            //           {isMissedCall ? (
                            //             <CallMissedIcon sx={{ color: 'white', fontSize: 18 }} />
                            //           ) : isOutgoingCall ? (
                            //             <CallMadeIcon sx={{ color: 'white', fontSize: 18 }} />
                            //           ) : (
                            //             <CallReceivedIcon sx={{ color: 'white', fontSize: 18 }} />
                            //           )}

                            //           <Typography
                            //             sx={{
                            //               color: 'white',
                            //               fontWeight: 700,
                            //               textShadow: '0 1px 3px rgba(0,0,0,0.3)',
                            //               fontSize: '0.9rem', // 🔸 consistent font size for all
                            //               whiteSpace: 'nowrap',
                            //             }}
                            //           >
                            //             {isMissedCall
                            //               ? 'Missed Call'
                            //               : isOutgoingCall
                            //               ? 'Outgoing Call'
                            //               : 'Incoming Call'}{' '}
                            //             at{' '}
                            //             {getOriginalCallTime(item)
                            //               ? new Date(getOriginalCallTime(item)).toLocaleTimeString([], {
                            //                   hour: '2-digit',
                            //                   minute: '2-digit',
                            //                 })
                            //               : ''}
                            //           </Typography>
                            //         </Box>

                            //         {/* Chat icon (right side inside pill) */}
                            //         {item.comment && (
                            //           <Box
                            //             onClick={(e) => {
                            //               e.stopPropagation(); // prevent bubble
                            //               setExpandedAccordion(
                            //                 expandedAccordion === idx ? false : idx
                            //               );
                            //             }}
                            //             sx={{
                            //               ml: 1,
                            //               width: 28,
                            //               height: 28,
                            //               borderRadius: '50%',
                            //               display: 'flex',
                            //               alignItems: 'center',
                            //               justifyContent: 'center',
                            //               bgcolor:
                            //                 expandedAccordion === idx
                            //                   ? 'rgba(255,255,255,0.25)'
                            //                   : 'rgba(255,255,255,0.15)',
                            //               transition: 'all 0.25s ease',
                            //               '&:hover': {
                            //                 transform: 'scale(1.1)',
                            //                 bgcolor: 'rgba(255,255,255,0.35)',
                            //               },
                            //             }}
                            //           >
                            //             <ChatBubbleOutlineRoundedIcon
                            //               sx={{
                            //                 fontSize: 16,
                            //                 color: 'white',
                            //               }}
                            //             />
                            //           </Box>
                            //         )}
                            //       </Paper>
                            //     </Tooltip>
                            //   </Box>

                            //   {/* 💬 Comment card */}
                            //   {item.comment && (
                            //     <Collapse in={expandedAccordion === idx}>
                            //       <Box
                            //         sx={(theme) => ({
                            //           mt: 1,
                            //           width: '100%',
                            //           display: 'flex',
                            //           justifyContent: {
                            //             xs: 'center',
                            //             sm: 'center',
                            //             md: isOutgoingCall ? 'flex-end' : 'center', // float right on big screens
                            //           },
                            //           position: 'relative',
                            //         })}
                            //       >
                            //         <Paper
                            //           elevation={4}
                            //           sx={{
                            //             p: 1.25,
                            //             borderRadius: 3,
                            //             bgcolor: '#ffffff',
                            //             boxShadow: '0 8px 20px rgba(15,23,42,0.12)',
                            //             border: '1px solid rgba(148,163,184,0.15)',
                            //             width: {
                            //               xs: 'min(320px, 90vw)', // mobile-friendly
                            //               md: 240,               // small floating box on big screens
                            //             },
                            //             mr: {
                            //               md: isOutgoingCall ? 2 : 0,
                            //             },
                            //             transition: 'all 0.25s ease',
                            //           }}
                            //         >
                            //           <Typography
                            //             sx={{
                            //               fontWeight: 600,
                            //               fontSize: 13,
                            //               color: '#0f172a',
                            //               mb: 0.5,
                            //             }}
                            //           >
                            //             Comment
                            //           </Typography>

                            //           <Typography
                            //             sx={{
                            //               fontSize: 13,
                            //               color: '#111827',
                            //               lineHeight: 1.5,
                            //               whiteSpace: 'pre-wrap',
                            //               wordBreak: 'break-word',
                            //             }}
                            //           >
                            //             {item.comment}
                            //           </Typography>

                            //           {serviceName && (
                            //             <Typography
                            //               variant="body2"
                            //               sx={{
                            //                 mt: 0.5,
                            //                 fontSize: 12,
                            //                 color: '#2563eb',
                            //                 fontWeight: 600,
                            //               }}
                            //             >
                            //               Service: {serviceName}
                            //             </Typography>
                            //           )}
                            //         </Paper>
                            //       </Box>
                            //     </Collapse>
                            //   )}
                            // </Box>

                          );
                        }

                        // Custom chat bubble - separate customer (left) from system (right)
                        const isSystemMessage = item.sender === 'system' || item.sender === 'user';
                        const isSystemOptions=item.sender;                
                        const isCustomerMessage = item.sender === 'customer';
                        const isReminderMessage = item.reminder === 'Reminder';
                        const isNewPatientMsg = isCustomerMessage && newMessageIds.length > 0 && item.id === newMessageIds[newMessageIds.length - 1];
                        const reconnectMessage = item?.templateType === 1;
                        const isServiceTemplate = item?.templateType === 2;
                        const isAIReplyMessage = !!(item?.metadata?.ai && item?.threadId?.startsWith('ai_'));



                        // console.log({reconnectMessage,isServiceTemplate})

                          // const bubbleBgColor = isServiceTemplate
                          //   ? 'red'               
                          //   : 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)'
                            // const bubbleBgColor = isServiceTemplate
                            //   ? 'linear-gradient(180deg,rgba(6, 151, 170, 1) 0%, #023149ff 100%)'
                            // : reconnectMessage
                            //   ? 'linear-gradient(135deg,rgba(180, 27, 27, 1) 0%, #580808ff 100%)'
                            // : isReminderMessage 
                            //   ? 'transparent'
                            // : isCustomerMessage 
                            //   ? 'transparent'
                            // :'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)';
                            const bubbleBgColor = isServiceTemplate
                              ? 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)'
                            : reconnectMessage
                              ? 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)'
                            : isReminderMessage 
                              ? 'transparent'
                            : isCustomerMessage 
                              ? 'transparent'
                            :'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)';
                        if(item.ticketRef == selectedContact?.id){
                          // console.log("item",item);
                          // handleIsTicketSeen(item.ticketRef);
                        }
                        // if(item.message.startsWith("{\"type\":")){
                        //   return false
                        // }
                        
                        return (
                          <React.Fragment key={idx}>
                            {/*  DATE SEPARATOR */}
                            {showDateSeparator && !isReconnectMessage && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  my: 2,
                                }}
                              >
                                <Box
                                  sx={{
                                    px: 2.5,
                                    py: 0.5,
                                    borderRadius: 12,
                                    bgcolor: '#e5e5e5',
                                    color: '#4a4a4a',
                                    fontWeight: 700,
                                    fontSize: '0.85rem',
                                    letterSpacing: 1,
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                                    border: '1px solid #d0d0d0',
                                    textTransform: 'uppercase',
                                    fontFamily: 'inherit',
                                  }}
                                >
                                  {dateStr}
                                </Box>
                              </Box>
                            )}
                            <Box
                              key={idx}
                              sx={{
                                display: 'flex',
                                justifyContent: isReminderMessage ? 'center' : isSystemMessage ? 'flex-end' : 'flex-start',
                                alignItems: 'flex-start',
                                animation: 'slideIn 0.3s ease-out',
                                '@keyframes slideIn': {
                                  '0%': {
                                    opacity: 0,
                                    transform: isSystemMessage ? 'translateX(20px)' : 'translateX(-20px)'
                                  },
                                  '100%': {
                                    opacity: 1,
                                    transform: 'translateX(0)'
                                  }
                                }
                              }}
                            >
                              <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: isSystemMessage ? 'flex-end' : 'flex-start',
                                mb: 0.5,
                              }}>
                                {/*  Show createdBy user’s name */}
                                {item.createdBy &&
                                  loggedInUser && String(item.createdBy) !== String(loggedInUser) &&
                                  item.reminder !== 'Reminder' && (
                                    <>
                                      {(() => {
                                        let matchedUser = item.assignedUsers?.find(
                                          (u) =>
                                            String(u.id) === String(item.createdBy) ||
                                            String(u._id) === String(item.createdBy)
                                        );

                                        //  If not found, look in global userList
                                        if (!matchedUser && Array.isArray(userList) && userList.length > 0) {
                                          matchedUser = userList.find(
                                            (u) =>
                                              String(u.id) === String(item.createdBy) ||
                                              String(u._id) === String(item.createdBy)
                                          );
                                        }

                                        if (!matchedUser) return null;

                                        const name =
                                          matchedUser?.TA_User_Name ||
                                          matchedUser?.name ||
                                          matchedUser?.email ||
                                          'Unknown User';

                                        // const avatar = name.charAt(0).toUpperCase();
                                        return (
                                          <>
                                          {/* <Box sx={{minWidth: 150, maxWidth: '75%',}}> */}
                                            <Typography variant="caption"
                                              sx={{
                                                fontSize: '0.7rem', color: '#6b7280', fontStyle: 'italic', fontWeight: 400, mb: 0.3, 
                                                textAlign: isSystemMessage ? 'right' : '',textTransform:'capitalize', display:isSystemMessage?'flex':'none',
                                              }}
                                              > 
                                              {name} </Typography>
                                          {/* </Box> */}
                                          </>
                                        );
                                      })()}
                                    </>
                                  )}

                                <Box 
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: isSystemMessage ? 'flex-end' : 'flex-start',
                                  gap: 1,
                                  width: '100%',
                                }}>
                                {isSystemOptions=='system' && (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.5 ,mt:1,mr:1 }}>
                                      <Box sx={{ width:'30px',height:'30px',bgcolor: 'rgba(255,255,255,0.7)', borderRadius: '50%', boxShadow: '0 2px 8px rgba(0,0,0,0.10)', p: 0.5, mb: 0.2, transition: 'all 0.2s', '&:hover': { bgcolor: 'rgba(255,255,255,1)', transform: 'scale(1.15)' } }}>
                                        <ArrowForwardRoundedIcon sx={{ cursor:'pointer',position:'relative',left:'4px',top:'2px',fontSize: 16, color: '#555' }} onClick={() => handleForwardMessage(idx)} />
                                      </Box>
                                      <Box sx={{ width:'30px',height:'30px',bgcolor: 'rgba(255,255,255,0.7)', borderRadius: '50%', boxShadow: '0 2px 8px rgba(0,0,0,0.10)', p: 0.5, transition: 'all 0.2s', '&:hover': { bgcolor: 'rgba(255,255,255,1)', transform: 'scale(1.15)' } }}>
                                        <PersonAddAlt1RoundedIcon sx={{ cursor:'pointer',position:'relative',left:'4px',top:'2px',fontSize: 16, color: '#555' }} onClick={() => handleAssignUser(idx)} />
                                      </Box>
                                    </Box>
                                  
                                )}
                                {/*    */}
                                <Paper
                                  sx={{
                                    borderRadius: isSystemMessage ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                                    p: 1.5,
                                    minWidth: 150,
                                    maxWidth: isReminderMessage ? 'auto' : 400,
                                    overflowWrap: 'break-word',
                                    whiteSpace: 'pre-wrap',
                                    boxShadow: isReminderMessage ? 'none' : isSystemMessage 
                                      ? '0 4px 20px rgba(20,83,45,0.15)' 
                                      : theme.palette.mode === 'dark'
                                      ? '0 4px 20px rgba(0, 0, 0, 0.3)'
                                      : '0 4px 20px rgba(0, 0, 0, 0.08)',
                                    // background: isReminderMessage ? 'transparent' : isSystemMessage 
                                    //   ? 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)' 
                                    //   : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                    background:bubbleBgColor,
                                    ml: isSystemMessage ? 0 : 0,
                                    mr: isSystemMessage ? 0 : 4,
                                    textAlign: 'left',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: isSystemMessage ? 'flex-end' : 'flex-start',
                                    wordBreak: 'break-word',
                                    border: isReminderMessage ? 'none' :isSystemMessage ? 'none' : '1px solid rgba(0,0,0,0.05)',
                                    transition: 'all 0.3s ease',
                                    position: 'relative',
                                    pb: 1.5,
                                  }}
                                  onContextMenu={e => handleMsgContextMenu(e, idx)}
                                >
                                    {/* <Typography fontWeight={700} sx={{ 
                                      mb: 0.3, 
                                      color: isSystemMessage ? 'white' : '#2d3748',
                                      textShadow: isSystemMessage ? '0 1px 2px rgba(0,0,0,0.2)' : 'none',
                                      fontSize: '0.9rem',
                                    }}>
                                    {item.name} 
                                  </Typography> */}
                                  
                                  {typeof item.message === 'string' &&
                                    !item?.message.startsWith('{\"address\"') &&
                                    !item?.message.startsWith('[{\"name\":') &&
                                    (item.message.length > 200 || /[\n\r\t]/.test(item.message)) ? (

                                      (() => {
                                        const isServiceTemplate = item?.templateType === 0;
                                        const isReminderMessage = item?.reminder === 'Reminder';

                                        if(item?.attachments.length !== 0){
                                          // console.log("item",item);
                                          if(item?.attachments[0]?.TD_Document_Type === 'Image'){
                                            return (
                                              // Render an image for image messages
                                              <img
                                                src={item?.attachments[0]?.TD_File_Path || ''}
                                                alt="Image message"
                                                style={{
                                                  maxWidth: '100%',
                                                  maxHeight: '400px',
                                                  borderRadius: 8,
                                                  marginBottom: 8,
                                                  display: 'block',
                                                  background: isSystemMessage ? 'rgba(255,255,255,0.15)' : '#f7fafc',
                                                }}
                                              />
                                            )
                                          }
                                          if(item?.attachments[0]?.TD_Document_Type === 'Document'){
                                            return (
                                              // Render an image for image messages 
                                              <iframe
                                              src={'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(item?.attachments[0]?.TD_File_Path) || ''}
                                              title="Document"
                                              style={{
                                                width: '100%',
                                                height: 400,
                                                border: 'none',
                                                background: '#ffffff00',
                                              }}
                                              allow="autoplay"
                                            />
                                            )
                                          }
                                          if(item?.attachments[0]?.TD_Document_Type === 'PDF'){
                                            return (
                                              // Render an image for image messages 
                                              <iframe
                                              src={item?.attachments[0]?.TD_File_Path || ''}
                                              title="Document"
                                              style={{
                                                width: '100%',
                                                height: 400,
                                                border: 'none',
                                                background: '#ffffff00',
                                              }}
                                              allow="autoplay"
                                            />
                                            )
                                          }
                                          if(item?.attachments[0]?.TD_Document_Type === 'Video'){
                                            return(
                                              // Render a video for video messages
                                              <iframe
                                                src={item?.attachments[0]?.TD_File_Path || ''}
                                                title="Video"
                                                style={{
                                                  width: '100%',
                                                  height: 400,
                                                  border: 'none',
                                                  background: '#ffffff00',
                                                }}
                                                allow="autoplay"
                                              />
                                            )
                                          }
                                        }
                                        

                                        return (
                                          <Typography
                                            component="pre"
                                            sx={{
                                              whiteSpace: 'pre-wrap',
                                              overflowWrap: 'break-word',
                                              fontFamily: 'monospace',
                                              fontSize: 12,
                                              // bgcolor: bubbleBgColor,   
                                              p: 1,
                                              borderRadius: 2,
                                              maxWidth: '100%',
                                              mb: 0.5,
                                              color: isSystemMessage ? 'white' : '#2d3748',
                                            }}
                                          >
                                            { !isReminderMessage ? (
                                              <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: 12,color:theme.palette.mode === 'dark'? (isSystemMessage ? 'black' : '#d1d5db') : (isSystemMessage ? 'white' : 'black'),}}>
                                                {item?.message && item.message.length > 100 ? (
                                                  !isExpanded ? (
                                                    <>
                                                      <p>{item.message.substring(0, 100)}...</p>
                                                      <a onClick={toggleMessage} style={{cursor: 'pointer', fontWeight: '700',}}>Read more</a>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <p>{item.message}</p>
                                                      <a onClick={toggleMessage} style={{cursor: 'pointer',fontWeight: '700',}}>Read less</a>
                                                    </>
                                                  )
                                                ) : (
                                                  <>
                                                    <span style={{color: theme.palette.mode === 'dark'? 'black' : 'white'}}>{item?.message}</span>
                                                    <Divider sx={{ my: 1 , borderColor:theme.palette.mode === 'dark'? 'black' : 'white' }}/>
                                                  </>
                                                )}
                                              </p>
                                            ):(
                                              <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                ml:isSmallScreen? 2:'',
                                                width:'100%',
                                                // border:'1px solid red',
                                              }}>
                                                <Typography sx={{
                                                  whiteSpace: 'pre-wrap',
                                                  overflowWrap: 'break-word',
                                                  fontFamily: 'monospace',
                                                  fontSize: isSmallScreen?9:12,
                                                  fontWeight: 'bold',
                                                  color: '#727272',
                                                  bgcolor: item.message.slice(0, 18) == 'Reminder activated' ? '#e6ffe6' : '#ffffd8' || '#eaeaea',
                                                  borderRadius: '50px',
                                                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                  maxWidth: '100%',
                                                  mb: 0.5,
                                                  padding: '8px 15px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  gap: 1
                                                }}>
                                                  {item.message.slice(0, 50)}...
                                                  <Box
                                                    sx={{ width: 30, height: 30, bgcolor: 'rgba(255,255,255,0.7)', borderRadius: '50%', display:'flex',alignItems:'center', justifyContent:'center',
                                                      boxShadow: '0 2px 8px rgba(0,0,0,0.10)', p: 0.5, mb: 0.2, transition: 'all 0.2s', '&:hover': { bgcolor: 'rgba(255,255,255,1)', transform: 'scale(1.15)' } }}
                                                  >
                                                    <ArrowForwardRoundedIcon sx={{cursor: 'pointer',fontSize: 17,color: '#555',transform: 'rotate(90deg)',}} onClick={() => setOpenReminderModal({ data: item.message, open: true })} />
                                                  </Box>
                                                </Typography>
                                              </Box>
                                            )
                                            }
                                          </Typography>
                                        );
                                      })()

                                    ) : (()=>{
                                    if(item.message == 'None' || item?.message.startsWith('{\"address\"') || item?.message.startsWith('{\"latitude\"') || item?.message.startsWith('[{\"name\":') || item?.message.startsWith("{\"type\":") ){
                                      if(item?.metadata?.data?.message?.message_content_type == 'Location'){
                                        // console.log(item);
                                        const locationObj = JSON.parse(item?.message);
                                        const location = {
                                          address :locationObj?.address,
                                          latitude :locationObj?.latitude,
                                          longitude :locationObj?.longitude,

                                          name :locationObj?.name,
                                          url :locationObj?.url,
                                        };

                                        return (
                                          <Box
                                            sx={{
                                              width: {
                                                xs: '100%',    // 100% width on extra-small screens
                                                sm: '350px',   // 350px on small screens
                                                md: '450px',   // 450px on medium screens
                                                lg: '500px',   // 500px on large screens and up
                                              },
                                              maxWidth: '100%',
                                            }}
                                          >
                                            <CustomLocationLoader data={location} />

                                            <Box marginTop={2} >
                                              <Typography variant="h5" sx={{ color: '#cc6d6d' }} >
                                                {location.name}
                                              </Typography>
                                              <Typography sx={{ fontSize:'0.9rem',color: '#888' }}>
                                                {location.address}
                                              </Typography>
                                              <a href={location.url} target="_blank" rel="noopener noreferrer"> {location.url}</a>
                                            </Box>
                                          </Box>
                                        );
                                      }
                                      
                                      if(item?.metadata?.data?.message?.message_content_type == 'Video'){
                                        return(
                                          // Render a video player for video messages
                                          <Box
                                            sx={{
                                              width: {
                                                xs: '100%',    // 100% width on extra-small screens
                                                sm: '350px',   // 350px on small screens
                                                md: '450px',   // 450px on medium screens
                                                lg: '500px',   // 500px on large screens and up
                                              },
                                              maxWidth: '100%',
                                            }}
                                          >
                                            <CustomVideoPlayer
                                              src={item?.metadata?.data?.message?.media_url}
                                              accentColor="#3b82f6" // You can customize this
                                            />
                                          </Box>
                                        )
                                      }
                                      
                                      if (item?.message.startsWith("{\"type\":")) {
                                        try {
                                          const parsed = JSON.parse(item.message);
                                          const title = parsed?.button_reply?.title || parsed?.list_reply?.title || 'Unknown Action';

                                          return (
                                            <>
                                              <Typography
                                                sx={{
                                                  whiteSpace: 'pre-wrap',
                                                  overflowWrap: 'break-word',
                                                  fontFamily: 'monospace',
                                                  fontSize: 12,
                                                  p: 1,
                                                  borderRadius: 2,
                                                  maxWidth: '100%',
                                                  mb: 0.5,
                                                  color: isSystemMessage ? 'white' : 'black',
                                                }}
                                              >
                                                {title}
                                              </Typography>
                                            </>
                                          );
                                        } catch (e) {
                                          console.error('Invalid JSON:', e);
                                          return null;
                                        }
                                      }
                                      
                                      if (item?.metadata?.data?.message?.message_content_type == 'Audio') {
                                        return (
                                          // Render an audio player for audio messages
                                            <CustomAudioPlayer
                                              src={item?.metadata?.data?.message?.media_url}
                                              accentColor={isSystemMessage ? '#6c5ce7' : '#3b82f6'}
                                              badgeLabel={item?.metadata?.data?.message?.message_content_type === 'Audio' ? 'audio' : undefined}
                                            />
                                        )
                                      }
                                      
                                      if (item?.metadata?.data?.message?.message_content_type == 'Document') {
                                        return (
                                          // Render an embedded document viewer for document messages
                                          <Box
                                            sx={{
                                              width: {
                                                xs: '100%',
                                                sm: '350px',
                                                md: '450px',
                                                lg: '500px',
                                              },
                                              maxWidth: '100%',
                                              // minHeight: 300,
                                              background: isSystemMessage ? 'rgba(255,255,255,0.15)' : '#f7fafc',
                                              borderRadius: 2,
                                              overflow: 'hidden',
                                              mb: 1,
                                            }}
                                          >
                                            {/* <iframe
                                              src={item?.metadata?.data?.message?.media_url}
                                              title="Document"
                                              style={{
                                                width: '100%',
                                                height: 400,
                                                border: 'none',
                                                background: '#fff',
                                              }}
                                              allow="autoplay"
                                            /> */}
                                            <Box
                                              component="a"
                                              href={item?.metadata?.data?.message?.media_url}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              sx={{
                                                display: 'inline-block',
                                                px: 2,
                                                py: 1,
                                                width: '100%',
                                                background: isSystemMessage ? '#6c5ce7' : '#3b82f6',
                                                color: '#fff',
                                                fontWeight: 600,
                                                borderRadius: 2,
                                                textAlign: 'center',
                                                textDecoration: 'none',
                                                boxShadow: '0 2px 8px 0 rgba(60,60,60,0.08)',
                                                transition: 'background 0.2s, box-shadow 0.2s',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                  background: isSystemMessage ? '#5e4cb2' : '#2563eb',
                                                  boxShadow: '0 4px 16px 0 rgba(60,60,60,0.12)',
                                                  textDecoration: 'none',
                                                },
                                              }}
                                            >
                                              Open Document
                                            </Box>
                                          </Box>
                                        )
                                      }
                                      
                                      if (item?.metadata?.data?.message?.message_content_type == 'Image') {
                                        return (
                                          // Render an image for image messages
                                          <img
                                            src={item?.metadata?.data?.message?.media_url}
                                            alt="Image message"
                                            style={{
                                              maxWidth: '100%',
                                              maxHeight: '400px',
                                              borderRadius: 8,
                                              marginBottom: 8,
                                              display: 'block',
                                              background: isSystemMessage ? 'rgba(255,255,255,0.15)' : '#f7fafc',
                                            }}
                                          />
                                        )
                                      }
                                      
                                      if (item?.metadata?.data?.message?.message_content_type == 'Contact'){
                                        const contacts = JSON.parse(item.message)
                                        // // // console.log({contacts})
                                        return (
                                          // <CustomLocationLoader data={item?.message} />
                                          <>
                                            {contacts.map((contact, index) => (
                                              <Box
                                                key={index}
                                                sx={{
                                                  mb: 1, borderRadius: 2, p:1, cursor: 'pointer',
                                                  '&:hover': { background: '#c9e2ff6e' },
                                                  '&:active': { background: '#c9e2ff6e' },
                                                }}
                                                onClick={() => {
                                                  const phoneNumber = contact?.phones?.[0]?.wa_id || contact?.phones?.[0]?.phone;
                                                  // // // console.log('clicked');
                                                  
                                                  if (navigator?.clipboard?.writeText && phoneNumber) {
                                                    // // // console.log('clicked2');
                                                    navigator.clipboard.writeText(phoneNumber);
                                                    setCustomSnackbarOpen({
                                                      open: true,
                                                      data: {
                                                        name: 'Contact Copied',
                                                        message: 'Phone number copied to clipboard',
                                                        type: 'message',
                                                      },
                                                      severity: 'success',
                                                    });
                                                  }
                                                  else{
                                                    // // console.log('error');
                                                    
                                                  }
                                                }}
                                              >
                                                {/* Top Label */}
                                                <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 300, mb: 0.5 }} >
                                                  Contact Shared
                                                </Typography>

                                                {/* Main Content Row */}
                                                <Box display="flex" alignItems="center" gap={1}>
                                                  <Avatar src={contact?.image_url} alt={contact?.name?.formatted_name} sx={{ width: 32, height: 32 }} />

                                                  <Box display="flex" flexDirection="column" sx={{ lineHeight: 1.2 }}>
                                                    <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 600 }}>
                                                      {contact?.name?.formatted_name || 'Unknown Name'}
                                                    </Typography>

                                                <Typography variant="caption" color="text.secondary">
                                                  {contact?.phones?.[0]?.phone || 'No Phone Available'}
                                                </Typography>
                                              </Box>
                                            </Box>
                                          </Box>
                                        ))}
                                      </>
                                    )
                                      }

                                    } else {

                                    const isReconnectMessage = item?.templateType === 1;
                                    const isReminderMessage = item?.reminder === 'Reminder';

                                      return (
                                        <>  
                                          {!isReminderMessage ? (
                                            <Typography 
                                              // sx={{
                                              //   whiteSpace: 'pre-wrap',
                                              //   overflowWrap: 'break-word',
                                              //   fontFamily: 'monospace',
                                              //   fontSize: 12,
                                              //   p: 1,
                                              //   borderRadius: 2,
                                              //   maxWidth: '100%',
                                              //   mb: 0.5,
                                              //   color:isSystemMessage?'white':'black',
                                              // }}
                                              sx={(theme)=>({
                                                whiteSpace: 'pre-wrap',
                                                overflowWrap: 'break-word',
                                                fontFamily: 'monospace',
                                                fontSize: 12,
                                                p: 1,
                                                borderRadius: 2,
                                                maxWidth: '100%',
                                                mb: 0.5,
                                                color: theme.palette.mode === 'dark'? (isSystemMessage ? 'black' : '#d1d5db') : (isSystemMessage ? 'white' : 'black'),
                                              })} 
                                            >
                                              { isReconnectMessage || isAIReplyMessage ? (
                                                <>
                                                  <span>{item.message}</span>
                                                  <Divider sx={{ my: 1 , borderColor:theme.palette.mode === 'dark'? 'black' : 'white' }}/>  
                                                </>
                                                ):(
                                                  <span>{item.message}</span>
                                                )
                                              }
                                            </Typography>
                                          ):(
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                ml:isSmallScreen? 2:'',
                                                width:'100%',
                                                // border:'1px solid red',
                                              }}>
                                                <Typography sx={{
                                                  whiteSpace: 'pre-wrap',
                                                  overflowWrap: 'break-word',
                                                  fontFamily: 'monospace',
                                                  fontSize: isSmallScreen?9:12,
                                                  fontWeight: 'bold',
                                                  color: '#727272',
                                                  bgcolor: item.message.slice(0, 18) == 'Reminder activated' ? '#e6ffe6' : '#ffffd8' || '#eaeaea',
                                                  borderRadius: '50px',
                                                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                  maxWidth: '100%',
                                                  mb: 0.5,
                                                  padding: '8px 15px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  gap: 1
                                                }}>
                                                  {item.message.slice(0, 50)}...
                                                  <Box
                                                    sx={{ width: 30, height: 30, bgcolor: 'rgba(255,255,255,0.7)', borderRadius: '50%', display:'flex',alignItems:'center', justifyContent:'center',
                                                      boxShadow: '0 2px 8px rgba(0,0,0,0.10)', p: 0.5, mb: 0.2, transition: 'all 0.2s', '&:hover': { bgcolor: 'rgba(255,255,255,1)', transform: 'scale(1.15)' } }}
                                                  >
                                                    <ArrowForwardRoundedIcon sx={{cursor: 'pointer',fontSize: 17,color: '#555',transform: 'rotate(90deg)',}} onClick={() => setOpenReminderModal({ data: item.message, open: true })} />
                                                  </Box>
                                                </Typography>
                                              </Box>
                                          )
                                          }
                                        </>
                                      )
                                    }
                                  })()}
                                    {/* Debug: Show forwarded messages count */}
                                    {item.id === chatHistory[0]?.id && (
                                      <Typography variant="caption" sx={{ color: 'red', fontSize: '0.5rem' }}>
                                      </Typography>
                                    )}
                                    {forwardedMessages.has(item.id) && (
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          mt: 0.5,
                                          color: isSystemMessage ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.4)',
                                          fontSize: '0.6rem',
                                          fontStyle: 'italic',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 0.3
                                        }}
                                      >
                                        <ForwardIcon sx={{ fontSize: 12 }} />
                                        Forwarded
                                      </Typography>
                                    )}
                                    <Typography variant="caption" sx={{
                                      width: '100%',
                                      alignSelf: 'flex-end',
                                      color: isSystemMessage?'white':'rgba(0, 0, 0, 0.5)',
                                      fontSize: '0.65rem',
                                      fontWeight: 500,
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}>
                                      {
                                        (()=>{
                                          if(item?.templateType == 1){
                                            return <span style={{color: theme.palette.mode === 'dark'? 'black' : 'white', marginLeft:7}} >Reconnect template message </span>
                                          }
                                          else if(item?.templateType == 2){
                                            return <span style={{color: theme.palette.mode === 'dark'? 'black' : 'white', marginLeft:7}} >Service template</span>
                                          }
                                          else if(isAIReplyMessage){
                                            return <span style={{color: theme.palette.mode === 'dark'? 'black' : 'white', marginLeft:7}} >AI Generated Reply</span>
                                          }
                                          return null;
                                        })()
                                      }
                                      <span style={{color: theme.palette.mode === 'dark'? (isSystemMessage ? 'black' : '#d1d5db') : (isSystemMessage ? 'white' : 'black'), marginLeft: 'auto' }}> 
                                        {(() => {
                                          if (!item?.timestamp) return 'Now';
                                            try {
                                              let timestampStr = item?.timestamp;
                                              if (typeof timestampStr === 'string' && !timestampStr.includes('Z') && !timestampStr.includes('+') && !timestampStr.includes('-', 10)) {
                                                timestampStr = timestampStr + 'Z';
                                              }
                                              const messageDate = new Date(timestampStr);
                                              if (isNaN(messageDate.getTime())) return 'Now';
                                              const now = new Date();
                                              const timeDiffMs = now.getTime() - messageDate.getTime();
                                              const timeDiffMinutes = timeDiffMs / (1000 * 60);
                                              if (timeDiffMinutes < 1) {
                                                return 'Now';
                                              }
                                              // Show only the time at which the message was received
                                              return messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                                            } catch (error) {
                                              console.error('Timestamp error:', error);
                                              return 'Now';
                                            }
                                        })()}
                                      </span>                    
                                    </Typography>
                                    {item.assignedUsers && item.assignedUsers.length > 0 && (
                                      <Box sx={{ mt: 1, display: 'flex', width: '100%', justifyContent: isSystemMessage ? 'flex-end' : 'flex-start', gap: 0.5 }}>
                                        {item.assignedUsers.map(user => {
                                          const userName = user?.TA_User_Name ||user?.user_name ||user?.name ||user?.username ||'';
                                          const avatar = userName?userName.charAt(0).toUpperCase() : '' ;
                                          return (
                                            <Tooltip key={user.id} title={userName} arrow>
                                              <Avatar
                                                sx={{ width: 24, height: 24, fontSize: 13, fontWeight: 700, bgcolor: '#166534',
                                                  color: 'white', boxShadow: '0 2px 8px rgba(20,83,45,0.18)', }}
                                              >
                                                {avatar}
                                              </Avatar>
                                            </Tooltip>
                                          )
                                        })}
                                      </Box>
                                    )}
                            </Paper>
                          </Box>
                          </Box>
                                {/* {!isSystemMessage && !isReminderMessage && (
                                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.5, ml: '-16px' }}>
                                    <Box sx={{ width: '30px', height: '30px', bgcolor: 'rgba(255,255,255,0.7)', borderRadius: '50%', boxShadow: '0 2px 8px rgba(0,0,0,0.10)', p: 0.5, mb: 0.2, transition: 'all 0.2s', '&:hover': { bgcolor: 'rgba(255,255,255,1)', transform: 'scale(1.15)' } }}>
                                      <ArrowForwardRoundedIcon sx={{ cursor: 'pointer', position: 'relative', left: '4px', top: '2px', fontSize: 16, color: '#555' }} onClick={() => handleForwardMessage(idx)} />
                                    </Box>
                                    <Box sx={{ width: '30px', height: '30px', bgcolor: 'rgba(255,255,255,0.7)', borderRadius: '50%', boxShadow: '0 2px 8px rgba(0,0,0,0.10)', p: 0.5, transition: 'all 0.2s', '&:hover': { bgcolor: 'rgba(255,255,255,1)', transform: 'scale(1.15)' } }}>
                                      <PersonAddAlt1RoundedIcon sx={{ cursor: 'pointer', position: 'relative', left: '4px', top: '2px', fontSize: 16, color: '#555' }} onClick={() => handleAssignUser(idx)} />
                                    </Box>
                                  </Box>
                                )} */}
                            </Box>
                          </React.Fragment>  
                          );
                        })}
                        
                      </>
                    )}
                    {
                      !selectedContact?.addressArray?.length && selectedContact && (
                        <Box>
                          <Box sx={{width:'100%',height:'40px',bgcolor:"",display:AddressLine?'none':'flex',justifyContent:'center',alignItems:'center'}} >
                            <Typography sx={{color:'#ff7700',fontSize:'12px'}} >Address information for this patient is missing. Kindly provide the complete address</Typography>
                          </Box>
                        </Box>
                      )
                    }
                  </Box>

                      {/* Scroll to bottom button */}
                      {showScrollToBottom && (
                        <Fab
                          size="small"
                          color="primary"
                          onClick={scrollToBottom}
                          sx={{
                            position: 'absolute',
                            bottom: 80,
                            right: 20,
                            zIndex: 1000,
                            boxShadow: 3,
                          }}
                        >
                          {/* <Badge badgeContent={unreadCount > 0 ? unreadCount : null} color="error">
                          <KeyboardArrowDownIcon />
                        </Badge> */}
                          <KeyboardArrowDownIcon />
                        </Fab>
                      )}

                      {/* Input area if a contact is selected then only show*/}

                      {selectedContact && (
                        <Box sx={(theme) => ({
                          p: { xs: 1.8, md: 2.2 },
                          display: 'flex',
                          alignItems: 'center',
                          gap: { xs: 0.8, md: 1 },
                          background: theme.palette.mode === 'dark' 
                            ? 'linear-gradient(135deg, #23272f 0%, #1a1d23 100%)'
                            : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                          position: 'relative',
                          height: { xs: 65, md: 72 },
                          flexShrink: 0,
                          zIndex: 10,
                          minHeight: { xs: 65, md: 72 },
                          maxHeight: { xs: 65, md: 72 },
                          boxShadow: theme.palette.mode === 'dark'
                            ? '0 -8px 32px rgba(0,0,0,0.3)'
                            : '0 -8px 32px rgba(0,0,0,0.08)',
                          backdropFilter: 'blur(20px)',
                          borderTop: theme.palette.mode === 'dark'
                            ? '1px solid rgba(255,255,255,0.1)'
                            : '1px solid rgba(0,0,0,0.06)',
                          mb: 0
                        })}>
                          <TextField
                            fullWidth
                            placeholder="Type a message..."
                            value={inputMessage}
                            onChange={e => setInputMessage(e.target.value)}
                            onKeyDown={handleKeyDown}
                            multiline
                            minRows={1}
                            maxRows={3}
                            sx={(theme) => ({
                              bgcolor: theme.palette.mode === 'dark'
                                ? 'rgba(60, 65, 75, 0.8)'
                                : 'rgba(255,255,255,0.95)',
                              borderRadius: 8,
                              backdropFilter: 'blur(20px)',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 8,
                                boxShadow: theme.palette.mode === 'dark'
                                  ? '0 4px 20px rgba(0,0,0,0.3)'
                                  : '0 4px 20px rgba(0,0,0,0.08)',
                                border: theme.palette.mode === 'dark'
                                  ? '1px solid rgba(255,255,255,0.15)'
                                  : '1px solid rgba(0,0,0,0.06)',
                                background: theme.palette.mode === 'dark'
                                  ? 'rgba(60, 65, 75, 0.9)'
                                  : 'rgba(255,255,255,0.9)',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&.Mui-focused': {
                                  boxShadow: theme.palette.mode === 'dark'
                                    ? '0 6px 30px rgba(40, 158, 212, 0.2)'
                                    : '0 6px 30px rgba(99, 102, 241, 0.15)',
                                  background: theme.palette.mode === 'dark'
                                    ? 'rgba(70, 75, 85, 1)'
                                    : 'rgba(255,255,255,1)',
                                  border: theme.palette.mode === 'dark'
                                    ? '1px solid rgba(40, 158, 212, 0.3)'
                                    : '1px solid rgba(99, 102, 241, 0.3)',
                                }
                              },
                              '& .MuiInputBase-input': {
                                fontSize: { xs: '0.65rem', md: '0.8rem' },
                                padding: { xs: '0px 4px', md: '6px 14px' },
                                lineHeight: 1.3,
                                color: theme.palette.mode === 'dark' ? '#e5e7eb' : '#1f2937',
                                fontWeight: 400,
                              },
                              '& .MuiInputBase-input::placeholder': {
                                color: theme.palette.mode === 'dark' ? '#6b7280' : '#9ca3af',
                                opacity: 1,
                                fontWeight: 400,
                              }
                            })}
                            InputProps={{
                              endAdornment: (
                                <IconButton
                                  onClick={handleImportClick}
                                  size="small"
                                  sx={{
                                    ml: 1,
                                    background: "#289ed4ff",
                                    color: 'white',
                                    borderRadius: '50%',
                                    boxShadow: '0 2px 8px rgba(20,83,45,0.15)',
                                    border: '2px solid #3aaedbff',
                                    transition: 'all 0.2s',
                                    '&:hover': {
                                      background: "#289ed4ff",
                                      transform: 'scale(1.12)',
                                      boxShadow: '0 4px 16px rgba(20,83,45,0.25)',
                                    },
                                  }}
                                >
                                  <AttachFileRoundedIcon sx={{ fontSize: 18 }} />
                                  <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    multiple
                                  />
                                </IconButton>
                              )
                            }}
                          />
                          <Tooltip title="Send" arrow>
                            <IconButton
                              onClick={handleSend}
                              disabled={sending}
                              sx={{
                                background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                                color: 'white',
                                width: { xs: 42, md: 46 },
                                height: { xs: 42, md: 46 },
                                borderRadius: '50%',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: '0 6px 25px rgba(20,83,45,0.3)',
                                flexShrink: 0,
                                position: 'relative',
                                overflow: 'hidden',
                                '&:hover': {
                                  transform: 'scale(1.1) translateY(-3px)',
                                  boxShadow: '0 10px 35px rgba(20,83,45,0.4)',
                                },
                                '&:active': {
                                  transform: 'scale(0.95) translateY(0px)',
                                }
                              }}
                            >
                              <SendIcon sx={{ fontSize: { xs: 18, md: 20 }, position: 'relative', zIndex: 1, transform: 'rotate(-90deg)' }} />
                            </IconButton>
                          </Tooltip>

                          {/* Reminder icon */}

                          <Tooltip title="Set Reminder" arrow>
                            <IconButton
                              onClick={handleSetReminder}
                              disabled={isReminderActivated(selectedContact?.id)}
                              sx={{
                                background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                                color: 'white',
                                width: { xs: 42, md: 46 },
                                height: { xs: 42, md: 46 },
                                borderRadius: '50%',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: '0 6px 25px rgba(20,83,45,0.3)',
                                flexShrink: 0,
                                position: 'relative',
                                overflow: 'hidden',
                                '&:hover': {
                                  transform: 'scale(1.1) translateY(-3px)',
                                  boxShadow: '0 10px 35px rgba(20,83,45,0.4)',
                                },
                                '&:active': {
                                  transform: 'scale(0.95) translateY(0px)',
                                },
                                cursor: isReminderActivated(selectedContact?.id) ? 'not-allowed' : 'pointer',
                              }}
                            >
                              <AccessAlarmIcon sx={{ fontSize: { xs: 18, md: 20 }, position: 'relative', zIndex: 1 }} />
                            </IconButton>
                          </Tooltip>

                        </Box>
                      )}



                    </Paper>
                </Grid>

                {/* Right Panel: Contact Details */}
                <Grid item xs={12} lg={3} md={3} sx={{
                  display: {
                    xs: showContactDetails ? 'flex' : 'none',
                    lg: 'flex'
                  },
                  flexDirection: 'column',
                  minHeight: 0,
                  height: '100%',
                  order: { xs: 1, lg: 1 }
                }}>
                  {/* First Contact Details Box (now on top) */}
                  {/* <Paper sx={{ p: 2, minHeight: 0, flexShrink: 0, borderRadius: 3 }}>
                  <Typography variant="h6">Contact Details</Typography>
                  {selectedContact ? (
                    <>
                      <Typography variant="subtitle1" sx={{ mt: 2, color:'background.text' }}>{selectedContact.name}</Typography>
                      <Typography variant="body2" color="background.text">Phone: +91 1234567890</Typography>
                      <Typography variant="body2" color="background.text">Email: -</Typography>
                      <Typography variant="body2" color="background.text" sx={{ mt: 1 }}>
                        Status: {isNearBottom ? 'Viewing latest messages' : 'Scrolled up'}
                      </Typography>
                    </>
                  ) : (
                    <Typography variant="body2">Select a contact to view details.</Typography>
                  )}
                </Paper> */}

                  {/* Second Contact Details Box (now below) */}
                  <Paper sx={{
                    flex: 1, display: 'flex',
                    flexDirection: 'column', minHeight: 0, p: 0, position: 'relative', height: '500px', overflow: 'hidden',
                    borderRadius: 3,
                    // border: '1px solid red'
                  }}>
                    {/* Header */}
                    <Box sx={{
                      p: 1.5,
                      borderBottom: 1,
                      borderColor: 'divider',
                      background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      boxShadow: '0 4px 25px rgba(224, 242, 254, 0.4)'
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {/* Back button for mobile */}
                        {isMdDown && (
                          <IconButton
                            onClick={() => {
                              setShowContactDetails(false);
                              setShowChatView(true);
                            }}
                            sx={{
                              color: 'white',
                              mr: 0.5,
                              ml: -0.5,
                              display: { lg: 'none' }
                            }}
                          >
                            <ArrowBackIcon />
                          </IconButton>
                        )}
                        <Typography variant="h6" fontWeight={700} sx={{ color: 'white', textShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                          User Chat
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>

                        {/* Payment template menu */}
                        {/* <Menu
                        anchorPaymentEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                      >
                        <MenuItem onClick={() => { handleTemplateAction('main-menu'); handleClose(); }}>
                          <Button variant="text" sx={{ fontWeight: 600 }}>Main Menu</Button>
                        </MenuItem>
                      </Menu> */}



                        {/* Trigger Button  - For creating template messages */}
                        {/* <IconButton onClick={handleMenuClick} sx={{ color: 'white' }}>
                          <MenuIcon />
                        </IconButton> */}

                        {/* Dropdown Menu - Template message menus  */}
                        {/* <Menu
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        >
                          <MenuItem onClick={() => { handleTemplateAction('main-menu'); handleClose(); }}>
                            <Button variant="text" sx={{ fontWeight: 600 }}>Main Menu</Button>
                          </MenuItem>
                          <MenuItem onClick={() => { handleTemplateAction('feedback'); handleClose(); }}>
                            <Button variant="text" sx={{ fontWeight: 600 }}>Feedback</Button>
                          </MenuItem>
                        </Menu> */}


                        {/* Service Template Menu */}
                        {selectedContact &&(
                          <IconButton onClick={handleServiceModalOpen} sx={{ color: 'white' }}>
                          <MenuIcon />
                          </IconButton>
                          )}


                      </Box>

                    </Box>

                  {/* Scrollable chat area */}
                  <Box
                    ref={userChatAreaRef}
                    onScroll={handleUserChatScroll}
                    sx={{
                      flex: 1,
                      minHeight: 0,
                      height: '100%',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      p: 1.5,
                      pb: 2,
                      position: 'relative',
                      background: 'background.paper',
                      // Enable mouse wheel scrolling
                      scrollBehavior: 'smooth',
                      // Custom scrollbar styles
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,0.3)',
                        borderRadius: '3px',
                        '&:hover': {
                          backgroundColor: 'rgba(0,0,0,0.5)',
                        }
                      },
                      '&::-webkit-scrollbar-track': {
                        backgroundColor: 'rgba(0,0,0,0.05)',
                        borderRadius: '3px',
                      },
                      // Ensure scrolling works
                      '&::-webkit-scrollbar-corner': {
                        backgroundColor: 'transparent',
                      },
                      // Mouse wheel scrolling
                      '&:hover': {
                        cursor: 'default',
                      },
                      // Force scrollbar to always show
                      '&::-webkit-scrollbar-thumb:vertical': {
                        minHeight: '20px',
                      },
                    }}
                  >
                    {userChatHistory.filter((item) => { return item.isPublish }).map((item, idx , arr) => {
                      // console.log("item",item)

                      if (item?.callStatus==1) {
                        return (
                          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 1 }}>
                            <Paper elevation={0} sx={{ bgcolor: '#e8f5e9', px: 2, py: 1, borderRadius: 20, display: 'flex', alignItems: 'center', gap: 1 }}>
                              <CallReceivedIcon fontSize="small" color="success" />
                              <Typography variant="caption" sx={{ color: 'success.main', fontWeight: 500 }}>
                                Received call • {item.timestamp ? new Date(item.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                              </Typography>
                            </Paper>
                          </Box>
                        )
                      }
                      if(item?.callStatus==2) {
                        return (
                          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 1 }}>
                            <Paper elevation={0} sx={{ bgcolor: '#e3f2fd', px: 2, py: 1, borderRadius: 20, display: 'flex', alignItems: 'center', gap: 1 }}>
                              <CallMadeIcon fontSize="small" color="primary" />
                              <Typography variant="caption" sx={{ color: '#1565c0', fontWeight: 500 }}>
                                Outgoing call • {item.timestamp ? new Date(item.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                              </Typography>
                            </Paper>
                          </Box>
                        )
                      }
                      if(item?.callStatus==3) {
                        return (
                          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 1 }}>
                            <Paper elevation={0} sx={{ bgcolor: '#fbe9e7', px: 2, py: 1, borderRadius: 20, display: 'flex', alignItems: 'center', gap: 1 }}>
                              <CallMissedIcon fontSize="small" color="warning" />
                              <Typography variant="caption" sx={{ color: 'warning.main', fontWeight: 500 }}>
                                Missed Call • {item.timestamp ? new Date(item.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                              </Typography>
                            </Paper>
                          </Box>
                        )
                      }
                        // Custom chat bubble
                      const isSystemMessage = item.sender === 'user' || item.sender === 'system';
                      item.name = item.sender === "customer" ? 'you' : 'System';


                        const ts = item.timestamp ? new Date(item.timestamp) : null;

                        // for format the date like today,yesterday,and dates
                        const formatDate = (date) => {
                        const now = new Date();
                        const diffDays = Math.floor((now.setHours(0, 0, 0, 0) - new Date(date.setHours(0, 0, 0, 0))) /(1000 * 60 * 60 * 24));
                        if (diffDays === 0) return 'TODAY';
                        if (diffDays === 1) return 'YESTERDAY';
                        return date.toLocaleDateString('en-GB', {day: 'numeric',month: 'long',year: 'numeric',}).toUpperCase();
                        };

                        const dateStr =ts && !isNaN(ts.getTime()) ? formatDate(new Date(ts)) : '';

                        const prev = idx > 0 ? arr[idx - 1] : null;

                        const prevDateStr =prev && prev.timestamp? formatDate(new Date(prev.timestamp)): '';

                        const showDateSeparator = idx === 0 ? !!dateStr : dateStr !== prevDateStr;

                        const isLeft = (item.sender === 'user' || item.sender === 'system');
                        const isSystemOptions=item.sender;                
                        const isCustomerMessage = item.sender === 'customer';
                        const isReminderMessage = item.reminder === 'Reminder';
                        const reconnectMessage = item?.templateType === 1;
                        const isServiceTemplate = item?.templateType === 2;

                            // const bubbleBgColor = isServiceTemplate
                            //   ? 'linear-gradient(180deg,rgba(6, 151, 170, 1) 0%, #023149ff 100%)'
                            // : reconnectMessage
                            //   ? 'linear-gradient(135deg,rgba(180, 27, 27, 1) 0%, #580808ff 100%)'
                            // : isReminderMessage 
                            //   ? 'transparent'
                            // : isCustomerMessage 
                            //   ? 'transparent'
                            // :'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)';
                            const bubbleBgColor = isServiceTemplate
                              ? 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)'
                            : reconnectMessage
                              ? 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)'
                            : isReminderMessage 
                              ? 'transparent'
                            : isCustomerMessage 
                              ? 'transparent'
                            :'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)';

                        return (
                          <React.Fragment key={item.id || idx}>



                            <Box
                          key={idx}
                          sx={{
                            display: 'flex',
                            justifyContent: !isSystemMessage ? 'flex-end' : 'flex-start',
                            alignItems: 'flex-start',
                            animation: 'slideIn 0.3s ease-out',
                            '@keyframes slideIn': {
                              '0%': {
                                opacity: 0,
                                transform: !isSystemMessage ? 'translateX(20px)' : 'translateX(-20px)'
                              },
                              '100%': {
                                opacity: 1,
                                transform: 'translateX(0)'
                              }
                            }
                          }}
                        >
                          {/* Right panel chat bubble */}
                          <Paper
                            sx={{
                              p: 1.2,
                              maxWidth:280,
                              borderRadius: 2,
                              // background: isSystemMessage ? 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)' : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                              background:bubbleBgColor,
                              color: isSystemMessage ? 'white' : 'black',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                              border: '1px solid rgba(243, 4, 4, 0.08)',
                              position: 'relative',
                              transition: 'all 0.3s ease',
                              '&:hover': {
                                transform: 'translateY(-1px)',
                                boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                              }
                            }}
                          >
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, wordBreak: 'break-word' ,alignItems:isSystemMessage?'flex-start':'flex-end'}}>
                              <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.3, fontSize: '0.95rem', color:theme.palette.mode === 'dark'? (isSystemMessage ? 'black' : '#d1d5db') : (isSystemMessage ? 'white' : 'black')}} >
                                {item.name}
                              </Typography>
                            </Box>

                            

                            {typeof item.message === 'string' && !hasMediaAttachment(item) && !item?.message.startsWith('{\"address\"') && !item?.message.startsWith('[{\"name\":') && (item.message.length > 200 || /[\n\r\t]/.test(item.message) ) ?
                              (
                                <Typography
                                  component="pre"
                                  sx={{
                                    whiteSpace: 'pre-wrap',
                                    overflowWrap: 'break-word',
                                    fontFamily: 'monospace',
                                    fontSize: 12,
                                    p: 1,
                                    borderRadius: 2,
                                    maxWidth: '100%',
                                    mb: 0.5,
                                    color: isSystemMessage ? 'white' : 'black',
                                    // border: isSystemMessage ? '1px solid rgba(255,255,255,0.2)' : '1px solid #e2e8f0'
                                  }}

                                >

                                  {/* State to track expanded/collapsed status */}

                                  <p style={{whiteSpace: 'pre-wrap',overflowWrap: 'break-word',fontSize: 12,color:theme.palette.mode === 'dark'? (isSystemMessage ? 'black' : '#d1d5db') : (isSystemMessage ? 'white' : 'black')}}>
                                    {item?.message && item.message.length > 100 ? (
                                    
                                    !isExpanded ? (
                                      <>
                                        <p>{item.message.substring(0, 100)}...</p>
                                        <a onClick={toggleMessage} style={{cursor: 'pointer',fontWeight:'700' }} >Read more</a>
                                      </>
                                      ) : (
                                      <>
                                        <p>{item.message}</p>
                                        <a onClick={toggleMessage} style={{cursor: 'pointer',fontWeight:'700' }} >Read less</a>
                                      </>
                                      )
                                      ) : (  
                                        item?.message
                                      )}
                                  </p>

                                </Typography>
                              ) : (() => {
                                if ( item.message=='None' || item?.message.startsWith('{\"address\"') || item?.message.startsWith('{\"latitude\"') || item?.message.startsWith('[{\"name\":') || item?.message.startsWith("{\"type\":") || hasMediaAttachment(item)) {

                                  let url = '';
                                  if(!hasMediaAttachment(item)){
                                    url = item?.metadata?.data?.message?.media_url;
                                  }else{
                                    url = item?.message;
                                  }

                                  if (item?.metadata?.data?.message?.message_content_type == 'Location') {
                                    const locationObj = JSON.parse(item?.message);
                                    const location = {
                                      address: locationObj?.address,
                                      latitude: locationObj?.latitude,
                                      longitude: locationObj?.longitude,
                                      name: locationObj?.name,
                                      url: locationObj?.url,
                                    };

                                    return (
                                      <Box
                                        sx={{
                                          width: {
                                            xs: '100%',    // 100% width on extra-small screens
                                            sm: '350px',   // 350px on small screen
                                            md: '450px',   // 450px on medium screens
                                            lg: '500px',   // 500px on large screens and up
                                          },
                                          maxWidth: '100%',
                                        }}
                                      >
                                        <CustomLocationLoader data={location} />

                                        <Box marginTop={2} >
                                          <Typography sx={{ fontSize: '1.15rem', color: '#cc6d6d' }} >
                                            {location.name}
                                          </Typography>
                                          <Typography sx={{ fontSize: '0.6rem', color: '#888' }}>
                                            {location.address}
                                          </Typography>
                                          <a href={location.url} style={{ fontSize: '0.6rem' }} target="_blank" rel="noopener noreferrer"> {location.url}</a>
                                        </Box>
                                      </Box>
                                    );
                                  }

                                  if (item?.message.startsWith("{\"type\":")) {
                                      try {
                                        const parsed = JSON.parse(item.message);
                                        const title = parsed?.button_reply?.title || parsed?.list_reply?.title || 'Unknown Action';

                                        return (
                                          <>
                                            <Typography
                                              sx={{
                                                whiteSpace: 'pre-wrap',
                                                overflowWrap: 'break-word',
                                                fontFamily: 'monospace',
                                                fontSize: 12,
                                                p: 1,
                                                borderRadius: 2,
                                                maxWidth: '100%',
                                                mb: 0.5,
                                                color: isSystemMessage ? 'white' : 'black',
                                              }}
                                            >
                                              {title}
                                            </Typography>
                                          </>
                                        );
                                      } catch (e) {
                                        console.error('Invalid JSON:', e);
                                        return null;
                                      }
                                    }


                                  if (item?.metadata?.data?.message?.message_content_type == 'Video') {
                                    return (
                                      // Render an audio player for audio mesages
                                      <Box
                                      sx={{
                                        width: {
                                          xs: '100%',    // 100% width on extra-small screens
                                          sm: '350px',   // 350px on small screens
                                          md: '450px',   // 450px on medium screens
                                          lg: '500px',   // 500px on large screens and up
                                        },
                                        maxWidth: '100%',
                                      }}
                                    >
                                      <CustomVideoPlayer src={item?.metadata?.data?.message?.media_url} accentColor="#3b82f6" />
                                    </Box>
                                    )
                                  }

                                  if (item?.metadata?.data?.message?.message_content_type == 'Audio') {
                                    return (
                                      // Render an audio player for audio messages
                                      <CustomAudioPlayer
                                        src={item?.metadata?.data?.message?.media_url}
                                        accentColor={isSystemMessage ? '#6c5ce7' : '#3b82f6'}
                                        badgeLabel={item?.metadata?.data?.message?.message_content_type === 'Audio' ? 'audio' : undefined}
                                      />
                                    )
                                  }

                                  if (item?.metadata?.data?.message?.message_content_type == 'Document') {
                                    return (
                                      // Render an embedded document viewer for document messages
                                      <Box
                                        sx={{
                                          width: {
                                            xs: '100%',
                                            sm: '350px',
                                            md: '450px',
                                            lg: '500px',
                                          },
                                          maxWidth: '100%',
                                          // minHeight: 300,
                                          background: isSystemMessage ? 'rgba(255,255,255,0.15)' : '#f7fafc',
                                          borderRadius: 2,
                                          overflow: 'hidden',
                                          mb: 1,
                                        }}
                                      >
                                        {/* <iframe
                                            src={item?.metadata?.data?.message?.media_url}
                                            title="Document"
                                            style={{
                                              width: '100%',
                                              height: 400,
                                              border: 'none',
                                              background: '#fff',
                                            }}
                                            allow="autoplay"
                                          /> */}
                                        <Box
                                          component="a"
                                          href={url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          sx={{
                                            display: 'inline-block',
                                            px: 2,
                                            py: 1,
                                            width: '100%',
                                            background: isSystemMessage ? '#6c5ce7' : '#3b82f6',
                                            color: '#fff',
                                            fontWeight: 600,
                                            borderRadius: 2,
                                            textAlign: 'center',
                                            textDecoration: 'none',
                                            boxShadow: '0 2px 8px 0 rgba(60,60,60,0.08)',
                                            transition: 'background 0.2s, box-shadow 0.2s',
                                            cursor: 'pointer',
                                            '&:hover': {
                                              background: isSystemMessage ? '#5e4cb2' : '#2563eb',
                                              boxShadow: '0 4px 16px 0 rgba(60,60,60,0.12)',
                                              textDecoration: 'none',
                                            }
                                          }}
                                        >
                                          Open Document
                                        </Box>
                                      </Box>
                                    )
                                  }

                                  if (item?.metadata?.data?.message?.message_content_type == 'Image') {
                                    return (
                                      // Render an image for image messages
                                      <img
                                        src={url}
                                        alt="Image message"
                                        style={{
                                          maxWidth: '100%',
                                          maxHeight: '400px',
                                          borderRadius: 8,
                                          marginBottom: 8,
                                          display: 'block',
                                          background: isSystemMessage ? 'rgba(255,255,255,0.15)' : '#f7fafc',
                                        }}
                                      />
                                    )
                                  }

                                  if (item?.metadata?.data?.message?.message_content_type == 'Contact') {
                                    const contacts = JSON.parse(item.message)
                                    // // // console.log({contacts})
                                    return (
                                      // <CustomLocationLoader data={item?.message} />
                                      <>
                                        {contacts.map((contact, index) => (
                                          <Box
                                            key={index}
                                            sx={{
                                              mb: 1, borderRadius: 2, p: 1, cursor: 'pointer',
                                              '&:hover': { background: '#c9e2ff6e' },
                                            '&:active': { background: '#c9e2ff6e' },
                                            }}
                                            onClick={() => {
                                              const phoneNumber = contact?.phones?.[0]?.wa_id;
                                              if (phoneNumber) {
                                                // Modern clipboard API
                                                if (navigator?.clipboard && navigator?.clipboard?.writeText) {
                                                  navigator?.clipboard?.writeText(phoneNumber)
                                                  setCustomSnackbarOpen({
                                                    open: true,
                                                    data: {
                                                      name: 'Contact Copied',
                                                      message: 'Phone number copied to clipboard',
                                                      type: 'message',
                                                    },
                                                    severity: 'success',
                                                  })
                                                  // .then(() => {
                                                  //   // // console.log('Phone number copied to clipboard');
                                                  // })
                                                  // .catch((err) => {
                                                  //   console.error('Failed to copy: ', err);
                                                  //   // Fallback to older method
                                                  //   fallbackCopyTextToClipboard(phoneNumber);
                                                  // });
                                                } else {
                                                  setCustomSnackbarOpen({
                                                    open: true,
                                                    data: {
                                                      name: 'Contact Not Copied',
                                                      message: 'Phone number not copied to clipboard',
                                                      type: 'message',
                                                    },
                                                    severity: 'error',
                                                  })
                                                  // Fallback for older browsers
                                                  // fallbackCopyTextToClipboard(phoneNumber);
                                                }
                                              }
                                            }}
                                          >
                                            {/* <Avatar src={contact?.image_url} sx={{ width: 24, height: 24 }} /> */}
                                            <Box display="flex" flexDirection="column">
                                              <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 300 }}>
                                                Contact Shared
                                              </Typography>

                                              <Typography variant="subtitle2" sx={{ color: 'primary.main' }}>
                                                {contact?.name?.formatted_name || "Unknown Name"}
                                              </Typography>

                                              <Typography variant="caption" color="text.secondary">
                                                {contact?.phones?.[0]?.phone || "No Phone Available"}
                                              </Typography>
                                            </Box>
                                          </Box>
                                        ))}
                                      </>
                                    )
                                  }
                                } else if(hasMediaAttachment(item)) {
                                  if (hasMediaAttachment(item?.attachments[0]?.TD_Document_Type === 'Image')) {
                                    return (
                                      // Render an image for image messages
                                      <img
                                        src={item?.attachments[0]?.TD_Document_URL}
                                        alt="Image message"
                                        style={{
                                          maxWidth: '100%',
                                          maxHeight: '400px',
                                          borderRadius: 8,
                                          marginBottom: 8,
                                          display: 'block',
                                          background: isSystemMessage ? 'rgba(255,255,255,0.15)' : '#f7fafc',
                                        }}
                                      />
                                    )
                                  }
                                }
                                
                                else {

                                  return (

                                    <Typography sx={{
                                      whiteSpace: 'pre-wrap',
                                      overflowWrap: 'break-word',
                                      fontFamily: 'monospace',
                                      fontSize: 12,
                                      // bgcolor: isSystemMessage ? 'rgba(255,255,255,0.2)' : '#f7fafc',
                                      p: 1,
                                      borderRadius: 2,
                                      maxWidth: '100%',
                                      mb: 0.5,
                                      // color: isSystemMessage ? 'white' : 'black',
                                      // border: isSystemMessage ? '1px solid rgba(255,255,255,0.2)' : '1px solid #e2e8f0'
                                      color: theme.palette.mode === 'dark'? (isSystemMessage ? 'black' : '#d1d5db') : (isSystemMessage ? 'white' : 'black'),
                                    }}>

                                      {item.message}

                                    </Typography>

                                  )

                                }
                              })()
                            }


                                  </Paper>
                                  </Box>


                            {showDateSeparator && (
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 2 }}>
                                <Box sx={{ px: 2.5, py: 0.5, borderRadius: 12, bgcolor: '#e5e5e5', color: '#4a4a4a', fontWeight: 700, fontSize: '0.85rem', letterSpacing: 1, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #d0d0d0', textTransform: 'uppercase', fontFamily: 'inherit' }}>
                                  {dateStr}
                                </Box>
                              </Box>
                            )}

                            {/* {item.type === 'missed_call' ? (
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 1 }}>
                                <Paper sx={{ p: 1.2, background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)', borderRadius: 3, minWidth: 150, maxWidth: 200, boxShadow: '0 6px 20px rgba(255, 107, 107, 0.3)' }}>
                                  <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '0.9rem' }}>Missed Call</Typography>
                                  <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 500 }}>{item.timestamp}</Typography>
                                </Paper>
                              </Box>
                            ) : item.callStatus === 1 ? (
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 1 }}>
                                <Paper elevation={0} sx={{ bgcolor: '#e8f5e9', px: 2, py: 1, borderRadius: 20, display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <CallReceivedIcon fontSize="small" color="success" />
                                  <Typography variant="caption" sx={{ color: 'success.main', fontWeight: 500 }}>
                                    Received call • {item.timestamp ? new Date(item.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                                  </Typography>
                                </Paper>
                              </Box>
                            ) : item.callStatus === 2 ? (
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 1 }}>
                                <Paper elevation={0} sx={{ bgcolor: '#e3f2fd', px: 2, py: 1, borderRadius: 20, display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <CallMadeIcon fontSize="small" color="primary" />
                                  <Typography variant="caption" sx={{ color: '#1565c0', fontWeight: 500 }}>
                                    Outgoing call • {item.timestamp ? new Date(item.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                                  </Typography>
                                </Paper>
                              </Box>
                            ) : item.callStatus === 3 ? (
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 1 }}>
                                <Paper elevation={0} sx={{ bgcolor: '#fbe9e7', px: 2, py: 1, borderRadius: 20, display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <CallMissedIcon fontSize="small" color="warning" />
                                  <Typography variant="caption" sx={{ color: 'warning.main', fontWeight: 500 }}>
                                    Missed Call • {item.timestamp ? new Date(item.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                                  </Typography>
                                </Paper>
                              </Box>
                            ) : (
                              <Box sx={{ display: 'flex', justifyContent: isLeft ? 'flex-start' : 'flex-end', my: 0.5 }}>
                                <Paper sx={{ p: 1.2, maxWidth: 280, borderRadius: 2, background: isLeft ? 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)' : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)', color: isLeft ? 'white' : 'black', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.3, fontSize: '0.95rem' }}>
                                    {item.sender === 'customer' ? 'you' : 'System'}
                                  </Typography>
                                  <Typography sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: 12 }}>
                                    {item.message}
                                  </Typography>
                                  <Typography variant="caption" sx={{ display: 'block', mt: 0.5, opacity: 0.7, fontSize: '0.65rem', textAlign: 'right' }}>
                                    {(() => {
                                      if (!item.timestamp) return 'Now';
                                      try {
                                        const d = new Date(item.timestamp);
                                        if (isNaN(d.getTime())) return 'Now';
                                        const diffMin = (Date.now() - d.getTime()) / 60000;
                                        return diffMin < 1 ? 'Now' : d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                                      } catch {
                                        return 'Now';
                                      }
                                    })()}
                                  </Typography>
                                </Paper>
                              </Box>
                          )} */}
                          </React.Fragment>
                        );
                      })}
                  </Box>

                    {/* Scroll to Bottom Button for User Chat */}
                    {showUserChatScrollToBottom && (
                      <Fab
                        size="small"
                        onClick={scrollUserChatToBottom}
                        sx={{
                          position: 'absolute',
                          bottom: 16,
                          right: 16,
                          background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                          color: 'white',
                          boxShadow: '0 4px 20px rgba(20,83,45,0.3)',
                          '&:hover': {
                            background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                            transform: 'scale(1.1)',
                            boxShadow: '0 6px 25px rgba(20,83,45,0.4)',
                          },
                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          zIndex: 10,
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </Fab>

                    )}

                    {/* Refreh Button */}
                    {/* <Box sx={{textAlign:'center'}}>
                      <IconButton
                            onClick={() => { refreshUserChat(); handleClose(); }}
                            disabled={refreshingUserChat}
                            sx={{
                              borderRadius: 2,
                              fontWeight: 600,
                              background: refreshingUserChat ? 'rgba(0,0,0,0.04)' : 'transparent',
                              transition: 'background 0.2s',
                              width:'100%'
                            }}
                            >
                            <RefreshIcon
                              sx={{
                                fontSize: 28,
                                color: refreshingUserChat ? 'grey.400' : 'primary.main',
                                animation: refreshingUserChat ? 'spin 1s linear infinite' : 'none',
                                '@keyframes spin': {
                                  '0%': { transform: 'rotate(0deg)' },
                                  '100%': { transform: 'rotate(360deg)' },
                                },
                              }}
                              />
                          </IconButton>
                    </Box> */}

                    {/* Unread Count Badge for User Chat */}

                  {userChatUnreadCount > 0 && (
                    <Fab
                      size="small"
                      onClick={scrollUserChatToBottom}
                      sx={{
                        position: 'absolute',
                        bottom: 16,
                        right: 16,
                        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                        color: 'white',
                        boxShadow: '0 4px 20px rgba(239, 68, 68, 0.4)',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                          transform: 'scale(1.1)',
                          boxShadow: '0 6px 25px rgba(239, 68, 68, 0.6)',
                        },
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        zIndex: 10,
                      }}
                    >
                      <Badge badgeContent={userChatUnreadCount} color="error">
                        <KeyboardArrowDownIcon />
                      </Badge>
                    </Fab>
                    )}



                  </Paper>
                </Grid>
            </Grid>
          </Box>

          {/* Context Menus and Dialogs for assigning a user for a particular chat */}
          <Dialog open={assignDialogOpen}  onClose={handleCloseAssignDialog} maxWidth="md" fullWidth
              PaperProps={{sx: {borderRadius: 4,p: 0,boxShadow: '0 8px 40px rgba(20,83,45,0.18)',minWidth: { xs: 420, sm: 600 },}}}>
            <DialogTitle sx={{display: 'flex',alignItems: 'center',gap: 1,fontWeight: 700,fontSize: '1.25rem',background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
              color: 'white',borderTopLeftRadius: 16,borderTopRightRadius: 16,py: 2,px: 3,}}>
              <PersonAddAlt1RoundedIcon sx={{ fontSize: 28, color: 'white', mr: 1 }} />
              Assign User
              <Typography variant="subtitle2" sx={{ ml: 2, color: 'rgba(255,255,255,0.8)', fontWeight: 400, fontSize: '1rem' }}>
                Assign this chat to one or more team members
              </Typography>
            </DialogTitle>
            <DialogContent sx={{px: 3,py: 3,bgcolor: 'background.paper',}}>
              {assignMsgIdx !== null && (
                <>
                  {(() => {
                    const message = chatHistory[assignMsgIdx];
                    const assignedAlready = message?.assignedUsers || [];
                    const createdById = message?.createdBy;

                    const availableUsers = userList
                      .filter((u) => {
                        const isAlreadyAssigned = assignedAlready.some(
                          (au) => String(au?._id || au?.id) === String(u.id)
                        );

                        if (isAlreadyAssigned) return false;

                        // If logged-in user == createdBy → show creator + others
                        if (String(loggedInUser) === String(createdById)) {
                          return true;
                        }

                        // If logged-in user != createdBy → hide creator
                        if (String(u.id) === String(createdById)) {
                          return false;
                        }

                        return true;
                      })
                      // exclude users already selected in dropdown (by ID)
                      .filter(
                        (u) => !assignUserValue.some((v) => String(v) === String(u.id))
                      )
                      // Service filter: only users whose role has selectedService
                      .filter((u) => userHasSelectedService(u))
                      // Search filter
                      .filter((u) =>
                        assignSearchQuery
                          ? u.name.toLowerCase().includes(assignSearchQuery.toLowerCase())
                          : true
                      );

                      return (
                        <Box>
                        <FormControl fullWidth margin="dense" sx={{ mt: 4 }}>
                          <InputLabel sx={{ color: 'background.text' }}>Select Service</InputLabel>
                          <Select
                            value={selectedService}
                            onChange={handleServiceChange}
                            label="Select Service"
                          >
                            {services.map((service) => (
                              <MenuItem key={service._id} value={service._id} sx={{ color: 'background.text' }}>
                                {service.TA_Service_Name}
                                {service.TA_Service_Amount && service.TA_Service_Amount > 0
                                  ? ` (₹${service.TA_Service_Amount})`
                                  : ' (Amount not set)'}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl fullWidth margin="dense" sx={{ mt: 1 }}>
                          <InputLabel id="assign-user-label">Select Users</InputLabel>
                            {/* <Select
                            labelId="assign-user-label"
                            multiple
                            value={assignUserValue}
                            label="Select Users"
                            onChange={(e) => {
                              setAssignUserValue(e.target.value);
                              setAssignSearchQuery('');
                            }}
                            renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    onMouseDown={(e) => e.stopPropagation()}
                                    onDelete={() => {
                                      setAssignUserValue((prev) =>
                                        prev.filter((id) => String(id) !== String(value))
                                      );
                                      setAssignSearchQuery('');
                                    }}
                                  />
                                ))}
                              </Box>
                            )}
                            MenuProps={{ PaperProps: { sx: { maxHeight: 360, width: 320, pt: 0 },}, }}
                            sx={{ minWidth: 320, borderRadius: 2, bgcolor: 'white', fontWeight: 500, fontSize: '1rem', boxShadow: '0 2px 8px rgba(20,83,45,0.06)',}}
                          >
                            <ListSubheader
                              disableSticky
                              sx={{ bgcolor: 'background.default', pt: 1.5, pb: 1, px: 1.5,}}
                            >
                              <SearchInput value={assignSearchQuery} onChange={(e) => setAssignSearchQuery(e.target.value)} onClear={() => setAssignSearchQuery('')}
                                sx={{ minWidth: '100%' }}
                                placeholder="Search users..."
                                onKeyDown={(e) => e.stopPropagation()}
                                onKeyUp={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                              />
                            </ListSubheader>

                            {availableUsers.length > 0 ? (
                              availableUsers.map((user) => (
                                <MenuItem key={user.id} value={user.name} sx={{color:'background.text'}}>
                                  <Checkbox checked={assignUserValue.some(v => String(v) === String(user.id))} />
                                  <ListItemText primary={user.name} />
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>
                                <ListItemText primary="All users already assigned or selected" />
                              </MenuItem>
                            )}
                            </Select> */}
                            <InputLabel id="assign-user-label" sx={{ color: 'background.text', }} > Select Users </InputLabel>
                            <Select
                            labelId="assign-user-label"
                            multiple
                            value={assignUserValue}
                            label="Select Users"
                            onChange={(e) => {
                              setAssignUserValue(e.target.value);  // array of user IDs
                              setAssignSearchQuery('');
                            }}
                            renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((userId) => {
                                  const user = userList.find(u => String(u.id) === String(userId));
                                  if (!user) return null;
                                  return (
                                    <Chip
                                      key={userId}
                                      label={user.name}
                                      size="small"
                                      onMouseDown={(e) => e.stopPropagation()}
                                      onDelete={() => {
                                        setAssignUserValue(prev =>
                                          prev.filter(id => String(id) !== String(userId))
                                        );
                                        setAssignSearchQuery('');
                                      }}
                                    />
                                  );
                                })}
                              </Box>
                            )}
                            MenuProps={{ PaperProps: { sx: { maxHeight: 360, width: 320, pt: 0 } }, MenuListProps: { disablePadding: true, autoFocusItem: false, onKeyDown: (e) => e.stopPropagation(),
                            } }}
                            sx={{ minWidth: 320, borderRadius: 2, bgcolor: 'background.paper', fontSize: '1rem', boxShadow: '0 2px 8px rgba(20,83,45,0.06)' }}
                          >
                            <ListSubheader
                              disableSticky
                              sx={{  pt: 1.5, pb: 1, px: 1.5 }}
                              onKeyDown={(e) => e.stopPropagation()}
                              onKeyUp={(e) => e.stopPropagation()}
                            >
                              <SearchInput
                                value={assignSearchQuery}
                                onChange={(e) => setAssignSearchQuery(e.target.value)}
                                onClear={() => setAssignSearchQuery('')}
                                sx={{ minWidth: '100%' }}
                                placeholder="Search users..."
                                onMouseDown={(e) => e.stopPropagation()}
                              />
                            </ListSubheader>

                            {availableUsers.length > 0 ? (
                              availableUsers.map((user) => (
                                <MenuItem key={user.id} value={user.id} sx={{ color: 'background.text' }}>
                                  <Checkbox checked={assignUserValue.some(v => String(v) === String(user.id))} />
                                  <ListItemText primary={user.name} />
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>
                                <ListItemText primary="All users already assigned or selected" />
                              </MenuItem>
                            )}
                          </Select>
                        </FormControl>
                        </Box>
                        );
                      })()}
                    </>
              )}
            </DialogContent>
            <DialogActions sx={{px: 3,pb: 2,bgcolor: 'background.paper',borderBottomLeftRadius: 16,borderBottomRightRadius: 16,}}>

              <Button onClick={handleCloseAssignDialog}  variant="outlined" sx={{borderRadius: 2,px: 3,py: 1,fontWeight: 600,borderColor: 'primary.main',color: 'primary.main',
                '&:hover': {borderColor: 'primary.dark',backgroundColor: 'rgba(0, 136, 204, 0.04)',},
                }} disabled={assignLoading}>
                Cancel
              </Button>
              <Button onClick={handleAssignUserSave} variant="contained" sx={{background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                color: 'white',fontWeight: 700,borderRadius: 2,px: 3,py: 1,boxShadow: '0 2px 8px rgba(34,197,94,0.15)',
                '&:hover': {background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',boxShadow: '0 4px 16px rgba(34,197,94,0.22)',},
                }} disabled={assignLoading}>
                {assignLoading ? 'Assigning...' : 'Assign'}
              </Button>
              {/* New button for the broadcast */}
              <Button  variant="contained" sx={{display:hideBroadCastButton?'none':'flex',background: 'linear-gradient(135deg,rgb(49, 174, 190) 0%, #0088cc 100%)',
                  color:'white',fontWeight: 700,borderRadius: 2,px: 3,py: 1,boxShadow: '0 2px 8px rgba(34,197,94,0.15)',
                '&:hover': {borderColor: 'primary.dark',backgroundColor: 'rgba(0, 136, 204, 0.04)',},
                }} disabled={assignLoading} onClick={handleBroadcastToMap}  >
                Broadcast
              </Button>

            </DialogActions>
          </Dialog>

          {/* comment dialog */}
          <Dialog open={commentDialogOpen} onClose={() => setCommentDialogOpen(false)}>
            <DialogTitle>Add Comment</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                label="Comment"
                type="text"
                fullWidth
                multiline
                minRows={2}
                value={commentValue}
                onChange={e => setCommentValue(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setCommentDialogOpen(false)}>Cancel</Button>
              <Button onClick={handleCommentSave} variant="contained">Save</Button>
            </DialogActions>
          </Dialog>

          {/* forward message dialog */}
          <Dialog open={forwardDialogOpen} onClose={() => setForwardDialogOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ color: 'background.text' }}>Forward Message</DialogTitle>
            <DialogContent>
              {hasForwardMedia  && (
              <Box sx={{ mb: 2, p: 1.5, border: "1px solid #e5e7eb", borderRadius: 2, background: "#fafafa" }}>
                <Typography variant="caption" sx={{ display: "block", mb: 1, color: "#6b7280" }}>
                {forwardPreviewNode}
                </Typography>
              </Box>
              )}
              {/* Existing message input */}
              {!hasForwardMedia && (
              <TextField
                autoFocus
                margin="dense"
                label="Message Content"
                type="text"
                fullWidth
                multiline
                minRows={3}
                maxRows={6}
                value={forwardMessageValue}
                onChange={e => setForwardMessageValue(e.target.value)}
              />
              )}
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setForwardDialogOpen(false)}>Cancel</Button>
              <Button onClick={handleForwardMessageSave} variant="contained" color="primary">Forward</Button>
            </DialogActions>
          </Dialog>

          {/* profile modal */}
          <Dialog open={profileModalOpen} onClose={() => setProfileModalOpen(false)} maxWidth="xs" fullWidth
            PaperProps={{
              sx: {
                borderRadius: 5,
                p: 0,
                boxShadow: '0 8px 40px rgba(0,136,204,0.18)',
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #e0f7fa 0%, #b2ebf2 100%)',
              }
            }}
          >
            <Box sx={{
              position: 'relative',
              p: 0,
              background: 'linear-gradient(135deg, #31aebe 0%, #0088cc 100%)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              pt: 5,
              pb: 3,
            }}>
              <IconButton
                onClick={() => setProfileModalOpen(false)}
                sx={{
                  position: 'absolute',
                  top: 12,
                  right: 12,
                  color: 'white',
                  background: 'rgba(0,0,0,0.08)',
                  '&:hover': { background: 'rgba(0,0,0,0.18)' },
                  zIndex: 2,
                }}
              >
                <CloseIcon />
              </IconButton>
              <Avatar sx={{
                width: 90,
                height: 90,
                fontSize: 38,
                fontWeight: 700,
                bgcolor: 'white',
                color: '#0088cc',
                boxShadow: '0 4px 24px rgba(0,136,204,0.18)',
                mb: 2,
                border: '4px solid #b2ebf2',
              }}>
                {selectedContact?.avatar || '?'}
              </Avatar>
              <Typography variant="h5" fontWeight={700} color="white" sx={{ textShadow: '0 2px 8px rgba(0,0,0,0.10)' }}>
                {selectedContact?.name || 'User'}
              </Typography>
              <Typography variant="body2" color="rgba(255,255,255,0.85)" sx={{ mb: 1 }}>
                User Profile
              </Typography>
            </Box>
            <Box sx={{ p: 3, pt: 2, background: 'white', borderBottomLeftRadius: 40, borderBottomRightRadius: 40 }}>
              <Typography variant="body2" sx={{ mb: 1, color: '#0088cc', fontWeight: 600 }}>
                <b>Phone:</b> +91 1234567890
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, color: '#0088cc', fontWeight: 600 }}>
                <b>Email:</b> user@example.com
              </Typography>
              {/* Add more details as needed */}
              <Button
                variant="contained"
                fullWidth
                sx={{
                  mt: 2,
                  background: 'linear-gradient(135deg, #31aebe 0%, #0088cc 100%)',
                  color: 'white',
                  fontWeight: 700,
                  borderRadius: 3,
                  boxShadow: '0 2px 8px rgba(0,136,204,0.12)',
                  py: 1.2,
                  fontSize: '1rem',
                  textTransform: 'none',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #0088cc 0%, #31aebe 100%)',
                  },
                }}
                onClick={handleAddToContact}
                startIcon={<PersonAddAlt1RoundedIcon />}
              >
                Add to Contact
              </Button>
            </Box>
          </Dialog>

          <CreateContactDialog
            open={addContactModalOpen}
            onClose={() => setAddContactModalOpen(false)}
            onSave={handleSaveContact}
            initialValues={addContactInitialValues}
          />

          {selectedContact?.ticketStatus === 3 && (
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h5" color="error" fontWeight={700}>
                Ticket closed.
              </Typography>
            </Box>
          )}

          {/* Add the Material-UI confirmation dialog at the bottom of the JSX */}
          <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
            <DialogTitle sx={{ color: 'background.text' }}>Confirm Action</DialogTitle>
            <DialogContent>
              <Typography sx={{ color: 'background.text' }}>
                {pendingTemplateAction
                  ? `Are you sure you want to ${pendingActionLabel}?`
                  : `Are you sure you want to ${pendingActionLabel} this ticket?`
                }
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setConfirmDialogOpen(false)} disabled={statusLoading}>Cancel</Button>
              <Button onClick={handleConfirmStatusUpdate} color="primary" disabled={statusLoading}>
                {statusLoading ? 'Processing...' : 'Confirm'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Edit Contact Dialog */}
          <Dialog open={editContactDialogOpen} onClose={() => setEditContactDialogOpen(false)} maxWidth="xs" maxHeight="xs" fullWidth>
            <DialogTitle>Edit Contact</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                value={editContactData.name}
                onChange={e => setEditContactData({ ...editContactData, name: e.target.value })}
                disabled={editContactLoading}
              />
              <TextField
                margin="dense"
                label="Phone"
                type="text"
                fullWidth
                value={editContactData.phone}
                onChange={e => setEditContactData({ ...editContactData, phone: e.target.value })}
                disabled
              />
              <TextField
                margin="dense"
                label="Email"
                type="email"
                fullWidth
                value={editContactData.email}
                onChange={e => setEditContactData({ ...editContactData, email: e.target.value })}
                disabled={editContactLoading}
              />

              <Box sx={{display:canAddressLine?'none':'flex',gap:1,justifyContent:'center',alignItems:'center'}}>
                <TextField
                  margin="dense"
                  label="Address Line"
                  type="Address"
                  fullWidth
                  value={addressData ? addressData[0]?.value : ""}
                  onChange={e => {
                    const newData = [...addressData];
                    newData[0] = { id: 0, value: e.target.value };
                    setAddressData(newData);
                  }}
                  disabled={editContactLoading}
                />
                <Tooltip title='Add another address line'>
                  <Box
                    sx={{
                      width: '35px',
                      height: "30px",
                      background: '#0088cc',
                      borderRadius: '10px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      transition: 'all ease-in-out 0.5s',
                      '&:hover': { background: "#004d74", transform: 'scale(1.1)' }
                    }}
                    onClick={() => setAddressData([...(addressData || []), { id: (addressData?.length || 0), value: "" }])}
                  >
                    <FontAwesomeIcon icon={faAdd} style={{ color: '#fff' }} />
                  </Box>
                </Tooltip>
              </Box>

              {addressData.length > 1 && addressData.slice(1).map((addr, ind) => (
                <TextField
                  key={addr.id}
                  margin="dense"
                  label={`Address Line ${ind + 2}`}
                  type="Address"
                  fullWidth
                  value={addr.value}
                  onChange={e => {
                    const newData = [...addressData];
                    newData[ind + 1] = { ...newData[ind + 1], value: e.target.value };
                    setAddressData(newData);
                  }}
                  disabled={editContactLoading}
                />
              ))}
              {/* <TextField
                margin="dense"
                label="Pincode"
                type="pincode"
                fullWidth
                sx={{display:canAddressLine?'none':'flex'}}
                value={editContactData.pincode}
                onChange={e => setEditContactData({ ...editContactData, pincode: e.target.value })}
                disabled={editContactLoading}
              /> */}
              <TextField
                margin="dense"
                label="Pincode"
                type="pincode"
                fullWidth
                value={editContactData.pincode}
                // onChange={e => setNewContact({ ...newContact, pincode: e.target.value })}
                onChange={(e) => {
                // Only allow up to 10 digits
                const val = e.target.value.replace(/[^\d]/g, '');
                if (!/^\d{0,6}$/.test(val)) return;
                setEditContactData({ ...editContactData, pincode: val });
                setCreateErrors({ ...createErrors, pincode: '' });
                setCreatePincodeError(val.length === 6 || val.length === 0 ? '' : 'Pincode must be 6 digits');
              }}
              disabled={editContactLoading}
              error={!!createErrors.pincode || !!createPincodeError}
              helperText={createErrors.pincode || createPincodeError}
              />
              <TextField
                margin="dense"
                label="Land Mark"
                type="landmark"
                fullWidth
                sx={{display:canAddressLine?'none':'flex'}}
                value={editContactData.landMark}
                onChange={e => setEditContactData({ ...editContactData, landMark: e.target.value })}
                disabled={editContactLoading}
              />
              <FormControl fullWidth margin="dense" disabled={editContactLoading || proListLoading} sx={{display:canHidePro?'none':'flex'}}>
                <InputLabel>PRO</InputLabel>
                <Select
                  value={editContactData.pro || ''}
                  onChange={e => setEditContactData({ ...editContactData, pro: e.target.value })}
                  label="PRO"
                >
                  <MenuItem value="">Select PRO</MenuItem>
                  {proList.map(pro => (
                    <MenuItem key={pro._id} value={pro._id}>
                      {pro.name} - {pro.phoneNumber}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {editContactError && <Typography color="error" sx={{ mt: 1 }}>{editContactError}</Typography>}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setEditContactDialogOpen(false)} disabled={editContactLoading}>Cancel</Button>
              <Button onClick={handleUpdateContact} variant="contained" disabled={editContactLoading}>
                {editContactLoading ? 'Updating...' : 'Update'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Call Comment Dialog */}
          <Dialog open={callCommentDialogOpen} onClose={handleCallCommentCancel} maxWidth="sm" fullWidth
            PaperProps={{
              sx: {
                borderRadius: 4,
                p: 0,
                boxShadow: '0 8px 40px rgba(34,197,94,0.18)',
                minWidth: { xs: 250, sm: 400 , md :600 },
              }
            }}
          >
            {/* <DialogTitle sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              fontWeight: 700,
              fontSize: '1.25rem',
              background: 'linear-gradient(135deg, #4ade80 0%, #22c55e 100%)',
              color: 'white',
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              py: 2,
              px: 3,
            }}>
              <CallIcon sx={{color: 'white', mr: 1 }} />
                  { !isSmallScreen?
                  'Call Comment':'Comment'}
              { isSmallScreen?
              (<Typography variant="subtitle2" sx={{ ml: 2, color: 'rgba(255,255,255,0.8)', fontWeight: 500, fontSize: '0.8rem' }}>
                Add or update ....
              </Typography>):
              (<Typography variant="subtitle2" sx={{ ml: 2, color: 'rgba(255,255,255,0.8)', fontWeight: 400, fontSize: '1rem' }}>
                Add or update a comment for this call
              </Typography>)
              }
            </DialogTitle> */}
            <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              background: 'linear-gradient(135deg, #4ade80 0%, #22c55e 100%)',
              color: 'white',
              borderTopLeftRadius: 3,
              borderTopRightRadius: 3,
              py: { xs: 1.5, sm: 2 },
              px: { xs: 2, sm: 3 },
            }}>
              <CallIcon sx={{ fontSize: { xs: 22, sm: 26 }, mr: 0.5 }} />

              {/* Title: "Comment" on mobile, "Call Comment" on bigger screens */}
              <Typography
                component="div"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: '1rem', sm: '1.25rem' },
                  display: 'flex',
                  alignItems: 'baseline',
                  gap: 0.5,
                }}
              >
                {/* xs text */}
                <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                  Comment
                </Box>
                {/* sm+ text */}
                <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                  Call Comment
                </Box>
              </Typography>

              {/* Subtitle: shorter hint on mobile, full sentence on bigger screens */}
              <Typography
                variant="subtitle2"
                sx={{
                  ml: 2,
                  color: 'rgba(255,255,255,0.8)',
                  fontWeight: { xs: 500, sm: 400 },
                  fontSize: { xs: '0.8rem', sm: '0.95rem' },
                  // you can hide it on very small screens if you want:
                  // display: { xs: 'none', sm: 'block' },
                }}
              >
                <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                  Add or update…
                </Box>
                <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                  Add or update a comment for this call
                </Box>
              </Typography>
            </DialogTitle>

            <DialogContent sx={{
              px: 3,
              py: 3,
              bgcolor: 'rgba(245, 247, 250, 0.98)',
              borderBottomLeftRadius: 16,
              borderBottomRightRadius: 16,
            }}>
              {/* dropdown created by aswin */} 
              <FormControl fullWidth margin="dense">
                <InputLabel sx={{ color: 'background.text' }}>Select Service</InputLabel>
                <Select
                  // value={selectedService}
                  value={callCommentService ?? ''}  
                  // onChange={handleServiceChange}
                  onChange={(e) => setCallCommentService(e.target.value || '')}
                  label="Select Service"
                  sx={{ color: 'background.text' }}
                >
                  {services.map((service) => (
                    <MenuItem key={service._id} value={service._id} sx={{ color: 'background.text' }}>
                      {service.TA_Service_Name}
                      {service.TA_Service_Amount && service.TA_Service_Amount > 0
                        ? ` (₹${service.TA_Service_Amount})`
                        : ' (Amount not set)'}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                // autoFocus
                margin="dense"
                label="Comment"
                type="text"
                fullWidth
                multiline
                minRows={3}
                maxRows={6}
                value={callCommentValue}
                onChange={e => setCallCommentValue(e.target.value)}
                onKeyDown={handleCallCommentKeyDown}
                disabled={callCommentLoading}
                sx={{
                  borderRadius: 2,
                  bgcolor: 'white',
                  boxShadow: '0 2px 8px rgba(34,197,94,0.06)',
                  fontSize: '1rem',
                  fontWeight: 500,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  }
                }}
              />
            </DialogContent>
            <DialogActions sx={{
              px: 3,
              pb: 2,
              bgcolor: 'rgba(245, 247, 250, 0.98)',
              borderBottomLeftRadius: 16,
              borderBottomRightRadius: 16,
            }}>
              <Button onClick={handleCallCommentCancel} sx={{ fontWeight: 600, borderRadius: 2 }}>Cancel</Button>
              <Button onClick={handleCallCommentSave} variant="contained" disabled={callCommentLoading || !callCommentValue.trim()} sx={{
                background: 'linear-gradient(135deg, #4ade80 0%, #22c55e 100%)',
                color: 'white',
                fontWeight: 700,
                borderRadius: 2,
                px: 3,
                py: 1,
                boxShadow: '0 2px 8px rgba(34,197,94,0.15)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                  boxShadow: '0 4px 16px rgba(34,197,94,0.22)',
                },
              }}>
                {callCommentLoading ? 'Saving...' : 'Save Comment'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Payment Modal */}
          <Dialog open={paymentModalOpen} onClose={() => setPaymentModalOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ color: 'background.text' }}>Create Payment</DialogTitle>
            <DialogContent>
              <FormControl fullWidth margin="dense">
                <InputLabel sx={{ color: 'background.text' }}>Select Service</InputLabel>
                <Select
                  value={selectedService}
                  onChange={handleServiceChange}
                  label="Select Service"
                  sx={{ color: 'background.text' }}
                >
                  {services.map((service) => (
                    <MenuItem key={service._id} value={service._id} sx={{ color: 'background.text' }}>
                      {service.TA_Service_Name}
                      {service.TA_Service_Amount && service.TA_Service_Amount > 0
                        ? ` (₹${service.TA_Service_Amount})`
                        : ' (Amount not set)'}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField margin="dense" label="Service Amount" type="number" fullWidth value={serviceAmount} onChange={handleAmountChange}
                InputProps={{ sx: { color: 'background.text', }, }}
                InputLabelProps={{ sx: { color: 'background.text', }, }}
                FormHelperTextProps={{ sx: { color: 'background.text', }, }}
                helperText={isCustomAmount ? "Custom amount entered" : "Predefined service amount"}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setPaymentModalOpen(false)}>Cancel</Button>
              <Button
                onClick={handleServicePaymentFromModal}
                variant="contained"
                color="success"
                disabled={!selectedService || !serviceAmount || parseFloat(serviceAmount) <= 0}
              >
                {/* Generate Payment Link */}
                Collect Online
              </Button>
              <Button
                variant="contained"
                color="error"
                disabled={!selectedService || !serviceAmount || parseFloat(serviceAmount) <= 0}
                onClick={handleOfflinePayment}
              >
                {/* Payment in cash */}
                Collect Offline
              </Button>
            </DialogActions>
          </Dialog>


          {/* Reminder modal */}
          <Dialog open={reminderDialogOpen} onClose={handleCloseReminder} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ color: 'background.text' }}>Set Reminder</DialogTitle>
            <DialogContent>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, bgcolor: '#e0e0e0', borderRadius: '5px', border: 'none', width: '100%', padding: 2, mb: 1 }}>
                <CustomDateAndTimePicker
                  date={reminderDate}
                  time={reminderTime}
                  bgcolor="#fff"
                  setDate={setReminderDate}
                  setTime={setReminderTime}
                // onValueChange={({date, time}) => {
                //   if (date) setReminderDate(date);
                //   if (time) setReminderTime(time);
                // }}
                />
              </Box>

              <FormControl fullWidth margin="dense">
                <InputLabel sx={{ color: 'background.text' }}>Select Service</InputLabel>
                <Select
                  value={selectedService}
                  onChange={handleServiceChange}
                  label="Select Service"
                  sx={{ color: 'background.text' }}
                >
                  {services.map((service) => (
                    <MenuItem key={service._id} value={service._id} sx={{ color: 'background.text' }}>
                      {service.TA_Service_Name}
                      {service.TA_Service_Amount && service.TA_Service_Amount > 0
                        ? ` (₹${service.TA_Service_Amount})`
                        : ' (Amount not set)'}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth margin="dense">
                <InputLabel id="assign-user-label" sx={{color:'background.text'}}>Assign Users</InputLabel>

                <Select
                  labelId="assign-user-label"
                  label="Assign Users"
                  multiple value={assignUserValue}
                  onChange={(e) => {
                    setAssignUserValue(e.target.value);
                    setAssignSearchQuery('');
                  }}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => {
                        const user = userList.find(u => String(u.id) === String(value));
                        if (!user) return null;
                        return (
                          <Chip
                            key={value}
                            label={user.name}
                            size="small"
                            onMouseDown={(e) => e.stopPropagation()}
                            onDelete={() => {
                              setAssignUserValue(prev => prev.filter(id => String(id) !== String(value)));
                              setAssignSearchQuery('');
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}
                  MenuProps={{
                    PaperProps: { sx: { maxHeight: 360, width: 320, pt: 0 } },
                    MenuListProps: {
                      disablePadding: true,
                      autoFocusItem: false,
                      onKeyDown: (e) => e.stopPropagation(), 
                    }
                  }}
                  sx={{ minWidth: 320 }}
                >

                  <ListSubheader disableSticky sx={{ pt: 1.5, pb: 1, px: 1.5 }}
                    onKeyDown={(e) => e.stopPropagation()}
                    onKeyUp={(e) => e.stopPropagation()}
                  >
                    <SearchInput
                      value={assignSearchQuery}
                      onChange={(e) => setAssignSearchQuery(e.target.value)}
                      onClear={() => setAssignSearchQuery('')}
                      placeholder="Search users."
                      sx={{ minWidth: '100%' }}
                    />
                  </ListSubheader>


                  {filteredUsers.length === 0 ? (
                    <MenuItem disabled>No matches</MenuItem>
                  ) : (
                    filteredUsers.map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        <Checkbox checked={assignUserValue.some(v => String(v) === String(user.id))} />
                        <ListItemText primary={user.name} secondary={user.email || user.phone} sx={{color:'background.text'}}/>
                      </MenuItem>
                    ))
                  )}
                </Select>

              </FormControl>

              <TextField
                autoFocus
                margin="dense"
                label="Message"
                type="text"
                fullWidth
                multiline
                minRows={3}
                maxRows={6}
                value={reminderComment}
                onChange={e => setReminderComment(e.target.value)}
                // onKeyDown={handleCallCommentKeyDown}
                disabled={callCommentLoading}
                sx={{
                  borderRadius: 2,
                  boxShadow: '0 2px 8px rgba(34,197,94,0.06)',
                  fontSize: '1rem',
                  fontWeight: 500,
                  color: 'background.text',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,

                    // text color for both input and textarea
                    '& .MuiInputBase-input': {
                      color: 'background.text'
                    },
                  },

                  // label color
                  '& .MuiInputLabel-root': {
                    color: 'background.text'
                  },

                  // label color when focused
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: 'primary'
                  }
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseReminder}>Cancel</Button>
              <Button onClick={handleSaveReminder} variant="contained" color="primary">Set Reminder</Button>
            </DialogActions>
          </Dialog>

          {
            customSnackbarOpen?.data?.type === 'message' && (
              <CustomSnackbar
                open={customSnackbarOpen?.open}
                onClose={handleSnackbarClose}
                severity={customSnackbarOpen?.severity || 'success'}
                title={customSnackbarOpen?.data?.name || ''}
                message={customSnackbarOpen?.data?.message || ''}
                // type={snackbar?.data?.type||''}
                type={'call'}
                autoHideDuration={customSnackbarOpen?.data?.duration || 5000}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              />
            )
          }

          {
            openReminderModal.open && (
              <Dialog onClose={() => setOpenReminderModal({ data: '', open: false })} open={openReminderModal.open}>
                {/* <DialogTitle>Set Reminder</DialogTitle> */}
                <DialogContent>
                  {/* {openReminderModal.data} */}
                  {
                    (()=>{
                      const ReminderComponent = openReminderModal.data.split('.');
                      const title = ReminderComponent[0];
                      const rest = ReminderComponent.slice(1).join('.');
                      // console.log('Aswin',ReminderComponent);
                      // console.log('Aswin',rest);
                      return (
                        <Box sx={{ p: 2 }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 700 , whiteSpace: 'pre-wrap'}}>{title}</Typography>
                          <br/>
                          <Typography variant="subtitle1" sx={{ fontWeight: 700,color:'gray' ,whiteSpace: 'pre-wrap',overflowWrap: 'break-word', }}>{rest}</Typography>
                        </Box>
                      );
                    })()
                  }
                </DialogContent>
              </Dialog>

              // <Dialog
              //   open={openReminderModal.open}
              //   onClose={() => setOpenReminderModal({ data: '', open: false })}
              //   maxWidth="sm"
              //   fullWidth
              // >
              //   <DialogContent>
              //     {(() => {
              //       const text = openReminderModal.data || '';

              //       const firstDotIndex = text.indexOf('.');

              //       const title =
              //         firstDotIndex !== -1
              //           ? text.slice(0, firstDotIndex + 1)
              //           : text;

              //       const body =
              //         firstDotIndex !== -1
              //           ? text.slice(firstDotIndex + 1).trim()
              //           : '';

              //       return (
              //         <Box sx={{ p: 2 }}>
              //           <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              //             {title}
              //           </Typography>

              //           {body && (
              //             <>
              //               <br />
              //               <Typography
              //                 variant="subtitle1"
              //                 sx={{ fontWeight: 500, color: 'gray' }}
              //               >
              //                 {body}
              //               </Typography>
              //             </>
              //           )}
              //         </Box>
              //       );
              //     })()}
              //   </DialogContent>
              // </Dialog>
            )
          }


            {/* Modal for the service template menu */}
            <Dialog open={serviceTemplateModalOpen} onClose={handleServiceModalClose} maxWidth="sm" fullWidth> 
              <DialogTitle sx={{ color: 'background.text' }}>
                Service Templates
              </DialogTitle>

              <DialogContent>
                <FormControl fullWidth margin="dense">
                  <InputLabel sx={{ color: 'background.text' }}>
                    Select up to 3 services
                  </InputLabel>
                  <Select
                    multiple
                    open={serviceSelectOpen}
                    onOpen={() => setServiceSelectOpen(true)}
                    onClose={() => setServiceSelectOpen(false)}
                    value={selectedServiceTemplates}
                    onChange={handleServiceTemplateChange}
                    label="Select up to 3 services"
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((id) => {
                          const svc = services.find((s) => s._id === id);
                          return (
                            <Chip
                              key={id}
                              label={svc?.TA_Service_Name || 'Service'}
                              size="small"
                            />
                          );
                        })}
                      </Box>
                    )}
                    sx={{ color: 'background.text' }}
                    MenuProps={{PaperProps: { sx: { maxHeight: 360 } },}}
                  >
                    {services.map((service) => (
                      <MenuItem key={service._id} value={service._id}>
                        <Checkbox checked={selectedServiceTemplates.indexOf(service._id) > -1} />
                        <ListItemText
                          primary={service.TA_Service_Name}
                          secondary={
                            service.TA_Service_Amount && service.TA_Service_Amount > 0
                              ? `₹${service.TA_Service_Amount}`
                              : 'Amount not set'
                          }
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </DialogContent>

              <DialogActions>
                <Button onClick={handleServiceModalClose}>Cancel</Button>
                <Button
                  onClick={handleSendServiceTemplate}
                  variant="contained"
                  disabled={!selectedServiceTemplates.length}
                >
                  Send Template
                </Button>
              </DialogActions>
            </Dialog>

            {/* Document Upload Modal */}
            <Dialog open={documentModalOpen} onClose={() => setDocumentModalOpen(false)} maxWidth="sm" fullWidth>
              <DialogTitle sx={{ color: 'background.text' }}>
                Upload Document
              </DialogTitle>
              <DialogContent>
                <Box sx={{ mt: 2, mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1, color: '#666' }}>
                    File: {documentFile?.name}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1, color: '#666' }}>
                    Size: {(documentFile?.size / 1024).toFixed(2)} KB
                  </Typography>
                </Box>
                {/* <FormControlLabel
                  control={
                    <Checkbox
                      checked={sendDocViaWhatsApp}
                      onChange={(e) => setSendDocViaWhatsApp(e.target.checked)}
                    />
                  }
                  label="Send via WhatsApp"
                  sx={{ color: 'background.text' }}
                /> */}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {
                  setDocumentModalOpen(false);
                  setDocumentFile(null);
                  setDocumentDescription('');
                  setSendDocViaWhatsApp(false);
                }}>
                  Cancel
                </Button>
                <Button
                  onClick={handleUploadDocument}
                  variant="contained"
                  disabled={!documentFile || documentLoading}
                  loading={documentLoading}
                >
                  {documentLoading ? 'Uploading...' : 'Upload & Send'}
                </Button>
              </DialogActions>
            </Dialog>

        </Box>
      );
    }

export default Interactions;